<template>
  <div id="deCreateNew">
    <div class="zwdesign-header">
      <div class="zwdesign-header--left logined">
        <span
          @click="handleJumpPath('/index')"
          style="
            color: #4934b2;
            font-size: 19px;
            font-weight: bold;
            cursor: pointer;
            float: left;
            margin: 8px 0 0 0;
          "
          class="iconfont"
        >
          <img class="logo" :src="designLogoUrl"
        /></span>
        <span
          @click="handleOldDesigner()"
          class="flex-col-ct cp"
          style="float: left; margin: 17px 0 0 10px;">
          <span class="f14 ml4" style="background: #4934b2;padding: 2px 4px;color: #ffffff;border-radius: 4px;">切换样式2</span>
        </span>
        <!-- <span
          @click="handleMyDesign()"
          class="ml60 flex-col-ct cp"
          style="float: left; margin: 17px 0 0 0"
          ><span class="iconfont iconImport"></span>
          <span class="f14 ml4">回到我的设计</span></span
        > -->
      </div>
      <div class="dividing-line"></div>
      <div class="zwdesign-header--center">
        <div class="left-toolbar">
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="撤销"
            placement="bottom"
            ><div @click.prevent="handleUndo">
              <span class="iconfont iconbackward icon"></span>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="重做"
            placement="bottom"
            ><div @click.prevent="handleRedo">
              <span class="iconfont iconforward icon"></span>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="清空"
            placement="bottom"
            ><div @click="handleClearCanvas">
              <span class="iconfont iconbrush icon"></span>
            </div>
          </el-tooltip>
          <el-popover
            :close-delay="0"
            @show="getPartData"
            width="399"
            trigger="hover"
            placement="bottom"
          >
            <div slot="reference">
              <div style="margin-top: 5px;padding:0 12px;cursor:pointer;">
                <i class="el-icon-document-copy"></i>
              </div>
            </div>
            <div class="save-record-cont">
              <div class="title-cont">
                <span class="title-text f14">请选择复制对象</span>
                <span style="float: right"
                  ><el-checkbox @change="handleCheckParts" v-model="checkAllParts"
                    >全选</el-checkbox
                  ></span
                >
              </div>
              <div class="content" style="padding: 8px 0px 8px 17px">
                <div class="flex data-cont">
                  <div
                    @click="handleSelectParts(record)"
                    v-for="record in parts"
                    :key="record.index"
                    class="part-item"
                    :class="{ active: config.toParts.includes(record.index) }"
                    v-if="record.id != config.activePart"
                  >
                    <img :src="record.thumb" :alt="record.title" /><span
                      class="product-id"
                      >{{ record.title }}</span
                    >
                  </div>
                </div>
                <div style="text-align: right">
                  <el-button @click="handleCopyObject" type="primary" size="small"
                    >确定</el-button
                  >
                </div>
              </div>
            </div>
          </el-popover>
          <!-- v-if="partMode == '1'" -->
          <el-popover
            :close-delay="0"
            width="220"
            trigger="hover"
            placement="bottom"
            popper-class="header-operate-popover"
          >
            <div slot="reference">
              <div class="item toolbar-item">
                <i class="el-icon-more"></i>
              </div>
            </div>
            <div>
              <div class="toolbar-item flex flex-row-between flex-col-ct"  @click="addGrid" :class="{ active: components.assistLine }">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconguidelines icon"></span>
                  <span class="toolbar-item-text">网格线</span>
                </div>
                <!-- <span class="shortcut-cont">(Ctrl + ')</span> -->
              </div>
              <!-- <div class="toolbar-item flex flex-row-between flex-col-ct" @click="addRuler" :class="{ active: components.ruler }">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconborder-aider icon"></span>
                  <span class="toolbar-item-text">标尺</span>
                </div>
              </div> -->
              <div class="toolbar-item flex flex-row-between flex-col-ct"  @click="addGuide" :class="{ active: components.guideLine }">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconguidelines icon"></span>
                  <span class="toolbar-item-text">辅助线</span>
                </div>
                <!-- <span class="shortcut-cont">(Ctrl + ')</span> -->
              </div>
              <div class="toolbar-item flex flex-row-between flex-col-ct" @click="handleFullScreen">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconfullscreen icon"></span>
                  <span class="toolbar-item-text">全屏</span>
                </div>
                <span class="shortcut-cont">(F11)</span>
              </div>
              <div class="toolbar-item flex flex-row-between flex-col-ct" @click="showPosPop = true">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconalign1 icon"></span>
                  <i class="el-icon-map-location"></i>
                  <span class="toolbar-item-text">位置与变换</span>
                </div>
              </div>
              <div class="toolbar-item flex flex-row-between flex-col-ct" @click="handleShowKeyConfig">
                <div class="flex flex-col-ct">
                  <span class="iconfont iconalign1 icon"></span>
                  <i class="el-icon-paperclip"></i>
                  <span class="toolbar-item-text">快捷键</span>
                </div>
              </div>
              <!-- <el-popover
                :close-delay="0"
                @show="getPartData"
                width="399"
                trigger="hover"
                placement="right"
              >
                <div slot="reference">
                  <div class="toolbar-item flex flex-row-between flex-col-ct">
                    <div class="flex flex-col-ct">
                      <span class="iconfont iconalign1 icon"></span>
                      <i class="el-icon-download"></i>
                      <span class="toolbar-item-text">下载</span>
                    </div>
                  </div>
                </div>
                <div class="save-record-cont">
                  <div class="title-cont">
                    <span class="title-text f14">请选择刀板</span>
                  </div>
                  <div class="content" style="padding: 8px 0px 8px 17px">
                    <div class="flex data-cont">
                      <div
                        @click="handleSelectPart(record)"
                        v-for="(record, index) in parts"
                        :key="index"
                        class="part-item"
                        :class="{ active: config.downloadPart == record.name }"
                      >
                        <img :src="record.src" :alt="record.i18n.zh" /><span
                          class="product-id"
                          >{{ record.i18n.zh }}</span
                        >
                      </div>
                    </div>
                    <div style="text-align: right">
                      <el-button
                        @click="handleDownloadPart"
                        type="primary"
                        size="small"
                        >下载</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-popover> -->
              <!-- <el-popover
                :close-delay="0"
                v-if="partMode == '1'"
                @show="getPartData"
                width="399"
                trigger="hover"
                placement="right"
              >
                <div slot="reference">
                  <div class="toolbar-item flex flex-row-between flex-col-ct">
                    <div class="flex flex-col-ct">
                      <span class="iconfont iconalign1 icon"></span>
                      <i class="el-icon-document-copy"></i>
                      <span class="toolbar-item-text">镜像</span>
                    </div>
                  </div>
                </div>
                <div class="save-record-cont">
                  <div class="title-cont">
                    <span class="title-text f14">请选择镜像方式</span>
                  </div>
                  <div class="content" style="padding: 8px 0px 8px 17px">
                    <div style="margin: 8px 0 16px 0">
                      <el-radio v-model="config.partConfig" label="1"
                        >左侧到右侧</el-radio
                      >
                      <el-radio v-model="config.partConfig" label="2"
                        >右侧到左侧</el-radio
                      >
                      <el-radio v-model="config.partConfig" label="3"
                        >刀版到刀版</el-radio
                      >
                    </div>
                    <div v-if="config.partConfig == '3'" class="flex data-cont">
                      <div
                        @click="handleSelectParts(record)"
                        v-for="(record, index) in parts"
                        :key="index"
                        class="part-item"
                        :class="{ active: config.toParts.includes(record.name) }"
                        v-if="record.name != config.activePart"
                      >
                        <img :src="record.src" :alt="record.i18n.zh" /><span
                          class="product-id"
                          >{{ record.i18n.zh }}</span
                        >
                      </div>
                    </div>
                    <div style="text-align: right">
                      <el-button @click="handleCopyPart" type="primary" size="small"
                        >确定</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-popover> -->
              <!-- <el-popover
                :close-delay="0"
                @show="getPartData"
                width="399"
                trigger="hover"
                placement="right"
              >
                <div slot="reference">
                  <div class="toolbar-item flex flex-row-between flex-col-ct">
                    <div class="flex flex-col-ct">
                      <span class="iconfont iconalign1 icon"></span>
                      <i class="el-icon-share"></i>
                      <span class="toolbar-item-text">复制</span>
                    </div>
                  </div>
                </div>
                <div class="save-record-cont">
                  <div class="title-cont">
                    <span class="title-text f14">请选择复制对象</span>
                    <span style="float: right"
                      ><el-checkbox @change="handleCheckParts" v-model="checkAllParts"
                        >全选</el-checkbox
                      ></span
                    >
                  </div>
                  <div class="content" style="padding: 8px 0px 8px 17px">
                    <div class="flex data-cont">
                      <div
                        @click="handleSelectParts(record)"
                        v-for="record in parts"
                        :key="record.index"
                        class="part-item"
                        :class="{ active: config.toParts.includes(record.index) }"
                        v-if="record.id != config.activePart"
                      >
                        <img :src="record.thumb" :alt="record.title" /><span
                          class="product-id"
                          >{{ record.title }}</span
                        >
                      </div>
                    </div>
                    <div style="text-align: right">
                      <el-button @click="handleCopyObject" type="primary" size="small"
                        >确定</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-popover> -->
            </div>
          </el-popover>
          <div class="dividing-line"></div>
          <!-- <div class="line"></div> -->
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="添加文字"
            placement="bottom"
            ><div @click="handleAddText" class="toolbar-item-operate flex flex-col-ct" :class="{ 'zw-disabled-copy': this.config.activePartLimitMode === 'image_only' }">
              <span class="iconfont icontext icon"></span>
              <span>添加文字</span>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="支持批量上传JPG、JPEG、PNG格式的图片，文件大小20M以内。请勿上传涉政、涉黄、侵权等违法行为，情节严重的将给予封号处理。"
            placement="bottom"
            ><div @click="uploadImg" class="toolbar-item-operate flex flex-col-ct" :class="{ 'zw-disabled-copy': this.config.activePartLimitMode === 'text_only' }">
              <span class="iconfont iconupload icon"></span>
              <span>上传图片</span>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item toolbar-item"
            effect="dark"
            content="仅支持我的定制-重新设计进入使用；元素限制可能导致部分元素不被保留。"
            placement="bottom"
          >
            <div @click="handleCopyDesign" class="toolbar-item-operate flex flex-col-ct" :class="{ 'zw-disabled-copy': !this.designDetail }">
              <i class="el-icon-document-copy" style="margin-right: 4px;"></i>
              <span>复制设计</span>
              <i class="el-icon-question" style="margin-left: 4px;"></i>
            </div>
          </el-tooltip>
          <input v-show="false" multiple ref="upload" type="file" @change="handleUpload" />
          <div class="dividing-line"></div>
          <!-- <div
            @click="pm1"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconfullscreen1"></i>
            <div class="toolbar-item-text mt5 f12">最大化</div>
          </div> -->
          <div
            @click="pm2"
            class="el-tooltip toolbar-item item"
            :class="{ 'nav_focus': config.maxSizeType == 'cutAll', 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconarrawsalt"></i>
            <div class="toolbar-item-text mt5 f12">铺满</div>
          </div>
          <div
            @click="handleSelectTile('jichu')"
            class="el-tooltip toolbar-item item"
            :class="{ 'nav_focus': config.isTile == 'jichu', 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconnum-c2"></i>
            <div class="toolbar-item-text mt5 f12">基础平铺</div>
          </div>
          <div
            @click="handleSelectTile('jingxiang')"
            class="el-tooltip toolbar-item item"
            :class="{ 'nav_focus': config.isTile == 'jingxiang', 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconnum-c3"></i>
            <div class="toolbar-item-text mt5 f12">镜像平铺</div>
          </div>
          <div
            @click="handleChangePos"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="el-icon-map-location" style="font-size:16px;line-height: 1.5;"></i>
            <div class="toolbar-item-text mt5 f12">位置与变换</div>
          </div>
          <div
            @click="handleFlipClockwise"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconrotate-right45" style="font-size:16px;line-height: 1.5;"></i>
            <div class="toolbar-item-text mt5 f12">顺旋转</div>
          </div>
          <div
            @click="handleFlipCounterclockwise"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconrotate-left45" style="font-size:16px;line-height: 1.5;"></i>
            <div class="toolbar-item-text mt5 f12">逆旋转</div>
          </div>
          <div
            @click="handleFlipX"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconzuoyoufanzhuan_huaban1" style="font-size:16px;line-height: 1.5;"></i>
            <div class="toolbar-item-text mt5 f12">水平翻转</div>
          </div>
          <div
            @click="handleFlipY"
            class="el-tooltip toolbar-item item"
            :class="{ 'zw-disabled': config.locked }"
            tabindex="0"
            style="cursor: pointer"
          >
            <i class="iconfont iconchuizhifanzhuan_huaban1" style="font-size:16px;line-height: 1.5;"></i>
            <div class="toolbar-item-text mt5 f12">垂直翻转</div>
          </div>
          <!-- <el-popover
            :close-delay="0"
            v-if="currentConfig.support_embroidery"
            @show="getEmbroideryPriceRange"
            width="399"
            trigger="hover"
            placement="bottom"
          >
            <div slot="reference">
              <span
                ><span class="el-popover__reference-wrapper"
                  ><div
                    class="save-record border-r"
                    style="margin: 3px 20px 0 23px; text-align: center"
                    aria-describedby="el-popover-7773"
                    tabindex="0"
                  >
                    <i
                      class="el-icon-money"
                      style="font-size: 17px; color: #495b6e"
                    ></i>
                    <div class="mt5" style="margin: 0px 0 0 0; font-size: 12px">
                      刺绣优惠
                    </div>
                  </div></span
                ></span
              >
            </div>
            <div class="save-record-cont">
              <div class="title-cont">
                <span class="title-text f14">刺绣优惠表格</span>
              </div>
              <div class="content" style="padding: 0px 0px 8px 17px">
                <el-slider
                  v-if="false"
                  :min="1"
                  :max="embroideryNumMax"
                  @input="handleChangeEmbroideryNum"
                  v-model="embroideryNum"
                ></el-slider>
                <div
                  v-if="false"
                  style="margin: 8px 0 0 0"
                  class="flex data-cont"
                >
                  刺绣优惠：{{ embroideryDiscountPrice }} 折
                </div>
                <el-table
                  id="outTable"
                  ref="table"
                  :data="detail.embroideryList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{ 'text-align': 'center' }"
                >
                  <el-table-column width="100px" label="序号" align="center">
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                    </template>
                  </el-table-column>
                  <el-table-column label="低数量" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.lowNum }}
                    </template>
                  </el-table-column>
                  <el-table-column label="高数量" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.highNum }}
                    </template>
                  </el-table-column>
                  <el-table-column label="折扣" align="center">
                    <template slot-scope="scope">
                      {{
                        scope.row.discount == 1
                          ? "无优惠"
                          : scope.row.discount * 10 + "折"
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-popover> -->

          <!-- <div
            v-if="false"
            class="el-tooltip toolbar-item item"
            aria-describedby="el-tooltip-7012"
            tabindex="0"
          >
            <span class="iconfont iconborder-outer icon"></span>
            <div class="toolbar-item-text mt5 f12">辅助线</div>
          </div> -->
          <!-- <div
            v-if="false"
            class="el-tooltip toolbar-item zw-disabled item hide-llp"
            aria-describedby="el-tooltip-4959"
            tabindex="0"
          >
            <span class="iconfont iconcrop icon"></span>
            <div class="toolbar-item-text mt5 f12">编组</div>
          </div> -->
        </div>
        <div class="right-toolbar"></div>
      </div>
      <div class="zwdesign-header--right logined">
        <!-- <el-switch
          style="display: block"
          @change="handleChangePartBySwitch"
          v-model="partMode"
          active-color="#13ce66"
          inactive-color="orange"
          active-text="印花"
          inactive-text="刺绣"
          active-value="1"
          inactive-value="2"
        >
        </el-switch> -->
        <div class="product-detail flex flex-row-center flex-col-ct mr16">
          <el-popover
            placement="top-start"
            width="400"
            trigger="hover"
            :close-delay="0"
            popper-class="header-zwdesign-product-popover"
          >
            <div slot="reference" class="flex flex-row-center flex-col-ct" tabindex="0">
              <div class="product-img mr12">
                <img :src="mainPic">
              </div>
              <!-- <div class="product-name mr12">{{ detail.proName }}</div> -->
            </div>
            <div class="product-name-container">
              <div class=" product-name-box">{{ detail.proName }}<span class="product-pId-box">（编号：{{detail.pId}}）</span></div>
              <div class="product-price-box">￥{{ detail.price }}</div>
              <div>
                <!-- 工艺 -->
                <el-tag effect="plain">{{ detail.prodTech }}</el-tag>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            :close-delay="0"
            popper-class="header-zwdesign-color-popover"
          >
            <div slot="reference" class="color-size flex flex-row-center flex-col-ct primary-color cp">
              <div class="flex flex-row-center flex-col-ct">
                <div class="color-item">
                  <a :style="{ background: dictMap['color'][currentAttr.color] }"></a>
                </div>
                <span class="color-item-desc">{{ currentAttr.color }} / {{ currentAttr.size }}</span>
              </div>
              <i class="arraw-icon iconfont iconarrow-down-bold"></i>
            </div>
            <div>
              <div class="sku-attr">
                <div class="sku-name" style="margin: 7px 32px 8px 0">
                  颜色
                </div>
                <div class="sku-detail">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="color"
                    placement="top"
                    v-for="(color, index) in colorList"
                    :key="index"
                  >
                    <a
                      :style="{ background: dictMap['color'][color] }"
                      :class="{ 'is-select': currentAttr.color === color }"
                      @click="handleSelectColor(color)"
                      class="sku-color"
                    ></a>
                  </el-tooltip>
                </div>
              </div>
              <div class="sku-attr">
                <div class="sku-name" style="margin: 7px 32px 8px 0">
                  尺码
                </div>
                <div
                  class="sku-detail"
                  style="margin: 4px 0 0 0"
                >
                  <a
                    :class="{ 'is-select': currentAttr.size === size }"
                    @click="handleSelectSize(size)"
                    class="sku-size"
                    v-for="(size, index) in sizeList"
                    :key="index"
                    >{{ size }}</a
                  >
                </div>
              </div>
            </div>
          </el-popover>
          <i class="el-tooltip iconfont icontoggle select-product-icon ml15 f20 cp" tabindex="0" @click="handleChooseProduct"></i>
        </div>
        <!-- 设计商品的关联组件不显示原保存按钮和记录等： -->
        <template v-if="!skuData">
          <el-popover
            @show="getDesignData"
            placement="top-start"
            width="390"
            trigger="hover"
            :close-delay="0"
            popper-class="save-record-cont-popper"
          >
            <div slot="reference">
              <span
                ><span class="el-popover__reference-wrapper"
                  ><div
                    class="save-record border-r"
                    aria-describedby="el-popover-7773"
                    tabindex="0"
                  >
                    <i class="iconfont iconfolder-open-fill"></i>
                    <div class="mt5">保存记录</div>
                  </div></span
                ></span
              >
            </div>
            <div class="save-record-cont">
              <div class="save-record-title-cont flex flex-col-start flex-row-between">
                <div class="save-record-title-cont-left">
                  <i class="el-icon-goods"></i>
                  <span>最近设计</span>
                </div>
                <div>
                  <div>前往<a class="design-pro" href="/select/selection/list?pageNum=1&pageSize=30" target="_blank">定制产品</a>页面下载效果图或刊登产品</div>
                  <div>前往<a class="design-pro" href="/select/selection/design" target="_blank">我的定制</a>页面查看我的设计</div>
                </div>
              </div>
              <div class="content">
                <div class="flex data-cont">
                  <div
                    @click="handleChangeProduct(record)"
                    v-for="(record, index) in designData"
                    :key="index"
                    class="product-item"
                  >
                    <img
                      :src="
                        record.coverPicUrl ? record.coverPicUrl : record.picUrl
                      "
                      :alt="record.designEngProName"
                    /><span
                      @click.stop="handleCopyText(record.designId)"
                      class="product-id"
                      >{{ record.designId }}</span
                    >
                  </div>
                </div>
                <el-pagination
                  style="text-align: center"
                  @current-change="handleCurrentChange"
                  :current-page="formDesign.pageNum"
                  layout="total, prev, next, jumper"
                  :total="totalDesign"
                  :page-size="6"
                >
                </el-pagination>
              </div>
            </div>
          </el-popover>
          <div class="dividing-line"></div>
          <div v-if="!isReplaceProduct" class="save-btn-content">
            <a
              @click="handleSaveDesign(false)"
              class="el-tooltip btn save-btn f14 item"
              aria-describedby="el-tooltip-1629"
              tabindex="0"
              :style="{
                backgroundColor: isSubmit
                  ? 'gray !important'
                  : '#4934b2 !important',
              }"
              :class="{'no_save': showDesign}"
              ><i class="iconfont iconsave-fill mr2"></i>保存 </a
            ><!---->
          </div>
          <div v-if="isReplaceProduct" class="save-btn-content">
            <a
              @click="handleShowDesignConfirm"
              class="el-tooltip btn save-btn f14 item"
              aria-describedby="el-tooltip-1629"
              tabindex="0"
              :style="{
                backgroundColor: isSubmit
                  ? 'gray !important'
                  : '#4934b2 !important',
              }"
              ><i class="iconfont iconsave-fill mr2"></i>替换产品 </a
            ><!---->
          </div>
          <el-dropdown @command="handleCommandMenu">
            <span class="el-dropdown-link">
              {{ user.nickName ? user.nickName : user.userName
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="console">控制台</el-dropdown-item>
              <el-dropdown-item command="image">我的图库</el-dropdown-item>
              <el-dropdown-item command="design">我的设计</el-dropdown-item>
              <el-dropdown-item command="list">定制产品</el-dropdown-item>
              <el-dropdown-item command="order">订单管理</el-dropdown-item>
              <el-dropdown-item command="cart">购物车</el-dropdown-item>
              <el-dropdown-item command="center">个人中心</el-dropdown-item>
              <el-dropdown-item command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
      <div class="addtocar-mask" style="display: none"></div>
      <!----><!----><!----><!---->
    </div>
    <div class="main">
      <div class="left-panel sidebar">
        <div class="toolbar">
          <ul>
            <!-- <li
              @click="handleChangeMenu(0)"
              class="tool-item"
              :class="currentMenu === 0 ? 'active' : ''"
            >
              <svg-icon
                class="menu-item"
                :icon-class="currentMenu === 0 ? 'product_fill' : 'product'"
              />
              <p>产品</p>
            </li> -->
            <li
              @click="handleChangeMenu(1)"
              class="tool-item"
              :class="currentMenu === 1 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'iconpicture-fill': currentMenu === 1,
                  iconpicture: currentMenu !== 1,
                }"
              />
              <p>图库</p>
            </li>
            <li
              @click="handleChangeMenu(2)"
              class="tool-item"
              :class="currentMenu === 2 ? 'active' : ''"
            >
              <svg-icon
                class="menu-item"
                :icon-class="currentMenu === 2 ? 'order_fill' : 'order'"
              />
              <p>背景</p>
            </li>
            <!-- <li
              @click="handleChangeMenu(3)"
              class="tool-item"
              :class="currentMenu === 3 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'icontext-fill': currentMenu === 3,
                  icontext: currentMenu !== 3,
                }"
              />
              <p>文字</p>
            </li> -->
            <!-- <li
              @click="handleChangeMenu(4)"
              class="tool-item"
              :class="currentMenu === 4 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'iconupload-fill': currentMenu === 4,
                  iconupload: currentMenu !== 4,
                }"
              />
              <p>上传</p>
            </li> -->
            <li
              @click="handleChangeMenu(5)"
              class="tool-item"
              :class="currentMenu === 5 ? 'active' : ''"
            >
              <i class="menu-item iconfont f24 iconview-layers"/>
              <p>图层</p>
            </li>
            <li
              @click="handleChangeMenu(6)"
              class="tool-item"
              :class="{'tab-disabled': !isShowEditTab, 'active': currentMenu === 6}"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'iconpicture-fill': currentMenu === 6,
                  iconpicture: currentMenu !== 6,
                }"
              />
              <p>编辑</p>
            </li>
          </ul>
          <ul>
            <li class="tool-item">
              <span
                ><span class="el-popover__reference-wrapper"
                  ><div
                    class="el-popover__reference"
                    aria-describedby="el-popover-9990"
                    tabindex="0"
                  >
                    <a target="_blank" class="help-link"
                      ><i class="iconfont f24 iconquestion icon"></i>
                      <p>帮助</p></a
                    >
                  </div></span
                ></span
              >
            </li>
          </ul>
        </div>
        <div class="content sidebar-cont">
          <!-- <div
            v-show="currentMenu === 0"
            class="product cont-top"
          >
            <div class="menu">
              <div
                @click="handleSelectProductMenu(0)"
                :class="{ 'menu-item-select': currentProductMenu === 0 }"
                class="menu-item"
              >
                印花产品
              </div>
              <div
                @click="handleSelectProductMenu(1)"
                :class="{ 'menu-item-select': currentProductMenu === 1 }"
                class="menu-item"
              >
                刺绣产品
              </div>
            </div>
            <ProductList
              ref="product1"
              saleType="1"
              :features="currentProductMenu"
              v-if="currentProduct === 0"
              @loaded="handleProductLoaded"
              @add="handleAddProduct"
            ></ProductList>
          </div> -->
          <div
            v-show="currentMenu === 1"
            class="material cont-top"
          >
            <div class="menu">
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(0)"
                :class="{ 'menu-item-select': currentMaterial === 0 }"
                class="menu-item"
              >
                印花图库
              </div>
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(1)"
                :class="{ 'menu-item-select': currentMaterial === 1 }"
                class="menu-item"
              >
                收费图库
              </div>
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(2)"
                :class="{ 'menu-item-select': currentMaterial === 2 }"
                class="menu-item"
              >
                共享图库
              </div>
              <div
                v-show="partMode == '2'"
                @click="handleSelectMaterial(3)"
                :class="{ 'menu-item-select': currentMaterial === 3 }"
                class="menu-item"
              >
                刺绣图片
              </div>
            </div>
            <ImageList
              ref="imageMe"
              @add="handleAddImage"
              mapSource="02"
              routeName="imageMe"
              v-if="currentMaterial === 0"
            ></ImageList>
            <ImageList
              ref="imageCommon"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageCommon"
              v-if="currentMaterial === 1"
            ></ImageList>
            <ImageList
              ref="imageShare"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageShare"
              v-if="currentMaterial === 2"
            ></ImageList>
            <ImageList
              ref="imageOrder"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageOrder"
              v-if="currentMaterial === 3"
            ></ImageList>
          </div>
          <div
            v-show="currentMenu === 2"
            class="background-text cont-top"
          > 
            <div class="picker-box">
              <ColorPicker
                class="menu-bg-color-picker-text"
                @change="handleChangeBgColor"
              ></ColorPicker>
            </div>
          </div>
          <div
            v-show="currentMenu === 3"
            class="upload-text cont-top"
          >
            <div class="add-text-btn" @click="handleAddText">
              <div style="display: inline-block">
                <span>添加</span>
                <span style="color: red">{{
                  partMode == "1" ? "印花" : "刺绣"
                }}</span
                >文字
              </div>
            </div>
          </div>
          <!-- <div
            v-show="currentMenu === 4"
            class="upload-image cont-top"
          >
            <div class="menu">
              <div
                v-if="partMode == '1'"
                @click="handleSelectUploadImage(0)"
                :class="{ 'menu-item-select': currentUploadImage === 0 }"
                class="menu-item"
              >
                印花图片
              </div>
              <div
                v-if="partMode == '2'"
                @click="handleSelectUploadImage(1)"
                :class="{ 'menu-item-select': currentUploadImage === 1 }"
                class="menu-item"
              >
                刺绣图片
              </div>
            </div>
            <div class="add-text-btn" @click="uploadImg">
              <span class="el-icon-plus mr3"></span>
              <span>上传图片（支持多张）</span>
            </div>
            <div class="remark-box">
              <div class="mb6">
                1.支持{{
                  partMode == "1" ? "批量" : ""
                }}上传JPG、JPEG、PNG格式的图片，文件大小20M以内
              </div>
              <div class="mb6">
                2.请勿上传涉政、涉黄、侵权等违法行为，情节严重的将给予封号处理
              </div>
              <div class="mb6">
                3.上传代表已阅读并同意
                <a>《法律声明》</a>
              </div>
            </div>
            <div class="upload-title">最近上传记录</div>

            <ImageList
              ref="uploadHistory"
              @add="handleAddImage"
              mapSource="01"
              type="uploadImage"
              :routeName="partMode == '1' ? 'imageMe' : 'imageOrder'"
            ></ImageList>

            <div v-show="false" class="upload-btn-box">
              <Button @click="uploadImg" />
              <input multiple ref="upload" type="file" @change="handleUpload" />
              <input
                ref="uploadEmbroideryImage"
                type="file"
                @change="handleUpload"
              />
            </div>
          </div> -->
          <div
            v-show="currentMenu === 5"
            class="pic-layer cont-top"
          >
            <div class="tit">
              <span class="txt">图层（{{ faceTitle }}）</span
              >
              <!-- <span class="close"
                ><i
                  @click="handleCloseLayer"
                  class="iconfont iconclose-bold"
                ></i
              ></span> -->
            </div>
            <div class="resize-area"></div>
            <div class="layer-box scroll-bar p10">
              <div
                v-for="(record, index) in customizeLayers"
                :key="index"
                role="group"
                aria-expanded="true"
                @click="handleSelectLayer(record, index)"
                class="el-tree-node__children"
                :class="{ active: activeLayer == index }"
              >
                <div
                  role="treeitem"
                  class="el-tree-node is-expanded is-current is-focusable"
                >
                  <div class="el-tree-node__content" style="padding-left: 18px">
                    <span
                      class="is-leaf el-tree-node__expand-icon el-icon-caret-right"
                    ></span
                    ><!----><!---->
                    <div class="custom-tree-node node-image">
                      <div class="name ccc">
                        <!----><!---->

                        <i
                          v-if="record.type == 'textbox'"
                          class="iconfont icontext imgbox"
                        ></i>
                        <div v-else class="imgbox">
                          <img :src="record.url" />
                        </div>
                        <label
                          :title="record.text"
                          v-if="record.type == 'textbox'"
                          class="ml5"
                          >{{ record.text ? record.text : "文本" }}</label
                        >
                        <label :title="record.name" v-else class="ml5">{{ record.name ? record.name : "图片" }}</label
                        ><!---->
                      </div>
                      <!---->
                      <div class="operates">
                        <span><!----><!----></span
                        ><span class="suspen">
                          <i
                            @click.stop="handleUp(record)"
                            class="el-icon-top mr8 up-icon"
                            :class="{ 'zw-disabled': record.locked }"
                          ></i>

                          <i
                            @click.stop="handleDown(record)"
                            class="el-icon-bottom mr8 down-icon"
                            :class="{ 'zw-disabled': record.locked }"
                          ></i>

                          <i
                            v-if="!record.locked"
                            @click.stop="handleLock(true, record.id)"
                            class="iconfont iconunlock-fill mr8 lock-icon"
                          ></i>
                          <i
                            v-if="record.locked"
                            @click.stop="handleLock(false, record.id)"
                            class="iconfont iconlock-fill mr8 lock-icon"
                          ></i>
                          <i
                            v-if="record.visible"
                            @click.stop="handleVisible(record, false)"
                            class="iconfont iconeye-open mr8 hidden-icon"
                          ></i>
                          <i
                            v-else
                            @click.stop="handleVisible(record, true)"
                            class="iconfont iconeye-close mr8 hidden-icon"
                          ></i>
                          <i
                            @click.stop="handleDelete(record)"
                            class="el-icon-delete mr8 delete-icon"
                            :class="{ 'zw-disabled': record.locked }"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    role="group"
                    aria-expanded="true"
                    class="el-tree-node__children"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="currentMenu === 6"
            class="edit-cont cont-top"
          >
            <div v-if="currentBox == 'image'" class="edit_cont_replace_image" @click="selectGallery">替换图片</div>
            <el-collapse v-model="activeQuery">
              <el-collapse-item name="1" v-if="currentBox == 'image'">
                <template slot="title">
                  <div class="pl_title">最大化</div>
                </template>
                <div class="flex flex-row-center edit-cont-item">
                  <div class="edit-cont-item-entrance" @click.prevent="pm1">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconfullscreen1"
                      :class="{ 'entrance_focus': config.maxSizeType == 'pageAll', 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">最大化设计</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="pm2">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconarrawsalt"
                      :class="{ 'entrance_focus': config.maxSizeType == 'cutAll', 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">铺满设计区域</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="pm3">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconcolum-height"
                      :class="{ 'entrance_focus': config.maxSizeType == 'cutHeight', 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">高度最大化</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="pm4">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconcolumn-width1"
                      :class="{ 'entrance_focus': config.maxSizeType == 'cutWidth', 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">宽度最大化</div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" v-if="currentBox == 'text'">
                <template slot="title">
                  <div class="pl_title">字体</div>
                </template>
                <div class="operation-item">
                  <div class="operation-item-content flex flex-col-ct">
                    <div class="zw-color-picker text-color ml3 mr3">
                      <div class="el-color-picker el-color-picker--small">
                        <!---->
                        <div
                          :class="{ 'zw-disabled': config.locked }"
                          @click="handleSetTextColor"
                          class="el-color-picker__trigger"
                        >
                          <span class="el-color-picker__color is-alpha hascolor"
                            ><span
                              class="el-color-picker__color-inner"
                              :style="{
                                backgroundColor: config.backgroundColorText,
                              }"
                            ></span
                            ><!----></span
                          ><span
                            class="el-color-picker__icon el-icon-arrow-down"
                            style=""
                          ></span>
                        </div>
                        <div
                          class="el-color-dropdown el-color-picker__panel zw-color-picker-pop"
                          style="display: none"
                        >
                          <div class="el-color-dropdown__main-wrapper">
                            <div
                              class="el-color-hue-slider is-vertical"
                              style="float: right"
                            >
                              <div class="el-color-hue-slider__bar"></div>
                              <div
                                class="el-color-hue-slider__thumb"
                                style="left: 0px; top: 0px"
                              ></div>
                            </div>
                            <div
                              class="el-color-svpanel"
                              style="background-color: rgb(255, 0, 0)"
                            >
                              <div class="el-color-svpanel__white"></div>
                              <div class="el-color-svpanel__black"></div>
                              <div
                                class="el-color-svpanel__cursor"
                                style="top: 0px; left: 0px"
                              >
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="el-color-alpha-slider"
                            style="display: none"
                          >
                            <div
                              class="el-color-alpha-slider__bar"
                              style="
                                background: linear-gradient(
                                  to right,
                                  rgba(0, 0, 0, 0) 0%,
                                  rgb(0, 0, 0) 100%
                                );
                              "
                            ></div>
                            <div
                              class="el-color-alpha-slider__thumb"
                              style="left: 0px; top: 0px"
                            ></div>
                          </div>
                          <div class="zw-color-predefine" style="display: flex">
                            <span
                              class="color-mark iconfont iconstraw"
                              style="
                                width: 24px;
                                height: 24px;
                                text-align: center;
                                font-size: 24px;
                                margin-left: 5px;
                                margin-top: 8px;
                                border-radius: 3px;
                                cursor: pointer;
                              "
                            ></span
                            ><span
                              class="iconfont icondisable-redline"
                              style="
                                width: 24px;
                                height: 24px;
                                text-align: center;
                                font-size: 24px;
                                margin-left: 5px;
                                margin-top: 8px;
                                border-radius: 3px;
                                color: red;
                                cursor: pointer;
                                border: 1px solid rgb(224, 229, 234);
                              "
                            ></span>
                            <div class="el-color-predefine">
                              <div class="el-color-predefine__colors">
                                <div
                                  class="el-color-predefine__color-selector selected"
                                >
                                  <div
                                    style="background-color: rgb(0, 0, 0)"
                                  ></div>
                                </div>
                                <div class="el-color-predefine__color-selector">
                                  <div
                                    style="background-color: rgb(255, 255, 255)"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="zw-color-predefine">
                            <div class="zw-color-predefine_panelName">预设</div>
                            <div class="zw-color-predefine__colors">
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(224, 32, 32)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(250, 100, 1)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(247, 181, 0)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(109, 212, 0)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(68, 215, 182)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(50, 197, 255)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(0, 145, 255)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(98, 54, 255)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(183, 41, 224)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(109, 114, 120)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(229, 229, 229)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(191, 191, 191)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(127, 127, 127)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(38, 38, 38)"></div>
                              </div>
                              <div
                                class="zw-color-predefine__color-selector selected"
                              >
                                <div style="background: rgb(0, 0, 0)"></div>
                              </div>
                              <div class="zw-color-predefine__color-selector">
                                <div style="background: rgb(255, 255, 255)"></div>
                              </div>
                            </div>
                          </div>
                          <div class="zw-color-custom">
                            <div
                              class="remove-tips"
                              style="
                                position: absolute;
                                left: 0px;
                                top: 0px;
                                z-index: 9999;
                                display: none;
                              "
                            >
                              删除
                            </div>
                            <div class="zw-color-custom_panelName">
                              自定义
                              <span
                                ><div
                                  role="tooltip"
                                  id="el-popover-5046"
                                  aria-hidden="true"
                                  class="el-popover el-popper zw-rest-prop"
                                  tabindex="0"
                                  style="width: 200px; display: none"
                                >
                                  <div class="el-popover__title">标题</div>
                                  <div
                                    style="
                                      padding: 5px 8px;
                                      font-size: 14px;
                                      line-height: 22px;
                                    "
                                  >
                                    自定义颜色最多添加24个，右击可删除
                                  </div>
                                </div>
                                <span class="el-popover__reference-wrapper"
                                  ><span
                                    class="iconfont iconinfo-circle el-popover__reference"
                                    aria-describedby="el-popover-5046"
                                    tabindex="0"
                                  ></span></span
                              ></span>
                            </div>
                            <div class="zw-color-custom__colors">
                              <div class="zw-color-custom__color-selector">
                                <div style="background: rgb(50, 137, 199)"></div>
                              </div>
                              <div class="zw-color-custom__color-add">
                                <span class="add-icon">+</span>
                              </div>
                            </div>
                          </div>
                          <div class="el-color-dropdown__btns">
                            <span class="el-color-dropdown__value"
                              ><div
                                class="el-input el-input--mini"
                                style="display: none"
                              >
                                <!----><input
                                  type="text"
                                  autocomplete="off"
                                  class="el-input__inner"
                                /><!----><!----><!----><!---->
                              </div>
                              <div class="el-input el-input--mini">
                                <!----><input
                                  type="text"
                                  autocomplete="off"
                                  class="el-input__inner"
                                /><!----><!----><!----><!---->
                              </div></span
                            ><button
                              type="button"
                              class="el-button el-color-dropdown__link-btn el-button--default el-button--mini"
                            >
                              <!----><!----><span>取消</span></button
                            ><button
                              type="button"
                              class="el-button el-color-dropdown__btn el-button--default el-button--mini is-plain"
                            >
                              <!----><!----><span>确定</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ColorPicker
                        v-if="components.colorPickerText"
                        class="bg-color-picker-text"
                        @change="handleChangeColorText"
                      ></ColorPicker>
                    </div>
                    <el-select
                      style="margin: -4px 0 0 9px; width: 186px;"
                      @change="handleChangeFontType"
                      v-model="config.fontFamily"
                      placeholder="字体"
                      size="small"
                      clearable
                      ref="fontFamily"
                      :disabled="config.locked"
                    >
                      <el-option
                        :style="{ fontFamily: item.name }"
                        v-for="item in fontList"
                        :key="item.name"
                        :label="item.chinaName"
                        :value="item.name"
                      >
                        <div>{{ item.chinaName }}</div>
                      </el-option>
                    </el-select>
                    <el-select
                      style="margin: -4px 0 0 9px; width: 78px"
                      @change="handleChangeFontSize"
                      v-model="config.fontSize"
                      placeholder="大小"
                      size="small"
                      clearable
                      :disabled="config.locked"
                    >
                      <el-option
                        v-for="item in fontSizeList"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="3" v-if="currentBox == 'text'">
                <template slot="title">
                  <div class="pl_title">间距行高</div>
                </template>
                <div class="operation-item flex flex-col-ct" style="margin: 16px 0">
                  <div class="operation-item-title" style="font-size: 14px">
                    间距
                  </div>
                  <div class="operation-item-content flex flex-col-ct" style="background: #ffffff">
                    <el-slider
                      :min="0"
                      :max="100"
                      @input="charSpacingChange"
                      style="width: 180px; margin: 0px 12px;"
                      v-model="config.charSpacing"
                      :disabled="config.locked"
                    ></el-slider>
                    <el-input-number
                      :class="{ 'zw-disabled': config.locked }"
                      class="zw-slide-input"
                      v-model="config.charSpacing"
                      width="90px"
                      style="width: 90px"
                      :min="0"
                      :max="100"
                      controls-position="right"
                      @change="charSpacingChange"
                      size="mini"
                    ></el-input-number>
                  </div>
                </div>
                <div class="operation-item flex flex-col-ct" style="margin: 16px 0">
                  <div class="operation-item-title" style="font-size: 14px">
                    行高
                  </div>
                  <div class="operation-item-content flex flex-col-ct" style="background: #ffffff">
                    <el-slider
                      :min="0"
                      :max="4"
                      :step="0.1"
                      @input="lineHeightChange"
                      style="width: 180px; margin: 0px 12px;"
                      v-model="config.lineHeight"
                      :disabled="config.locked"
                    ></el-slider>
                    <el-input-number
                      :class="{ 'zw-disabled': config.locked }"
                      class="zw-slide-input"
                      v-model="config.lineHeight"
                      width="90px"
                      style="width: 90px"
                      :min="0"
                      :max="4"
                      :step="0.1"
                      controls-position="right"
                      @change="lineHeightChange"
                      size="mini"
                    ></el-input-number>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="4">
                <template slot="title">
                  <div class="pl_title">旋转</div>
                </template>
                <div class="flex flex-row-center edit-cont-item">
                  <div class="edit-cont-item-entrance" @click.prevent="handleFlipX">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconzuoyoufanzhuan_huaban1"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">水平翻转</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleFlipY">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconchuizhifanzhuan_huaban1"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">垂直翻转</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleFlipCounterclockwise">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconrotate-left45"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">逆时针45度</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleFlipClockwise">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconrotate-right45"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">顺时针45度</div>
                  </div>
                </div>
                <div class="operation-item flex flex-col-ct" style="margin: 16px 0">
                  <div class="operation-item-title" style="font-size: 14px">
                    旋转
                  </div>
                  <div class="operation-item-content flex flex-col-ct" style="background: #ffffff">
                    <el-slider
                      :min="-180"
                      :max="180"
                      @input="angleChange"
                      style="width: 180px; margin: 0px 12px;"
                      v-model="config.rotate"
                      :disabled="config.locked"
                    ></el-slider>
                    <el-input-number
                      :class="{ 'zw-disabled': config.locked }"
                      class="zw-slide-input"
                      v-model="config.rotate"
                      width="90px"
                      style="width: 90px"
                      :min="-180"
                      :max="180"
                      controls-position="right"
                      @change="angleChange"
                      size="mini"
                    ></el-input-number>
                  </div>
                </div>
              </el-collapse-item>
              <!-- <el-collapse-item name="5" v-if="currentBox == 'text'">
                <template slot="title">
                  <div class="pl_title">文字描边</div>
                </template>
              </el-collapse-item> -->
              <el-collapse-item name="6" v-if="currentBox == 'text'">
                <template slot="title">
                  <div class="pl_title">对齐</div>
                </template>
                <div class="operation-item">
                  <div class="operation-item-content flex flex-col-ct">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="加粗"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked, 'select-icon': config.fontWeight == 'bold' }"
                        @click.prevent="handleAddWeight()"
                        class="edit-text-item-entrance mr23"
                        tabindex="0"
                        ><span class="iconfont iconfont-size1 icon"></span
                      ></span>
                    </el-tooltip>

                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="斜体"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked, 'select-icon': config.fontStyle == 'italic' }"
                        @click.prevent="handleAddFontStyle()"
                        class="edit-text-item-entrance mr23"
                        tabindex="0"
                        ><span class="iconfont iconfont-slanted icon"></span
                      ></span>
                    </el-tooltip>

                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="左对齐"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked,'select-icon': config.textAlign == 'left'}"
                        @click.prevent="handleSetTextAlign('left')"
                        class="edit-text-item-entrance mr23"
                        tabindex="0"
                        ><span class="iconfont iconalign-left1 icon"></span
                      ></span>
                    </el-tooltip>

                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="居中对齐"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked,'select-icon': config.textAlign == 'center' }"
                        @click.prevent="handleSetTextAlign('center')"
                        class="edit-text-item-entrance mr23"
                        tabindex="0"
                        ><span class="iconfont iconalign-center icon"></span
                      ></span>
                    </el-tooltip>

                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="右对齐"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked,'select-icon': config.textAlign == 'right' }"
                        @click.prevent="handleSetTextAlign('right')"
                        class="edit-text-item-entrance"
                        tabindex="0"
                        ><span class="iconfont iconalign-right icon"></span
                      ></span>
                    </el-tooltip>
                    <!-- <el-tooltip
                      class="item"
                      effect="dark"
                      content="两端对齐"
                      placement="top"
                    >
                      <span
                        :class="{ 'zw-disabled': config.locked }"
                        class="edit-text-item-entrance"
                        tabindex="0"
                        ><span class="iconfont iconalign-both icon"></span
                      ></span>
                    </el-tooltip> -->
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="7" v-if="currentBox == 'image'">
                <template slot="title">
                  <div class="pl_title">平铺</div>
                </template>
                <div class="flex flex-row-center edit-cont-item">
                  <div class="edit-cont-item-entrance" @click.prevent="handleSelectTile('jichu')">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconnum-c2 tile-button"
                      :class="{'entrance_focus': config.isTile == 'jichu','zw-disabled': config.locked}"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">基础平铺</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleSelectTile('jingxiang')">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconnum-c3 tile-button"
                      :class="{'entrance_focus': config.isTile == 'jingxiang','zw-disabled': config.locked}"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">镜像平铺</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleSelectTile('hengxiang')">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconnum-c4 tile-button"
                      :class="{'entrance_focus': config.isTile == 'hengxiang','zw-disabled': config.locked}"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">横向平铺</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleSelectTile('zongxiang')">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconnum-c5 tile-button"
                      :class="{'entrance_focus': config.isTile == 'zongxiang','zw-disabled': config.locked}"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">纵向平铺</div>
                  </div>
                </div>
                <div class="tileway-pop" v-if="config.showTileConfig">
                  <div class="zw-slide-pop">
                    <div class="zw-slide-pop-main">
                      <div class="slide">
                        <span>横向间距</span>
                        <el-slider
                          @change="handleTileGap"
                          style="width: 130px; margin: 0 0 0 16px"
                          v-model="config.gapWidth"
                          :disabled="config.locked"
                        ></el-slider>
                        <el-input v-model="config.gapWidth" size="mini" style="width:70px;margin-left:16px;"></el-input>
                      </div>
                      <div class="slide">
                        <span>纵向间距</span>
                        <el-slider
                          @change="handleTileGap"
                          style="width: 130px; margin: 0 0 0 16px"
                          v-model="config.gapHeight"
                          :disabled="config.locked"
                        ></el-slider>
                        <el-input v-model="config.gapHeight" size="mini" style="width:70px;margin-left:16px;"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="8">
                <template slot="title">
                  <div class="pl_title">图层</div>
                </template>
                <div class="flex flex-row-center edit-cont-item">
                  <div class="edit-cont-item-entrance" @click.prevent="handleZoomin">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-zoom-in"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">放大</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleZoomout">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-zoom-out"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">缩小</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleUp(currentObject)">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-top"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">上移一层</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleDown(currentObject)">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-bottom"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">下移一层</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleChangePos">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-map-location"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">位置与变换</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleCopy">
                    <span
                      class="edit-cont-item-entrance-icon iconfont iconfile-add"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">创建副本</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleShowOpacity">
                    <span
                      class="edit-cont-item-entrance-icon el-icon-view"
                      :class="{ 'zw-disabled': config.locked }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">透明</div>
                  </div>
                  <div class="edit-cont-item-entrance" @click.prevent="handleLockLayerSwitch">
                    <span
                      class="edit-cont-item-entrance-icon iconfont"
                      :class="{
                        'select-icon': config.locked, 
                        'iconlock': config.locked, 
                        'iconunlock': !config.locked, 
                      }"
                      tabindex="0"
                    ></span>
                    <div class="edit-cont-item-entrance-text">锁定/解锁</div>
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除（Delete/Backspace）"
                    placement="top"
                  >
                    <div 
                      class="edit-cont-item-entrance"
                      @click.prevent="handleDelete(currentObject)">
                      <span
                        class="edit-cont-item-entrance-icon iconfont icondelete"
                        :class="{ 'zw-disabled': config.locked }"
                        tabindex="0"
                      ></span>
                      <div class="edit-cont-item-entrance-text">删除</div>
                    </div>
                  </el-tooltip>
                </div>
                <div v-if="components.showOpacityConfig" class="opacity-pop">
                  <div class="zw-slide-pop" style="padding: 0 10px">
                    <div class="zw-slide-pop-main">
                      <div class="slide">
                        <span>透明</span>
                        <el-slider
                          @change="handleChangeOpacity"
                          style="width: calc(100% - 69px); margin: 0 0 0 16px"
                          v-model="config.opacity"
                          :disabled="config.locked"
                        ></el-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>

      <div class="simple-designer">
        <!-- <div style="position: absolute;z-index: 10;text-align: center;width: 100%;top: 14px;">温馨提醒：设计时，图片需完全覆盖黑色外框区域！</div> -->
        <!-- <div v-if="false" class="toolbar">
          <div class="operation-list">
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="上移一层"
                placement="top"
              >
                <i
                  @click="handleOper('bringUp')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-moveup"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="下移一层"
                placement="top"
              >
                <i
                  @click="handleOper('bringDown')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-movedown"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="水平居中"
                placement="top"
              >
                <i
                  @click="handleOper('centerX')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-center-horizontally"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="垂直居中"
                placement="top"
              >
                <i
                  @click="handleOper('centerY')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-verticallycentered"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="水平翻转"
                placement="top"
              >
                <i
                  @click="handleOper('flipX')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-horizontal-mirroring"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="垂直翻转"
                placement="top"
              >
                <i
                  @click="handleOper('flipY')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-vertical-mirror"
                ></i>
              </el-tooltip>
            </div>
            <div
              @click.prevent="performAction({ name: 'rotate', value: 45 })"
              class="base-icon-button"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="图案顺时针旋转45°"
                placement="top"
              >
                <i
                  @click="handleRotate(45)"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-clockwise-rotation"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案逆时针旋转45°"
                placement="top"
              >
                <i
                  @click="handleRotate(-45)"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-anticlockwise-rotation"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="复制图案"
                placement="top"
              >
                <i
                  @click="handleOper('copy')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-copy-pattern"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案宽度最大化"
                placement="top"
              >
                <i
                  @click="handleOper('maximizeByWidth')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximize-width"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案高度最大化"
                placement="top"
              >
                <i
                  @click="handleOper('maximizeByHeight')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximum-height"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案最大化设计"
                placement="top"
              >
                <i
                  @click="handleOper('maximize')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximizethepattern"
                ></i>
              </el-tooltip>
            </div>
          </div>
        </div> -->
        <div class="main-panel">
          <!-- <div id="designerDiv"></div> -->
          <iframe
            id="designer-frame" 
            ref="designerFrame"
            class="designer-iframe"
            :src="'/iframe-designer/index.html?customHeader=true&customSidebar=true&customRightBox=false&customRightBoxImageOps=true&customRightBoxTextOps=true&customRightBoxColor=true&customRightBoxSize=true&savePreview=false&realTimeRender='+realTimeRender"
            width="100%" 
            height="97%" 
            frameborder="0">
          </iframe>
        </div>
        <!-- <ul
          :style="{ height: partMode == '1' ? '198px' : '39px' }"
          class="bg-color-set"
          style="padding: 2px 0 0 0"
        >
          <li v-if="canChangeBackgroundColor && partMode == '1'" class="bg-color-pick">
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="背景色"
                  placement="right"
                >
                  <div
                    ref=""
                    @click="handleSetBackgroundColor"
                    class="el-color-picker__trigger"
                  >
                    <span class="el-color-picker__color is-alpha hascolor"
                      ><span
                        class="el-color-picker__color-inner"
                        :style="{ backgroundColor: config.backgroundColor }"
                      ></span
                      ></span
                    >
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="canChangeBackgroundColor && partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 0px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除背景色"
                  placement="right"
                >
                  <div
                    @click="handleDeleteBackground('')"
                    class="el-color-picker__trigger"
                  >
                    <span class="el-color-picker__color is-delete"
                      ><span
                        class="el-color-picker__color-inner"
                        style="background-color: transparent"
                      ></span
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 6px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="撤销"
                  placement="right"
                >
                  <div @click="handleUndo" class="el-color-picker__trigger">
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconbackward icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 6px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="重做"
                  placement="right"
                >
                  <div @click="handleRedo()" class="el-color-picker__trigger">
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconforward icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li class="bg-color-pick" style="margin-bottom: -5px">
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="清空"
                  placement="right"
                >
                  <div
                    @click="handleClearCanvas"
                    class="el-color-picker__trigger"
                  >
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconbrush icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
        </ul> -->
        <!-- <ul
          :style="{ paddingBottom: partMode == '1' ? '0px' : '0px' }"
          class="view-img"
        >
          <li
            @click="handleChangePart(record)"
            v-for="(record, index) in parts"
            :key="index"
            :style="{
              marginBottom:
                partMode == '1' && index != parts.length - 1 ? '12px' : '23px',
            }"
            v-if="
              (!record.support_embroidery && partMode == '1') ||
                (record.support_embroidery && partMode == '2')
            "
            :class="{ active: record.name == config.activePart }"
          >
            <el-tooltip
              class="item tab_per_pro"
              effect="dark"
              :content="record.i18n.zh"
              placement="left"
              :key="index"
            >
              <img :src="record.src" />
            </el-tooltip>
            <div
              v-if="partMode == '2'"
              style="
                margin: 4px 0 0 0;
                text-align: center;
                position: absolute;
                top: 56px;
                left: 8px;
              "
            >
              + ¥ {{ record.embroidery_params.CNY }}
            </div>
          </li>
          <li
            v-if="partMode == '2' && embroideryPrice > 0"
            style="
              background: transparent;
              text-align: center;
              line-height: 25px;
              height: 25px;
              padding: 0;
              margin-bottom: 0;
              font-weight: bold;
            "
          >
            合计:¥<span style="color: red">{{ embroideryPrice }}</span>
          </li>
        </ul> -->
        <!-- <ColorPicker
          v-if="components.colorPicker"
          class="bg-color-picker-"
          @change="handleChangeColor"
          :currentColor="config.backgroundColor"
        ></ColorPicker> -->
        <!-- <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-left"
        >
          <p class="">印刷品质 (优秀)</p>
          <p
            v-if="currentPart && !currentPart.support_embroidery"
            style="color: rgba(0, 0, 0, 0.45)"
          >
            推荐尺寸 (<span style="color: red"
              >{{ currentPart.psd_params.width }} *
              {{ currentPart.psd_params.height }}</span
            >)
          </p>
          <p
            v-if="currentPart && currentPart.support_embroidery"
            style="color: rgba(0, 0, 0, 0.45)"
          >
            推荐尺寸 (<span style="color: red"
              >{{ currentPart.embroidery_params.width }} *
              {{ currentPart.embroidery_params.height }}</span
            >)
          </p>
        </div> -->
        <!-- <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-center"
        >
          <p v-if="false">{{ detail.proName }}</p>
          <span>{{ partName }}</span>
        </div> -->
        <!-- <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-right"
        >
          <div @click="handleRecoverCanvasSize" class="maximize">
            <i class="iconfont iconcanvas-recovery"></i>
          </div>
          <i @click="handleMinusCanvasSize" class="iconfont iconzoom-out"></i>
          <div class="slider">
            <div
              role="slider"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-orientation="horizontal"
              class="el-slider"
              aria-valuetext="0"
              aria-label="slider between 0 and 100"
            >
              <el-slider
                @input="handleChangeCanvasSize"
                v-model="config.canvasSize"
              ></el-slider>
            </div>
          </div>
          <i @click="handleAddCanvasSize" class="iconfont iconzoom-in"></i>
        </div> -->
      </div>
      <!-- <el-tabs
        v-model="activeView"
        @tab-click="handleChangeView"
        class="el-tabs"
        tab-position="left"
        style="height: 90px;position:absolute;right: 325px;top: 0px;"
      >
        <el-tab-pane name="2D" label="2D"></el-tab-pane>
        <el-tab-pane name="3D" label="3D"></el-tab-pane>
      </el-tabs> -->

      <!-- <div class="product-detail-box right-panel">
        <el-popover
          @show="getDesignData"
          placement="top-start"
          width="390"
          trigger="hover"
          :close-delay="0"
          popper-class="save-record-cont-popper"
        >
          <div slot="reference">
            <div class="save-record-cont flex flex-row-end flex-col-ct"> 保存记录/下载刊登 <i class="iconfont arrow iconarrow-down-bold"></i></div>
          </div>
          <div class="save-record-cont">
            <div class="save-record-title-cont flex flex-col-ct flex-row-between">
              <div class="save-record-title-cont-left">
                <i class="el-icon-goods"></i>
                <span>最近设计</span>
              </div>
              <div>前往<a class="design-pro" href="/select/selection/list?pageNum=1&pageSize=30" target="_blank">定制产品</a>页面下载效果图或刊登产品</div>
            </div>
            <div class="content">
              <div class="flex data-cont">
                <div
                  @click="handleChangeProduct(record)"
                  v-for="(record, index) in designData"
                  :key="index"
                  class="product-item"
                >
                  <img
                    :src="
                      record.coverPicUrl ? record.coverPicUrl : record.picUrl
                    "
                    :alt="record.designEngProName"
                  /><span
                    @click.stop="handleCopyText(record.designId)"
                    class="product-id"
                    >{{ record.designId }}</span
                  >
                </div>
              </div>
              <el-pagination
                style="text-align: center"
                @current-change="handleCurrentChange"
                :current-page="formDesign.pageNum"
                layout="total, prev, next, jumper"
                :total="totalDesign"
                :page-size="6"
              >
              </el-pagination>
            </div>
          </div>
        </el-popover>
        <div class="design-effect">
          <div class="big-img-cont">
            <div class="type-btn-group">
              <div 
                class="btn-item btn-3d" 
                :class="{'active': activeView == '3D'}"
                @click="handleChangeView('3D')"
              >3D</div>
              <div 
                class="btn-item btn-2d" 
                :class="{'active': activeView == '2D'}"
                @click="handleChangeView('2D')"
              >2D</div>
            </div>
            <div class="preview-btn" v-show="activeView == '2D'" @click="handleShowPreview">
              <i class="iconfont iconzoom-in">预览</i>
            </div>
            <canvas
              v-show="activeView == '3D'"
              id="preview"
              :width="700"
              :height="700"
              style="width: 300px; height: 300px;"
            />
            <div v-show="activeView == '2D'">
              <el-image 
                v-for="(item, index) in previewsData" 
                :key="index"
                class="map-preview-img"
                :class="{'active': previewIndex == index}"
                :src="item.preview_url"
                style="width: 300px; height: 300px;" 
              ></el-image>
            </div>
          </div>
          <div v-show="activeView == '2D'" class="small-img-list-cont">
            <div class="flex flex-wrap">
              <div 
                v-for="(item, index) in previewsData" 
                :key="index"
                class="small-img-item"
                :class="{'active': index == previewIndex}"
                @click="selcetPreview(index)"
              >
                <el-image
                  :src="item.preview_url"
                  style="width: 66px; height: 66px;" 
                ></el-image>
                <div class="tips-mask">效果图{{index+1}}</div>
              </div>
            </div>
          </div>
          <pic-zoom
            v-show="activeView == '2D'"
            @click.native="handleShowPreview"
            id="pic-zoom"
            style="
              width: 300px;
              height: 300px;
              position: absolute;
              z-index: 100;
              border-radius: 22px;
              border: 1px solid #e5e6eb;
            "
            :url="previewImageUrl"
            :scale="3"
          ></pic-zoom>
        </div>
      </div> -->
    </div>
    <!-- <el-dialog
      :close-on-click-modal="false"
      title="图片上传"
      :visible.sync="uploadImageVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="uploadImageForm"
        label-width="80px"
        :rules="rules"
        style="margin: 15px"
      >
        <el-form-item label="图片分类：" prop="delivery">
          <TreeSelect
            :props="{
              value: 'id',
              label: 'label',
              children: 'children',
            }"
            :options="treeData"
            v-model="uploadImageForm.imageType"
            ref="childSelTree"
            style="width: 50%; margin-right: 10px"
            @getValue="getTreeNodeId"
          ></TreeSelect>
        </el-form-item>
        <el-form-item label="选择图片：" prop="delivery">
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadImageVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog
      :close-on-click-modal="false"
      title="效果图预览"
      :visible.sync="previewImagesVisible"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="getSrc(productImage)" />
            </el-carousel-item>
          </el-carousel>
          <div class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of colorList"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="getSrc(productImage)" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showSaveConfirm" width="30%">
      <span>请确认是否替换原订单的产品</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showSaveConfirm = false"
          >取 消</el-button
        >
        <el-button
          v-if="originPId == detail.pId"
          size="small"
          type="primary"
          @click="handleSaveDesign('1')"
          >替换并转换</el-button
        >
        <el-button size="small" type="primary" @click="handleSaveDesign('0')"
          >替换</el-button
        >
      </span>
    </el-dialog>

    <!-- <el-dialog
      :close-on-click-modal="false"
      title="添加刺绣文本"
      :visible.sync="uploadTextVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="textForm"
        label-width="100px"
        :rules="rulesText"
        style="margin: 15px"
      >
        <el-form-item label="添加文字：" prop="text">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入英文，暂不支持中文"
            v-model="textForm.text"
            @input="limitLines"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="字号：" prop="delivery">
          <el-checkbox size="small" v-model="textForm.bold">加粗</el-checkbox>
          <el-checkbox size="small" v-model="textForm.italic">斜体</el-checkbox>
        </el-form-item>
        <el-form-item label="字体工艺：" prop="font_type">
          <el-radio-group
            @change="handleChangeEmbroideryFontType"
            v-model="textForm.font_type"
          >
            <el-radio label="2d">平面绣</el-radio>
            <el-radio label="3d">立体绣</el-radio>
          </el-radio-group>
          <div>
            <el-image
              style="width: 100px; height: 100px"
              :src="textForm.font_type == '2d' ? image2D : image3D"
              :preview-src-list="
                textForm.font_type == '2d' ? [image2D] : [image3D]
              "
            >
            </el-image>
          </div>
        </el-form-item>
        <el-form-item label="字体：" prop="font_family">
          <el-select
            size="small"
            v-model="textForm.font_family"
            placeholder="请选择"
          >
            <el-option
              v-for="item in embroideryFontList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色：" prop="delivery">
          <div slot="label">
            颜色：<br /><el-button @click="handleCopyColor" type="text"
              >复制颜色</el-button
            >
          </div>
          <ul class="background-color-content">
            <el-tooltip
              v-for="(color, idx) in textColorList"
              :key="idx"
              effect="dark"
              :content="color.hex"
              placement="top"
            >
              <li
                class="background-color-item"
                :style="{ background: color.hex }"
                @click="selectTextColor(color, idx)"
                style="position: relative"
              >
                <i
                  class="el-icon-check"
                  style="position: absolute; top: 5px; left: 5px"
                  :style="{
                    color: textForm.color_name == 'white' ? 'black' : '#ffffff',
                  }"
                  v-if="textForm.color_name === color.name"
                ></i>
              </li>
            </el-tooltip>
          </ul>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadTextVisible = false"
          >取 消</el-button
        >
        <el-button @click="handleAddEmbroideryText" size="small" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog> -->

    <!-- <el-dialog
      :close-on-click-modal="false"
      title="设置刺绣颜色"
      :visible.sync="setColorVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="imageForm"
        label-width="100px"
        style="margin: 15px"
      >
        <el-form-item label="颜色：" prop="delivery">
          <div slot="label">
            颜色：<br /><el-button @click="handleCopyColor" type="text"
              >复制颜色</el-button
            >
          </div>
          <ul class="background-color-content">
            <el-tooltip
              class="item"
              effect="dark"
              :content="color.hex"
              placement="top"
              v-for="(color, idx) in textColorList"
              :key="idx"
            >
              <li
                class="background-color-item"
                :style="{ background: color.hex }"
                @click="selectImageColor(color, idx)"
                style="position: relative"
              >
                <i
                  class="el-icon-check"
                  style="position: absolute; top: 5px; left: 5px"
                  :style="{
                    color:
                      imageForm.color_name == 'white' ? 'black' : '#ffffff',
                  }"
                  v-if="imageForm.color_name === color.name"
                ></i>
              </li>
            </el-tooltip>
          </ul>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="setColorVisible = false"
          >取 消</el-button
        >
        <el-button
          @click="handleAddEmbroideryImageColor"
          size="small"
          type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog> -->
    <el-dialog
      :close-on-click-modal="false"
      title="快捷键说明"
      :visible.sync="setKeyVisible"
      width="700px"
    >
      <div class="shortcut-box scroll-bar">
        <div class="panel-box">
          <div class="panel-tit mb10">常规操作</div>
          <div class="panel-cont">
            <div
              v-for="record in keyConfig"
              :key="record.event"
              class="panel-item"
            >
              <div>
                <div class="name">{{ record.name }}</div>
                <div v-if="!setKey || !record.canEdit" class="keycode">
                  <span
                    v-for="key in record.keys"
                    :key="key"
                    :class="key == '+' ? 'combine' : 'key'"
                    >{{ key }}</span
                  >
                </div>
                <div v-if="setKey && record.canEdit" class="keycode">
                  <div class="input-box">
                    <input
                      @click="keyBox = record.event"
                      readonly
                      v-model="record.text"
                      placeholder="请按键盘进行设置"
                    /><i
                      @click="record.text = ''"
                      class="iconfont iconclose-fill icon clear"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button
          style="float:left"
          @click="handleRestoreKeyConfig"
          size="small"
          >恢复默认配置</el-button
        >
        <el-button v-if="setKey" size="small" @click="handleCancelSetKey"
          >取 消</el-button
        >
        <el-button
          v-if="setKey"
          @click="handleSaveKey"
          size="small"
          type="primary"
          >保 存</el-button
        >
        <el-button
          v-if="!setKey"
          @click="setKey = true"
          size="small"
          type="primary"
          >自定义快捷键</el-button
        >
      </div> -->
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="设置坐标"
      :visible.sync="setPosVisible"
      width="600px"
    >
      <el-form ref="pos_form" class="pos_form" :model="posForm" label-width="100px">
        <el-form-item label="名称：" prop="posSort">
          <el-radio-group v-model="posForm.posSort" size="small">
            <el-radio label="1">坐标1</el-radio>
            <el-radio label="2">坐标2</el-radio>
            <el-radio label="3">坐标3</el-radio>
            <el-radio label="4">坐标4</el-radio>
            <el-radio label="5">坐标5</el-radio>
            <el-radio label="6">坐标6</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注：" prop="posLabel">
          <el-input 
            style="width:240px;" 
            size="small" 
            v-model="posForm.posLabel" 
            maxlength="10" 
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="setPosVisible = false"
          >取 消</el-button
        >
        <el-button
          @click="handlePos"
          size="small"
          type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 位置与变换 -->
    <div class="position-operate-pop" v-if="showPosPop" v-drag="{ handle: '.tit' }">
      <div class="tit">
          <div class="flex flex-col-center">
              <el-tooltip
                  class="item toolbar-item"
                  effect="dark"
                  content="拖拽可调节窗口位置"
                  placement="top"
                  >
                  <div><i class="iconfont icondrag-left"></i>位置与变换</div>
              </el-tooltip>
          </div>
          <a class="btn mr5" @click="showPosPop = false"><i class="iconfont iconclose-bold"></i></a>
      </div>
      <div class="container">
          <div class="change-box">
              <div class="flex flex-row-between mb8">
                  <div class="zw-unit-input">
                      <div class="zw-unit-input-tit">X</div>
                      <el-input-number
                        @change="handleChangeLayer"
                        style="width: 100px;"
                        type="text"
                        v-model="layerInfo.x"
                        size="small"
                        controls-position="right"
                        :disabled="config.locked || !currentObject.id"
                      ></el-input-number>
                  </div>
                  <div class="zw-unit-input">
                      <div class="zw-unit-input-tit">Y</div>
                      <el-input-number
                        @change="handleChangeLayer"
                        style="width: 100px;"
                        type="text"
                        v-model="layerInfo.y"
                        size="small"
                        controls-position="right"
                        :disabled="config.locked || !currentObject.id"
                      ></el-input-number>
                  </div>
              </div>
              <div class="flex flex-row-between">
                  <div class="zw-unit-input">
                      <div class="zw-unit-input-tit">宽</div>
                      <el-input-number
                        @change="handleChangeLayer"
                        style="width: 100px;"
                        type="text"
                        v-model="layerInfo.w"
                        size="small"
                        controls-position="right"
                        :disabled="config.locked || !currentObject.id"
                      ></el-input-number>
                  </div>
                  <div class="zw-unit-input">
                      <div class="zw-unit-input-tit">高</div>
                      <el-input-number
                        @change="handleChangeLayer"
                        style="width: 100px;"
                        type="text"
                        v-model="layerInfo.h"
                        size="small"
                        controls-position="right"
                        :disabled="config.locked || !currentObject.id"
                      ></el-input-number>
                  </div>
              </div>
              <div class="label mb10 mt20 flex flex-col-ct">常用坐标：<el-button size="mini" type="primary" @click="setPosVisible = true" :disabled="config.locked || !currentObject.id">设置坐标</el-button></div>
              <div class="zw-position flex flex-wrap">
                <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(false)" type="primary" plain size="mini">上次坐标</el-button>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[0]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(1)" type="primary" plain size="mini" >坐标1</el-button>
                </el-tooltip>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[1]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(2)" type="primary" plain size="mini" >坐标2</el-button>
                </el-tooltip>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[2]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(3)" type="primary" plain size="mini" >坐标3</el-button>
                </el-tooltip>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[3]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(4)" type="primary" plain size="mini" >坐标4</el-button>
                </el-tooltip>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[4]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(5)" type="primary" plain size="mini" >坐标5</el-button>
                </el-tooltip>
                <el-tooltip
                  effect="light"
                  :content="layerPosInfoShow[5]?.label"
                  placement="top"
                  >
                  <el-button :disabled="config.locked || !currentObject.id" @click="updatePosition(6)" type="primary" plain size="mini" >坐标6</el-button>
                </el-tooltip>
              </div>
          </div>
      </div>
    </div>

    <!-- 设置保存颜色 -->
    <el-dialog
      :close-on-click-modal="false"
      title="选择颜色"
      :visible.sync="showSaveColorConfirm"
      width="800px"
    >
      <div class="save_color_form">
        <div class="save_title">请选择要保存的颜色（<span>{{ checkedPics.length }}</span>/{{ saveColorConfirmData.length }}）</div>
        <el-checkbox
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
          v-model="isCheckColor"
          >全选（保存较少的颜色，可以提高保存速度）</el-checkbox
        >
        <el-checkbox-group 
          v-model="checkedPics" 
          @change="handleCheckedPicChange" 
          class="pic_box">
          <el-checkbox 
            v-for="(item, index) in saveColorConfirmData" 
            :label="item" 
            :key="index" 
            class="per_pic">
              <img :src="item.mainPic.picUrl" alt="产品轮播图">
              <div class="properVal">{{ item.properVal.split(':')[0] }}</div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showSaveColorConfirm = false"
          >取 消</el-button
        >
        <el-button
          @click="handleSaveColorConfirm"
          size="small"
          type="primary"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择产品 -->
    <SelectProductDialog
      v-model="productDialogVisible"
      @update="handleProduct"
    ></SelectProductDialog>

    <!-- 选择图库图片 -->
    <GalleryDialog :visible="galleryVisible" @onClose="getResult"></GalleryDialog>
  </div>
</template>
<script>
import GalleryDialog from '@/views/ai/pic/compoents/GalleryDialog'
import Breadcrumb from "@/components/common/Breadcrumb"
import { setHotKey, getUserProfile } from "@/api/system/user"
import { addDesign, getDesign } from "@/api/customProduct/design"
import ImageList from "./components/ImageList.vue"
import ProductList from "./components/ProductList.vue"
import TreeSelect from "@/components/common/treeSelect"
// import {loadBasicData} from '@/api/customProduct/custom'
import { mapGetters } from "vuex"
import store from "@/store"
import axios from "axios"
import ColorPicker from "@/components/colorPicker/index.vue"
import SelectProductDialog from '@/views/customProduct/online/components/SelectProductDialog'
import {
  getProductList,
  getProductDetail,
  getEmbroideryPrice,
} from "@/api/customProduct/product"
import logoSite from "@/assets/images/logo_blue.png"
// import "simple-designer"
import { uploadFile } from "./upload.js"
import { uploadFileNew } from "./uploadNew.js"
import { addImgMap, deleteImgMap } from "@/api/customProduct/imageStore"
import { listDesign } from "@/api/customProduct/design"
import { Base64 } from "js-base64"
import { addUserDesign, addUserDesignNew } from "@/api/customProduct/design"
import { matchSku, editSku, setOrderRemark } from "@/api/order/all"
import hotkeys from "hotkeys-js"
import { getMapInfo } from "@/api/map/map"
import Ruler from "./components/ruler.js"
import PicZoom from "vue-piczoom"
import image2D from "@/assets/images/index/2d.jpg"
import image3D from "@/assets/images/index/3d.jpg"
import Cookies from "js-cookie"
import { getConfigKey } from "@/api/system/config"
import designCacheDB from '@/utils/designCacheDB'

export default {
  name: "create",
  components: {
    GalleryDialog,
    Breadcrumb,
    ImageList,
    TreeSelect,
    ProductList,
    ColorPicker,
    PicZoom,
    SelectProductDialog,
  },
  data() {
    return {
      previewImageUrl: "",
      keyBox: "",
      image2D: image2D,
      image3D: image3D,
      addImagVisible: false, //添加素材弹框开关
      imageList: [], //素材
      designer: null,
      fileList: [],
      currentRow: null,
      skuList: [],
      basicData: {},
      value: [],
      currentMenu: 1,
      menuList: ["产品", "主题", "背景", "图片"],
      currentProduct: 0,
      currentMaterial: 0,
      currentBackground: 0,
      currentImage: 0,
      uploadImageVisible: false,
      uploadImageForm: {},
      treeData: [],
      rules: [],
      rulesText: {},
      productImageList: [],
      currentColor: "",
      currentSize: "",
      previewResult: null,
      previewImagesVisible: false,
      activeCarousel: 0,
      form: {
        pId: "1",
        printsParams: "",
        skuList: [],
        mapIds: ["1", "2"],
        canvasJson: "",
        designId: "",
      },
      embroideryNum: 1,
      textForm: {
        text: "",
        font_family: "Block2",
        color_name: "black",
        bold: false,
        italic: false,
        font_type: "2d",
      },
      imageForm: {
        color_name: "white",
        color_index: 1,
      },
      layerInfo: {
        x: "",
        y: "",
        w: "",
        h: "",
      },
      price: 0,
      proName: "",
      basicId: "",
      isFirstLoading: true,
      previewList: [],
      detail: {},
      SimpleDesigner: null,
      logoSite: logoSite,
      currentAttr: {
        color: "",
        size: "", 
      },
      currentBox: "",
      components: {
        assistLine: true,
        ruler: false,
        guideLine: true,
        colorPicker: false,
        // showProductColor: true,
        // showProductSize: false,
        showLayer: true,
        colorPickerText: false,
        showOpacityConfig: false,
      },
      currentPart: "",
      config: {
        backgroundColor: "#ffffff", //？
        backgroundColorText: "#000000",//字体颜色
        fontFamily: "",//字体
        fontSize: "", //字号
        textAlign: "", //对齐方式
        fontWeight: "", //是否加粗
        fontStyle: "", //是否斜体
        charSpacing: "", //字间距
        lineHeight: "", //行高
        isSetBackground: false,//？
        copyIndex: 0,//？
        scale: 1,//？
        canvasSize: 50,//？
        locked: false, //是否锁定
        rotate: 0, //旋转角度
        undoLength: 0,//？
        redoLength: 0,//？
        partConfig: "1",//？
        toParts: [],//所有层面
        activePart: "",//当前层面
        activePartLimitMode: "",//元素限制模式
        downloadPart: "",//？
        showTileConfig: false,
        isTile: '', //平铺类型
        gapWidth: 0, //平铺横向间距
        gapHeight: 0,//平铺纵向间距
        opacity: 100,//透明度
        maxSizeType: '',//最大化
      },
      textColorList: [
        {
          hex: "#171717",
          name: "black",
        },
        {
          hex: "#ffffff",
          name: "white",
        },
        {
          hex: "#a1a1a1",
          name: "grey",
        },
        {
          hex: "#9c6a23",
          name: "brown",
        },
        {
          hex: "#d82424",
          name: "red",
        },
        {
          hex: "#ee6419",
          name: "orange",
        },
        {
          hex: "#50b03c",
          name: "green",
        },
        {
          hex: "#035239",
          name: "darkGreen",
        },
        {
          hex: "#192c7c",
          name: "blue",
        },
        {
          hex: "#3f92db",
          name: "sky",
        },
        {
          hex: "#934b7c",
          name: "purple",
        },
        {
          hex: "#ffde00",
          name: "yellow",
        },
      ],

      textFontList: [
        "Block2",
        "Crevasse",
        "College",
        "Folio Condensed",
        "Arnold",
        "Handel Gothic",
        "Monoglyceride Bold",
        "Dr Zeus",
        "Enchantment",
        "Old English",
      ],
      textFontList3D: [
        "3D Futuro",
        "3D London",
        "3D Brush",
        "3D Monoglyceride",
      ],
      embroideryFontList: [],
      currentProductMenu: 0,
      currentConfig: {},
      currentObject: {}, //当前选中图层
      previewsData: [{}],
      previewIndex: 0,
      previewImages: [],
      layers: [],
      customizeLayers: [],
      setKeyVisible: false,
      setKey: false,
      fontSizeList: [
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        36,
        48,
        56,
        72,
        86,
        100,
      ],
      keyConfig: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["ctrl", "+", "a"],
          text: "ctrl+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["ctrl", "+", "m"],
          text: "ctrl+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["ctrl", "+", "c"],
          text: "ctrl+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["ctrl", "+", "v"],
          text: "ctrl+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["ctrl", "+", "z"],
          text: "ctrl+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["ctrl", "+", "shift", "+", "z"],
          text: "ctrl+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["delete"],
          text: "delete",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["ctrl", "+", "s"],
          text: "ctrl+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["ctrl", "+", "\\"],
          text: "ctrl+\\",
          canEdit: true,
        },
      ],
      activeView: "2D",
      keyConfigDefault: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["ctrl", "+", "a"],
          text: "ctrl+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["ctrl", "+", "m"],
          text: "ctrl+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["ctrl", "+", "c"],
          text: "ctrl+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["ctrl", "+", "v"],
          text: "ctrl+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["ctrl", "+", "z"],
          text: "ctrl+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["ctrl", "+", "shift", "+", "z"],
          text: "ctrl+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["delete"],
          text: "delete",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["ctrl", "+", "s"],
          text: "ctrl+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["ctrl", "+", "\\"],
          text: "ctrl+\\",
          canEdit: true,
        },
      ],
      keyConfigApple: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["command", "+", "a"],
          text: "command+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["command", "+", "m"],
          text: "command+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["command", "+", "c"],
          text: "command+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["command", "+", "v"],
          text: "command+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["command", "+", "z"],
          text: "command+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["command", "+", "shift", "+", "z"],
          text: "command+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["backspace"],
          text: "backspace",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["command", "+", "s"],
          text: "command+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["command", "+", "\\"],
          text: "command+\\",
          canEdit: true,
        },
      ],
      fontList: [],
      formDesign: {
        pageNum: 1,
        pageSize: 8,
        delFlag: "1",
        sDesignId: '01',
        beginTime: '',
        endTime: '',
        ifNew: '01', //01新，02旧
      },
      designData: [],
      totalDesign: 0,
      parts: [],
      activeLayer: "",
      triggerFlag: false,
      arrKey: [],
      timer: null,
      showSaveConfirm: false,
      myRuler: null,
      isSubmit: false,
      isScreenshotFinished: true,
      toolBarHeight: "80vh",
      checkAllParts: false,
      psd_params: {
        width: 0,
        height: 0,
      },
      partMode: "1",
      currentUploadImage: 0,
      CPrice: 0,
      uploadTextVisible: false,
      setColorVisible: false,
      embroideryPrice: 0,
      embroideryImageInfo: {
        embroideryParams: {
          colors: ["orange", "white", "grey"],
        },
      },
      embroideryImageColorsOrigin: [],
      embroideryImageColors: ["orange", "white", "grey"],
      textColorMap: {
        white: "#ffffff",
        black: "#171717",
        grey: "#a1a1a1",
        brown: "#9c6a23",
        red: "#d82424",
        orange: "#ee6419",
        green: "#50b03c",
        darkGreen: "#035239",
        blue: "#192c7c",
        sky: "#3f92db",
        purple: "#934b7c",
        yellow: "#ffde00",
      },
      embroideryDiscountPrice: 0,
      embroideryNumMax: 0,
      userProfile: {},
      // canSaveDesigner: true,
      canChangeBackgroundColor: true, //默认可修改背景色, false为不可修改
      showDesign: false, //该分类下产品是否可设计
      setPosVisible: false, //设置坐标
      posForm: {
        posSort: '1',
        posLabel: '',
      },
      layerPosInfoShow: {},
      designerUrlType: '', //01线上，02本地
      productDialogVisible: false,
      activeQuery: ['1','2','3','4','5','6','7','8'],
      galleryVisible: false,
      showPosPop: false,
      designerApi: {},
      mainPic: '',
      faceTitle: '',
      isSync: false,
      changeFlag: null,
      aliyunOssToken: null,
      formSet: [],
      realTimeRender: '',
      designDetail: null,  //已设计产品的设计数据
      selectType: '',  //copy复用设计
      showSaveColorConfirm: false,
      saveColorConfirmData: [],
      isCheckColor: false,
      isIndeterminate: false,
      checkedPics: [],
    }
  },
  props: {
    skuData: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapGetters(["nginx", "dictData", "dictMap", "user"]),
    sizeList() {
      let sizeList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          let size = record.properVal.split(":")[1]
          if (color == this.currentAttr.color) {
            if (!sizeList.includes(size)) {
              sizeList.push(size)
            }
          }
        }
      }
      return sizeList
    },
    designLogoUrl() {
      return this.$store.state.setting.siteData.designLogoUrl
    },
    colorList() {
      let colorList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          if (!colorList.includes(color)) {
            colorList.push(color)
          }
        }
      }

      return colorList
    },
    // partName() {
    //   let partName = ""
    //   for (let record of this.parts) {
    //     if (record.name == this.config.activePart) {
    //       partName = record.i18n.zh
    //       break
    //     }
    //   }
    //   return partName
    // },
    isReplaceProduct() {
      let appSkuId = this.$route.query.appSkuId
      if (appSkuId) {
        return true
      } else {
        return false
      }
    },
    originPId() {
      let pId = this.$route.query.pId
      if (pId) {
        return pId
      } else {
        return ""
      }
    },
    isApple() {
      return (
        navigator.platform.indexOf("Mac") > -1 ||
        navigator.platform.indexOf("iPod") > -1 ||
        navigator.platform.indexOf("iPhone") > -1 ||
        navigator.platform.indexOf("iPad") > -1
      )
    },
    isShowEditTab() {
      return this.customizeLayers.length > 0
    },
  },
  async mounted() {
    // 设计器初始化
    // 调整实时渲染状态，需要在加载前赋值
    this.realTimeRender = localStorage.getItem('isRealTimeRender') === 'true'

    const designerFrame = this.$refs.designerFrame
    designerFrame.addEventListener('load', this.iframeInit)

    // 坐标
    if (Cookies.get("moreLayerInfo")) {
      this.layerPosInfoShow = JSON.parse(Cookies.get("moreLayerInfo"))
    }
    //  let data = {
    //     userName: this.user.name,
    //     hotKey: '',
    //   }
    //   let result = await setHotKey(data)

    // let userProfile = await getUserProfile()
    // this.userProfile = userProfile
    // if (
    //   userProfile.user.hotKey &&
    //   userProfile.user.hotKey.indexOf("windows") > -1 &&
    //   !this.isApple
    // ) {
    //   let hotKey = JSON.parse(userProfile.user.hotKey)
    //   this.keyConfig = JSON.parse(JSON.stringify(hotKey.windows))
    // } else if (
    //   userProfile.user.hotKey &&
    //   this.isApple &&
    //   userProfile.user.hotKey.indexOf("apple") > -1
    // ) {
    //   let hotKey = JSON.parse(userProfile.user.hotKey)
    //   this.keyConfig = JSON.parse(JSON.stringify(hotKey.apple))
    // } else if (!userProfile.user.hotKey && this.isApple) {
    //   this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigApple))
    // } else if (!userProfile.user.hotKey && !this.isApple) {
    //   this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigDefault))
    // } else if (
    //   userProfile.user.hotKey &&
    //   this.isApple &&
    //   userProfile.user.hotKey.indexOf("apple") == -1
    // ) {
    //   this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigApple))
    // } else if (
    //   userProfile.user.hotKey &&
    //   !this.isApple &&
    //   userProfile.user.hotKey.indexOf("windows") == -1
    // ) {
    //   this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigDefault))
    // }

    // this.bindKey()

    // this.myRuler = new Ruler({
    //   container: document.querySelector(".simple-designer"), // reference to DOM element to apply rulers on
    //   rulerHeight: 15, // thickness of ruler
    //   fontFamily: "arial", // font for points
    //   fontSize: "10px",
    //   strokeStyle: "black",
    //   lineWidth: 1,
    //   enableMouseTracking: true,
    //   enableToolTip: true,
    // })
    // this.myRuler.api.toggleRulerVisibility(false)
    // window.setInterval(() => {
    //   this.previewImageUrl = this.convertCanvasToImage(
    //     document.querySelector("#preview")
    //   )
    //   let dom = document.querySelector(".mouse-cover-canvas")
    //   if (dom) {
    //     dom.id = "mouse-cover-canvas"
    //   }
    // }, 1000)
    
    // 顶部样式
    if (document.querySelector(".child-content")) {
      document.querySelector(".child-content").style.padding = "0"
      document.querySelector(".child-content").style.marginTop = "0"
    }
    if (document.querySelector(".el-header")) {
      document.querySelector(".el-header").style.display = "none"
    }
    document.querySelector("body").setAttribute("style", "overflow:hidden !important;")

    document.addEventListener("click", this.clickEvent)
    // document.addEventListener('keydown', this.handleKey)
  },

  beforeRouteLeave(to, from, next) {
    // if (document.querySelector(".child-content")) {
    //   document.querySelector(".child-content").style.padding = "12px"
    // }
    // if (document.querySelector(".el-header")) {
    //   document.querySelector(".el-header").style.display = "block"
    // }
    // document.getElementsByTagName("body")[0].style["overflow"] = "inherit"

    // document.removeEventListener("click", this.clickEvent)
    // // document.removeEventListener('keydown', this.handleKey)
    // hotkeys.unbind()
    let designerFrame = this.$refs.designerFrame
    if (!designerFrame) return
    designerFrame.removeEventListener('load', this.iframeInit)
    designerFrame.src = 'about:blank'
    if (designerFrame.parentNode) {
      designerFrame.parentNode.removeChild(designerFrame)
    }
    designerFrame = null

    this.reset()
    next() //允许跳转页面
  },
  methods: {
    iframeInit() {
      const designerFrame = this.$refs.designerFrame
      this.designerApi = designerFrame.contentWindow.SingleDesign

      this.handleProductLoaded() //初始化产品 
      
      // 调整效果图弹窗
      this.designerApi.setPreviewScale(0.75)

      const iframeDoc = designerFrame.contentDocument || designerFrame.contentWindow.document
      const xgtTcEle = iframeDoc.querySelectorAll('.xgt_tc')
      xgtTcEle[0].style.top = '7%'
      // const faceWindowEle = iframeDoc.querySelectorAll('.faceWindow')
      // faceWindowEle[0].style.height = '80vh'

      // 可用字体
      this.getFontList()

      this.designerApi.onLayerChange((layers) => { //监听图层变化
        // console.log('当前图层列表:', layers)
        this.layers = layers
        this.customizeLayers = this.layers.filter(v => ['material', 'textbox'].includes(v.type))
        const activeIndex = this.customizeLayers.findIndex(v => v.id === this.currentObject?.id)
        if (activeIndex > -1) {
          this.activeLayer =  activeIndex
        } else {
          if (this.customizeLayers.length>0) {
            this.activeLayer = 0
            this.designerApi.selectLayer(this.customizeLayers[0].id)
          } else {
            // 图层为空
            this.activeLayer = ""
          }
        }
      })
      this.designerApi.onFaceSelect((faceInfo) => {
          this.faceTitle = faceInfo.title
          this.config.activePart = faceInfo.id
          const currFaces = this.designerApi.getFaces().find(v => v.id === faceInfo.id)
          if (currFaces) {
            this.config.activePartLimitMode = currFaces.elementLimitMode
          }
      })
      this.designerApi.onLayerSelect((layerId) => { //监听图层是否选中
          // console.log('用户选中了图层:', layerId)
          if(layerId) {
            this.updateLayers(layerId)
            this.handleCurrLayerConfig(this.customizeLayers[this.activeLayer])
          } else {
            // null，取消选中
            this.currentObject = {}
            // this.currentBox = '' //取消选中保持原功能，再次选中时再更新，不然撤销会导致闪一下
            // this.currentMenu = 1  //默认打开图库
          }
      })
      this.designerApi.onLayerTransform((data) => {
          // console.log('图层变换:', data)
          this.layerInfo.w = data.width
          this.layerInfo.h = data.height
          this.layerInfo.y = data.top
          this.layerInfo.x = data.left
          this.config.rotate = data.angle
      })
      window.addEventListener('message', async (event) => {
        if (event.data && event.data.type === 'realTimeRenderChange') {
          // console.log('用户切换了实时渲染状态：', event.data.isRealTimeRender);
          // event.data.isRealTimeRender 为 boolean 值 (true:开启, false:关闭)
          localStorage.setItem('isRealTimeRender', String(event.data.isRealTimeRender))
        } else if (event.data && event.data.type === 'variantChange') {
          // 属性切换
          const variantInfo = event.data
          // console.log('变体切换(跨域):', variantInfo)
          if (variantInfo.colorName) {
            this.currentAttr.color = variantInfo.colorName
          }
          if (variantInfo.sizeValue) {
            this.currentAttr.size = variantInfo.sizeValue
          }
        } else if (event.data && event.data.type === 'saveDispatched') {//只在从设计器路由进入监听
          // console.log('设计保存已派发(跨域):', event.data)
          const currSaveForm = this.formSet.find(v => v.reqId === event.data.reqId)
          // console.log('currSaveForm: ',currSaveForm)
          // 监听“保存开始”通知（可在此时允许继续编辑）
          if (!this.changeFlag) {
            designCacheDB.createNotification({
              proName: currSaveForm.proName,
              reqId: event.data.reqId,
            })
            // 缓存尺寸和坐标，不用等保存成功，方遍客户连续操作
            Cookies.set("layerInfo", JSON.stringify(this.layerInfo), { expires: 365 })
            this.endLoading()
  
            // 清空当前设计
            this.designerApi.clearAll()
            this.designerApi.deleteBackgroundColor()

            this.isScreenshotFinished = true
            this.isSubmit = false
          }
        } else if (event.data && event.data.type === 'saveSuccess') {  
          // console.log('设计保存成功(跨域):', event.data)
          // 保存
          try {
            const designId = event.data.designId
            // console.log('保存成功，设计ID:', designId)
            // const localEffects = event.data.effects //本地效果图(Base64)
            const detail = await this.designerApi.getDesignRecord(designId) //设计记录
            const currSaveForm = this.formSet.find(v => v.reqId === event.data.reqId)
            let form = this._.clone(currSaveForm)

            // 实际应用中会出现产品和效果图不一致的情况，剔除错误数据
            if (detail.productName != this.detail.proCode) {
              this.$message.error('设计出错，请重新设计！')
              this.endLoading()
              this.isScreenshotFinished = true
              this.isSubmit = false
              if (!this.changeFlag) {
                designCacheDB.closeNotification(event.data.reqId)
              }
              return
            }

            // 只保存选择的颜色
            let localEffects = []
            if (form.checkedPics.length>0) {
              localEffects = event.data.effects?.filter(l_item => {
                return form.checkedPics.some(checkItem => checkItem.properVal.split(":")[0] == l_item.colorName)
              })
            } else {
              localEffects = event.data.effects || []
            }
            delete form.checkedPics

            // 如果效果图全部为空，则不让保存
            if (!localEffects || localEffects.length === 0 || localEffects.every(v => !v.render_url)) {
              this.$message.error('效果图保存出错，请重新保存！')
              this.endLoading()
              this.isScreenshotFinished = true
              this.isSubmit = false
              return
            }

            delete form.proName
            form.canvasJson = JSON.stringify(detail)  //存储整个详情对象，用于还原设计
            form.printsParams = Base64.encode(designId)  //第三方设计id
            
            // changeFlag不存在：从设计器路由进入，替换产品0,1，保存设计3，保存设计并关联2
            if (this.changeFlag) {
              // 处理skuList
              if (['0','1'].includes(this.changeFlag)) {  //替换产品（页面跳转）
                if (localEffects && localEffects.length > 0 && localEffects.some(v => v.render_url)) {
                  let skuList = []
                  let coverPic = ''
                  for (let record of localEffects) {
                    let base64Data = record.render_url
                    if (!base64Data) {
                      if (this.dictMap['photo_merging']?.[detail.goodsSku]) {
                        // 绘制一张边界明显的空白图片
                        const canvas = document.createElement('canvas')
                        canvas.width = 2000
                        canvas.height = 2000
                        const ctx = canvas.getContext('2d')
                        
                        // 绘制白色背景
                        ctx.fillStyle = '#ffffff'
                        ctx.fillRect(0, 0, canvas.width, canvas.height)
                        
                        // 绘制明显的边界
                        ctx.strokeStyle = '#666666'
                        ctx.lineWidth = 4
                        ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20)
                        
                        // 绘制 "无图片" 文字
                        // ctx.fillStyle = '#666666'
                        // ctx.font = 'bold 32px Arial'
                        // ctx.textAlign = 'center'
                        // ctx.fillText('无图片', canvas.width / 2, canvas.height / 2)
                        
                        base64Data = canvas.toDataURL('image/png')
                      } else {
                        continue
                      }
                    }
  
                    const file = this.base64ToFile(base64Data, new Date().getTime() + ".png")
                    let result = await uploadFileNew(file, false, this.aliyunOssToken)
                    this.aliyunOssToken = result.aliyunOssToken
                    if (!result.uploadFlag) {
                      this.isSubmit = false
                      return
                    }
                    skuList.push({
                      color: record.colorName,
                      imageUrl: result.fileUrl,
                      title: record.title,
                    })
                  }
                  let colorList = []
                  const newSkuList = []
  
                  skuList.map((el) => {
                    colorList.push(el.color)
                  })
  
                  colorList = this._.uniq(colorList)
  
                  for (const e of colorList) {
                    let ob = {
                      color: e,
                      imageList: [],
                    }
  
                    const colorImages = []
                    skuList.map((el) => {
                      if (e === el.color) {
                        ob.imageList.push(el.imageUrl)
                        colorImages.push({
                          imageUrl: el.imageUrl,
                          title: el.title
                        })
                      }
                      if (!coverPic) {
                        coverPic = el.imageUrl
                      }
                    })
  
                    // 生成拼接图片
                    if (this.dictMap['photo_merging']?.[detail.goodsSku] && colorImages.length > 1) {
                      const collageBase64 = await designCacheDB.generateCollageImage(colorImages, e)
                      if (collageBase64) {
                        const file = designCacheDB.base64ToFile(collageBase64, new Date().getTime() + "_collage.png")
                        let result = await uploadFileNew(file, false, designCacheDB.aliyunOssToken)
                        designCacheDB.aliyunOssToken = result.aliyunOssToken
                        // 将拼接图片添加到imageList中
                        ob.imageList.unshift(result.fileUrl)
                      }
                    }
                    newSkuList.push(ob)
                  }
                  form.skuList = newSkuList
                  form.coverPic = coverPic
                }
  
                // 缓存尺寸和坐标
                Cookies.set("layerInfo", JSON.stringify(this.layerInfo), { expires: 365 })
                this.endLoading()
                // 清空当前设计
                this.designerApi.clearAll()
                this.designerApi.deleteBackgroundColor()
  
                form.appSkuId = this.$route.query.appSkuId
                form.changeFlag = this.changeFlag
                await addUserDesignNew(form)
  
                this.$message({
                  message: "设计保存成功！",
                  type: "success",
                  duration: 1000,
                })
                this.isSubmit = false
                this.showSaveConfirm = false
              } else { // 设计商品关联（组件）
                // 缓存尺寸和坐标
                Cookies.set("layerInfo", JSON.stringify(this.layerInfo), { expires: 365 })
                this.endLoading()
                // 清空当前设计
                this.designerApi.clearAll()
                this.designerApi.deleteBackgroundColor()
  
                this.isSubmit = false
                this.reset()
                this.$emit('onFinish', { 
                  form, 
                  localEffects, 
                  proCode: detail.goodsSku,
                  changeFlag: this.changeFlag
                })
              }
            } else {
              const designData = {
                localEffects: localEffects,
                form: form,
                proCode: detail.goodsSku,
              }
              // 保存到 IndexedDB
              await designCacheDB.addDesign({
                id: 'design_' + Date.now(),
                data: designData,
                timestamp: Date.now(),
                status: 'pending',
                createdAt: new Date().toISOString(),
                userName: this.user.name,
                proName: this.detail.proName,
                reqId: event.data.reqId,
              })
  
              const delIndex = this.formSet.findIndex(v => v.reqId === event.data.reqId)
              this.formSet.splice(delIndex, 1)
            }
          } catch (err) {
            console.error('保存设计失败:', err)
            this.$message.error('保存设计失败，请稍后重试')
            this.endLoading()
            this.isScreenshotFinished = true
            this.isSubmit = false
            if (!this.changeFlag) {
              designCacheDB.closeNotification(event.data.reqId)
            }
          }
        } else if (event.data && event.data.type === 'saveFailed') {
          const reqId = event.data.reqId
          const message = event.data.message || '保存失败'
          console.error('保存失败:', reqId, message)
          // 这里应关闭“设计效果图生成中”或其他保存中的 UI
          if (reqId) {
            designCacheDB.closeNotification(reqId)
            this.$message.error(message)
          }
          this.endLoading()
          this.isScreenshotFinished = true
          this.isSubmit = false
        }
      })
    },
    base64ToFile(base64Data, filename) {
      // 去除base64前缀（如果存在）
      const arr = base64Data.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1] || base64Data) // 如果没有前缀，直接使用整个字符串
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      
      return new File([u8arr], filename, { type: mime || 'image/png' })
    },
    // 更新图层列表
    updateLayers(layerId) {
      this.layers = this.designerApi.getLayers() //添加、删除会导致图层发生变化
      // console.log('layers: ', this.layers)
      this.customizeLayers = this.layers.filter(v => ['material', 'textbox'].includes(v.type))
      // console.log('customizeLayers: ', this.customizeLayers)
      const currIndex = this.customizeLayers.findIndex(v => v.id === layerId)
      this.activeLayer = currIndex
      // console.log('activeLayer: ', this.activeLayer)
    },
    clickEvent(e) {
      let list = document.querySelector(".bg-color-picker-")
      if (
        (list && list.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-color-picker") > -1)
      ) {
      } else if (this.components.colorPicker) {
        this.components.colorPicker = false
      }

      // 点击字体颜色颜色盘以外的位置隐藏颜色盘
      let listText = document.querySelector(".bg-color-picker-text")
      if (
        (listText && listText.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-color-picker") > -1)
      ) {
      } else if (this.components.colorPickerText) {
        this.components.colorPickerText = false
      }

      // 点击平铺相关按钮以外的位置隐藏滑块
      let listTile = document.querySelector(".tileway-pop")
      if (
        (listTile && listTile.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("tile-button") > -1)
      ) {
      } else if (this.config.showTileConfig) {
        this.config.showTileConfig = false
      }

      // 点击透明相关按钮以外的位置隐藏滑块
      let listOpacity = document.querySelector(".opacity-pop")
      if (
        (listOpacity && listOpacity.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-icon-view") > -1 &&
          e.target.className.indexOf("el-icon-view") > -1)
      ) {
      } else if (this.components.showOpacityConfig) {
        this.components.showOpacityConfig = false
      }
    },
    // 菜单重置及设计数据回显(数据不全，无法全部回显)
    handleCurrLayerConfig(object) {
      // **type (图层类型) 枚举值说明:**
      // *   `material`: **图片素材** (最常见，用户添加的图片)
      // *   `textbox`: **文本** (用户添加的文字)
      // *   `bg`: **背景色块/底板** (通常不可删除)
      // *   `mainBg`: **主背景图** (如果有，通常不可删除)
      // *   `unknown`: 未知类型
      if (object) {
        this.currentObject = object
        if (object.type === 'textbox') {
          this.currentBox = "text"
        } else if (object.type === 'material') {
          this.currentBox = "image"
        }
        this.layerInfo.x = this.currentObject.left
        this.layerInfo.y = this.currentObject.top
        this.layerInfo.w = this.currentObject.width
        this.layerInfo.h = this.currentObject.height

        this.config.visible = this.currentObject.visible
        this.config.locked = this.currentObject.locked
        this.config.opacity = this.currentObject.opacity * 100
        this.config.rotate = this.currentObject.angle
        // 最大化（自定义的，其实插件没有这个字段，这里临时存储一下）
        this.config.maxSizeType = this.currentObject.maxSizeType || ''
        // 平铺
        this.config.isTile = this.currentObject.patternType || ''
        this.config.gapWidth = this.currentObject.marginLeft
        this.config.gapHeight = this.currentObject.marginTop
        // 文本
        this.config.backgroundColorText = this.currentObject.fill
        this.config.fontSize = this.currentObject.fontSize
        this.config.fontFamily = this.currentObject.fontFamily
        this.config.fontWeight = this.currentObject.fontWeight
        this.config.fontStyle = this.currentObject.fontStyle
        this.config.textAlign = this.currentObject.textAlign
        this.config.charSpacing = this.currentObject.charSpacing
        this.config.lineHeight = this.currentObject.lineHeight
      } else {
        this.currentObject = {}
        this.currentBox = ''
        this.currentMenu = 1  //默认打开图库
      }
    },
    // 跳转首页
    handleJumpPath(path) {
      // 如果是设计商品的关联组件不跳转
      if(this.skuData) {
        return
      }
      this.$router.push({ path: path })
    },
    // 撤销
    handleUndo() {
      this.designerApi.undo()
    },
    // 重做
    handleRedo() {
      this.designerApi.redo()
    },
    // 清空
    handleClearCanvas() {
      this.$confirm("是否清空设计？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "清空所有面设计",
        cancelButtonText: "清空当前面设计",
        cancelButtonClass: "design_clear_layer_cancel",
        type: "warning",
      })
      .then(() => {
        this.designerApi.clearAll()
      })
      .catch((action) => {
        if (action === 'cancel') {
          this.designerApi.clear()
        }
      })
    },
    // 复制刀版
    getPartData() {
      if (this.designerApi.getFaces) {
        if (this.config.activePartLimitMode === 'image_only') {
          this.parts = this.designerApi.getFaces()
            .filter(face => !face.isOverall)
            .filter(face => face.elementLimitMode !== 'text_only') //只复制图片兼容的层面
        } else if (this.config.activePartLimitMode === 'text_only') {
          this.parts = this.designerApi.getFaces()
            .filter(face => !face.isOverall)
            .filter(face => face.elementLimitMode !== 'image_only') //只复制文字兼容的层面
        } else {
          this.parts = this.designerApi.getFaces()
            .filter(face => !face.isOverall)
        }
      }
      this.config.toParts = []
      this.checkAllParts = false
      // for (let i = 0; i <= this.parts.length; i++) {
      //   this.config.toParts.push(this.parts[i].index)
      // }
    },
    handleCheckParts() {
      if (this.checkAllParts) {
        this.config.toParts = []
        for (let record of this.parts) {
          this.config.toParts.push(record.index)
        }
      } else {
        this.config.toParts = []
      }
    },
    handleSelectParts(record) {
      let find = false
      for (let i = 0; i <= this.config.toParts.length; i++) {
        if (this.config.toParts[i] === record.index) {
          this.config.toParts.splice(i, 1)
          find = true
          break
        }
      }
      if (!find) {
        this.config.toParts.push(record.index)
      }
    },
    handleCopyObject() {
      this.designerApi.copyLayerContent(this.config.toParts).then(() => {
        this.msgSuccess("复制成功")
      }).catch(errMsg => {
        this.msgError(errMsg)
      })
    },
    // 网格线
    addGrid() {
      if (this.components.assistLine) {
        this.designerApi.toggleGrid(false)
      } else {
        this.designerApi.toggleGrid(true)
      }
      this.components.assistLine = !this.components.assistLine
    },
    // 标尺
    // addRuler() {
    //   if (this.components.ruler) {
    //     this.myRuler.api.toggleRulerVisibility(false)
    //   } else {
    //     this.myRuler.api.toggleRulerVisibility(true)
    //   }
    //   this.components.ruler = !this.components.ruler
    // },
    // 辅助线
    addGuide() {
      if (this.components.guideLine) {
        this.designerApi.toggleGuide(false)
      } else {
        this.designerApi.toggleGuide(true)
      }
      this.components.guideLine = !this.components.guideLine
    },
    // 全屏
    handleFullScreen() {
      this.launchFullscreen(document.querySelector("body"))
    },
    // 快捷键
    handleShowKeyConfig() {
      this.setKeyVisible = true
    },
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    // 添加文字
    handleAddText() {
      if (this.config.activePartLimitMode === 'image_only') return
      this.designerApi.addText('TEXT')
    },
    // 上传图片
    uploadImg() {
      if (this.config.activePartLimitMode === 'text_only') return
      if (!this.$refs.upload) return
      this.$refs.upload.dispatchEvent(new MouseEvent("click"))
    },
    async handleUpload(event) {
      let _self = this

      const files = event.target.files
      this.startLoading()
      let isSuccess = true
      for (let file of files) {
        let imageDataArr = []
        const isLt2M = file.size / 1024 / 1024 < 50
        if (!isLt2M) {
          isSuccess = false
          _self.msgError(`${file.name}超过50M，上传失败！`)
          continue
        }
        if (!file.type.startsWith('image/')) {
          _self.msgError(`${file.name}非图片格式，请上传图片文件！`)
            continue
        } else if (file.type == 'image/gif') {
          _self.msgError(`${file.name}为GIF格式图片，禁止上传！`)
          continue
        }
        const { uploadFlag, fileUrl } = await uploadFile(file, true)
        if (!uploadFlag) {
          _self.msgError("上传失败！")
          this.endLoading()
          return
        }
        let fileInfo = await this.getFileInfo(file)
        let imageData = {}
        imageData.picUrl = fileUrl
        imageData.picWidth = fileInfo.picWidth
        imageData.picHeight = fileInfo.picHeight
        imageData.picName = file.name
        imageData.fileSize = file.size
        imageData.mapAttr = this.currentUploadImage == 0 ? "01" : "02"

        //上传低清图片
        if (imageData.picWidth > 150) {
          const img = await this.readImg(file)
          const blob = await this.compressImg(
            img,
            file.type,
            150,
            (150 * imageData.picHeight) / imageData.picWidth
          )
          var result = await uploadFile(blob, true)
          imageData.picUrl2 = result.fileUrl
        } else {
          imageData.picUrl2 = imageData.picUrl
        }

        if (imageData.picWidth > 500) {
          const img = await this.readImg(file)
          const blob = await this.compressImg(
            img,
            file.type,
            500,
            (500 * imageData.picHeight) / imageData.picWidth
          )
          var result = await uploadFile(blob, true)
          imageData.picUrl3 = result.fileUrl
        } else {
          imageData.picUrl3 = imageData.picUrl
        }

        imageDataArr.push(imageData)
        let response = await addImgMap(imageDataArr)

        if (response.code === 200) {
          let imageUrl = fileUrl

          if (
            fileInfo.picHeight >= fileInfo.picWidth &&
            fileInfo.picHeight > 2000
          ) {
            let width = Math.round(
              (fileInfo.picWidth / fileInfo.picHeight) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
          }

          if (
            fileInfo.picWidth > fileInfo.picHeight &&
            fileInfo.picWidth > 2000
          ) {
            let height = Math.round(
              (fileInfo.picHeight / fileInfo.picWidth) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
          }

          this.designerApi.addImage(imageUrl, response.data[0].mapId, file.name)
        } else {
          _self.msgError("上传失败！")
          this.endLoading()
          return
        }
      }
      if (_self.$refs["uploadHistory"]) {
        _self.$refs["uploadHistory"].getData()
      }

      _self.$refs["upload"].value = null
      if (isSuccess) {
        _self.$message({
          message: "上传成功",
          type: "success",
          duration: 700,
        })
      }

      this.handleChangeMenu(1) //更新图库

      this.endLoading()
    },
    getFileInfo(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = function(event) {
          var txt = event.target.result
          var img = document.createElement("img")
          img.src = txt
          img.onload = function() {
            let record = {}
            record.picWidth = img.width
            record.picHeight = img.height
            resolve(record)
          }
        }
        reader.readAsDataURL(file)
      })
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function(e) {
          img.src = e.target.result
        }
        reader.onerror = function(e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function() {
          resolve(img)
        }
        img.onerror = function(e) {
          reject(e)
        }
      })
    },
    compressImg(img, type, mx, mh) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        const { width: originWidth, height: originHeight } = img
        // 最大尺寸限制
        const maxWidth = mx
        const maxHeight = mh
        // 目标尺寸
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            // 宽图片
            targetWidth = maxWidth
            targetHeight = Math.round(maxWidth * (originHeight / originWidth))
          } else {
            // 高图片
            targetHeight = maxHeight
            targetWidth = Math.round(maxHeight * (originWidth / originHeight))
          }
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function(blob) {
          resolve(blob)
        }, type || "image/png")
      })
    },
    // 初始化产品
    async handleProductLoaded() {
      if (this.isFirstLoading) {
        let pId = this.$route.query.pId
        if (!pId) {
          if (document.location.host === 'test.temudiy.com') {
            pId = "1200803955942805504" //测试
          } else if (document.location.host === 'www.onecust.cn') {  //小东定制
            pId = "1001" //生产环境
          } else if (document.location.host === 'www.onecust.com') {  //1号定制
            pId = "1002" //生产环境
          } else {
            pId = "1000143901395877888" //生产环境
          }
        }
        let designId = this.$route.query.designId
        if (designId) { //1、订单列表进入（重新设计、替换产品）
          this.handleChangeProduct({
            designId,
          })
        } else { // 2、其他：产品详情进入
          let productResult = await getProductDetail(pId)
          this.detail = productResult.data
          this.showDesign = false
          this.processData()
          this.designerApi.setProduct(productResult.data.proCode)
        }
        this.isFirstLoading = false
      }
    },
    // 切换已设计产品
    async handleChangeProduct(record) {
      this.designDetail = null
      this.startLoading()
      let result = await getDesign(record.designId)
      let designData = result.data

      let productResult = await getProductDetail(designData.pId)
      this.detail = productResult.data
      this.processData()

      await this.sleep(500)
      if (designData.canvasJson) { //还原设计
        this.designerApi.setProduct(designData.proCode).then(() => {
          this.designDetail = JSON.parse(designData.canvasJson)
          // this.designerApi.clear() //批量设计的产品不会自动清除
          // this.designerApi.deleteBackgroundColor()
          this.designerApi.loadDesign(this.designDetail).then(() => {
            this.endLoading()
          })
        })
      } else {
        // 加入一张图
        this.designerApi.setProduct(designData.proCode).then(async () => {
          if (designData.mapIds && designData.mapIds.length > 0) {
            // const mode = this.config.activePartLimitMode
            const mode = this.designerApi.getFaces().find(v => v.active).elementLimitMode
            if (mode === 'text_only') {
              this.msgError('当前设计面限制只能添加文字，无法加载图片')
              this.endLoading()
              return
            }

            let mapId = designData.mapIds[0].mapId
            let imageInfo = (await getMapInfo(mapId)).data
            let imageUrl = imageInfo.picUrl
            if (
              imageInfo.picHeight >= imageInfo.picWidth &&
              imageInfo.picHeight > 2000
            ) {
              let width = Math.round(
                (imageInfo.picWidth / imageInfo.picHeight) * 2000
              )
              imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
            }
    
            if (
              imageInfo.picWidth > imageInfo.picHeight &&
              imageInfo.picWidth > 2000
            ) {
              let height = Math.round(
                (imageInfo.picHeight / imageInfo.picWidth) * 2000
              )
              imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
            }
            await this.designerApi.addImage(imageUrl, imageInfo.mapId, imageInfo.picName)
          }
          this.endLoading()
        })
      }
    },
    // 切换产品
    handleChooseProduct() {
      this.productDialogVisible = true
    },
    handleProduct(record) {
      const busiUserNameList = record.busiList?.map(v => v.userName)
      if (record.busiList?.length>0 && !busiUserNameList.includes(this.user.primAcc)) {
        this.$message.error('该产品只允许指定商家匹配！')
        return
      }
      this.productDialogVisible = false
      // console.log('record: ',record)
      if (this.selectType === 'copy') {
        this.handleCopyProduct(record)
      } else {
        this.designDetail = null
        this.handleAddProduct(record)
      }
    },
    async handleAddProduct(record) {
      this.showDesign = false
      this.designerApi.setProduct(record.proCode).then(() => {
          // console.log('产品切换成功')
          this.detail = record
          this.processData()
      })
    },
    async handleCopyProduct(record) {
      this.showDesign = false

      let handleLayerReady = (event) => {
          if (event.data && event.data.type === 'layerChange') {
              // console.log('设计器完全就绪，开始复用设计...')
              this.designerApi.loadDesign(this.designDetail, { matchByName: true }).then(() => {
                // console.log('设计复用成功')
                // 层面名称相同的会自动加载，名称不同的保持空白
                this.designDetail = null
              });
              window.removeEventListener('message', handleLayerReady)
          }
      }
      window.addEventListener('message', handleLayerReady)

      this.designerApi.setProduct(record.proCode)
      
      this.detail = record
      this.processData()
    },
    // 当前sku信息
    processData() {
      let properVal = this.detail.skuList[0].properVal.split(":")
      this.currentAttr.color = properVal[0]
      // this.change2DColor(properVal[0])
      this.currentAttr.size = properVal[1].replace(/\\/g, "")
      this.currentSku = this.detail.skuList[0]
      this.mainPic = this.currentSku.picList[0].picUrl
    },
    // 切换颜色/尺码
    handleSelectColor(color) {
      this.currentAttr.color = color
      this.designerApi.setVariant({ colorName: color, sizeValue: this.currentAttr.size })
      this.selectSku()
    },
    handleSelectSize(size) {
      this.currentAttr.size = size
      this.designerApi.setVariant({ colorName: this.currentAttr.color, sizeValue: size })
      this.selectSku()
    },
    selectSku() {
      for (let record of this.detail.skuList) {
        record.properVal = record.properVal.replace(/\\/g, "")
        if (
          record.properVal ===
          `${this.currentAttr.color}:${this.currentAttr.size}`
        ) {
          this.currentSku = record
          this.mainPic = this.currentSku.picList[0].picUrl
          break
        }
      }
    },
    // 保存记录
    getDesignData() {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(endDate.getDate() - 30)
      this.formDesign.endTime = `${endDate.getFullYear()}-${(endDate.getMonth()+1).toString().padStart(2, 0)}-${endDate.getDate().toString().padStart(2, 0)}`
      this.formDesign.beginTime = `${startDate.getFullYear()}-${(startDate.getMonth()+1).toString().padStart(2, 0)}-${startDate.getDate().toString().padStart(2, 0)}`
      listDesign(this.formDesign)
        .then((re) => {
          this.designData = re.rows
          this.totalDesign = re.total
        })
        .catch((err) => {})
    },
    // 保存记录翻页
    handleCurrentChange(pageNum) {
      this.formDesign.pageNum = pageNum
      this.getDesignData()
    },
    // 复制设计编号
    handleCopyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制设计编号成功")
      document.body.removeChild(target)
    },
    // 保存
    async handleSaveDesign(flag) {
      // flag：0替换，1替换并转换，2设计后关联
      this.changeFlag = flag
      if (this.showDesign) {
        // 符合不允许下单目录
        this.$message.error('该产品不允许保存和设计！')
        return
      }

      if (['2','3'].includes(this.changeFlag)) {
        // 校验设计后关联功能绑定的的产品
        const busiUserNameList = this.detail.busiList?.map(v => v.userName)
        if (this.detail.busiList?.length>0 && !busiUserNameList.includes(this.user.primAcc)) {
          this.$message.error('该产品只允许指定商家匹配！')
          return
        }
        let exist = this.dictData["disable_directory"]?.some(v => this.detail.typeId.indexOf(v.value)>-1)
        if (this.skuData.platNo == '15' && this.skuData.orderModel == 'Y1') {
          // 半托y1的单子disable_directory下的才能关联
          if (!exist) {
            this.$message.error('y1订单需关联指定产品，该产品不符合要求无法关联，请联系管理员！')
            return
          }
        } else if (this.skuData.platNo == '18') { //国外发单
          // 国外发货只能关联半托的产品
          if (!exist) {
            this.$message.error('国外发货只能关联半托的产品!')
            return
          }
        } else if (this.skuData.platNo == '19') { //国内发单
          // 国内发货只能关联国内的产品
          if (exist) {
            this.$message.error('国内发货只能关联国内的产品!')
            return
          }
        }
        
        if (this.skuData.platNo == '21') {
          // 美客多不能关联vmi目录（mkd_rela_dir）下的产品
          let mcdExist = this.dictData["mkd_rela_dir"]?.some(v => this.detail.typeId.indexOf(v.value)>-1)
          if (mcdExist) {
            this.$message.error('美客多不能关联vmi目录下的产品!')
            return
          }
        }
      }

      let pIds = [
        "759848612718227456",
        "749720374595035136",

        "720341440962994176",
        "707659002355867648",

        "702601711477182464",
        "698620515915960320",

        "1111",
        "1022",

        "1304",
        "1024",

        "1009",
        "1026",

        "1106",
        "1028",
        "1011",

        "1008",
        "1110",

        "1005",
        "655834166810345472",
        "1013",
        "1206",
      ]

      if (pIds.includes(this.detail.pId)) {
        this.msgError("产品上线中，有需要请联系客服")
        return
      }
      if (this.detail.relaPId) {
        let hintText = ""
        if (this.detail.proName.indexOf("男") > -1) {
          hintText = "是否同步此设计到女款产品"
        } else if (this.detail.proName.indexOf("女") > -1) {
          hintText = "是否同步此设计到男款产品"
        } else {
          hintText = "是否同步此设计到同款产品"
        }

        this.$confirm(hintText, "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            this.isSync = true
            this.handleFinalSave()
          })
          .catch((action) => {
            if (action == "cancel") {
              this.isSync = false
              this.handleFinalSave()
            }
          })
      } else {
        this.isSync = false
        this.handleFinalSave()
      }
    },
    filterUniqueColors(data) {
      const seenColors = new Set()
      
      return data.filter(item => {
        const color = item.properVal.split(':')[0]
        
        if (seenColors.has(color)) {
          return false // 颜色已存在，过滤掉
        } else {
          seenColors.add(color)
          return true // 保留第一个出现的
        }
      });
    },
    async handleFinalSave() {
      if (!this.detail.pId) {
        this.msgError("请选择产品")
        return
      }
      
      this.checkedPics = [] //重置数据
      this.saveColorConfirmData = this.filterUniqueColors(this.detail.skuList)
      if (this.saveColorConfirmData.length>1) {  //多颜色
        this.isCheckColor = true
        this.handleCheckAllChange(true) //默认颜色全选
        this.showSaveColorConfirm = true
      } else { //单色
        this.finalSaveEvent()
      }
    },
    handleSaveColorConfirm() {
      if (this.checkedPics.length == 0) {
        this.$message.error('至少选择一种颜色！')
        return
      }
      this.showSaveColorConfirm = false
      this.finalSaveEvent()
    },
    finalSaveEvent() {
      // 临时存储设计数据
      let form = this._.clone(this.form)

      // 处理relaPId
      if (this.detail.relaPId && this.isSync) {
        form.relaPId = this.detail.relaPId
      } else {
        form.relaPId = undefined
      }

      let mapIds = []
      const allLayers = this.designerApi.getAllLayers()
      for (const item of allLayers) {
        if (item.mapId && !mapIds.includes(item.mapId)) {
          mapIds.push(item.mapId)
        }
      }

      form.mapIds = mapIds
      form.pId = this.detail.pId
      form.properVal = this.currentAttr.color + ":" + this.currentAttr.size
      form.ifNew = '01'
      form.reqId = 'save_' + new Date().getTime()
      form.proName = this.detail.proName
      form.checkedPics = this.checkedPics //为空表示单色
      this.formSet.push(form)
      
      if (!this.isScreenshotFinished) {
        this.msgError("请等待效果图渲染完成后再保存！")
        return
      }
      this.isScreenshotFinished = false

      if (this.isSubmit) {
        this.msgError("设计保存中...请稍等")
        return
      }
      this.isSubmit = true

      this.designerApi.setSaveOptions({
        skipEffectSave: true  //是否跳过效果图保存 (默认为 false)
      })
      // 自动保存模式 false（无弹窗），默认模式 true（有弹窗）
      this.designerApi.save({
        reqId: form.reqId,
        savePreview: false, 
      })
      this.startLoading()
    },
    // 保存的右侧菜单
    handleCommandMenu(command) {
      let url = ""
      if (command == "console") {
        url = "/index"
      } else if (command == "image") {
        url = "/map/map_mng/imageMe"
      } else if (command == "design") {
        url = "/select/selection/design"
      } else if (command == "list") {
        url = "/select/selection/list?pageNum=1&pageSize=30"
      } else if (command == "order") {
        url = "/order/myOrder/order"
      } else if (command == "cart") {
        url = "/order/myOrder/shopCart"
      } else if (command == "center") {
        url = "/system/account/userInfo"
      } else if (command == "exit") {
        this.handleLogOut()
        return
      }
      this.$router.push({
        path: url,
      })
    },
    // 退出登录
    handleLogOut() {
      this.$store.dispatch("LogOut").then(() => {
        if (this.user.userType == "00") {
          location.href = "/login_admin"
        } else {
          location.href = "/login"
        }
      })
    },
    // 获取图片列表
    handleChangeMenu(index) {
      this.currentMenu = index
      if (index == 1) {
        this.currentMaterial = 0
        this.$nextTick(() => {
          this.$refs["imageMe"].getData('designerNew')
        })
      } else if (index == 5) {
        // 更新图层列表
        this.updateLayers(this.currentObject.id)
      }
    },
    handleSelectMaterial(index) {
      this.currentMaterial = index
      this.$nextTick(() => {
        if (index == 0) {
          this.$refs["imageMe"].getData()
        }
        if (index == 1) {
          this.$refs["imageCommon"].getData()
        }
        if (index == 2) {
          this.$refs["imageShare"].getData()
        }
        if (index == 3) {
          this.$refs["imageOrder"].getData()
        }
      })
    },
    //*************** 图层操作 ***************
    // 复制设计
    handleCopyDesign() {
      if (!this.designDetail) return
      this.selectType = 'copy'
      this.productDialogVisible = true
    },
    // 添加图片
    handleAddImage(record) {
      let imageUrl = record.picUrl 
      if (record.picHeight >= record.picWidth && record.picHeight > 2000) {
        let width = Math.round((record.picWidth / record.picHeight) * 2000)
        imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
      }

      if (record.picWidth > record.picHeight && record.picWidth > 2000) {
        let height = Math.round((record.picHeight / record.picWidth) * 2000)
        imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
      }
      if (this.config.activePartLimitMode === 'text_only') {
        this.$message.error('当前设计面限制只能添加文字，无法添加图片')
        return
      }
      this.designerApi.addImage(imageUrl, record.mapId, record.picName)
    },
    // 选中图层
    handleSelectLayer(record, index) {
      this.designerApi.selectLayer(record.id)
      this.activeLayer = index
    },
    // 上移
    handleUp(layer) {
      // if (!layer.id) {
      //   this.$message.error('请选择图层！')
      //   return
      // }
      this.designerApi.layerUp(layer.id)
    },
    // 下移
    handleDown(layer) {
      // if (!layer.id) {
      //   this.$message.error('请选择图层！')
      //   return
      // }
      this.designerApi.layerDown(layer.id)
    },
    // 显示/隐藏
    handleVisible(layer, visible) {
      this.designerApi.setLayerVisibility(layer.id, visible)
    },
    // 锁定/解锁
    handleLock(lock, id) {
      this.designerApi.setLock(lock, id)
      this.designerApi.selectLayer(id) //用于更新图层数据
    },
    // 删除
    handleDelete(layer) {
      // if (!layer.id) {
      //   this.$message.error('请选择图层！')
      //   return
      // }
      this.designerApi.deleteLayer(layer.id)
    },
    // 背景色
    handleChangeBgColor(color, isCover) {
      if (color) {
        // 设置
        if (isCover) {
          this.designerApi.setBackgroundColor(color, true)//应用到所有面
        } else {
          this.designerApi.setBackgroundColor(color)
        }
      } else {
        // 删除
        this.designerApi.deleteBackgroundColor()
      }
      // console.log(color,isCover)
    },
    // 替换图片
    selectGallery(e) {
      // e.stopPropagation()
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      this.galleryVisible = true
    },
    getResult(data) {
      this.galleryVisible = false
      // replaceImage(url, id, mapId, picName)
      this.designerApi.replaceImage(data.picUrl, this.currentObject.id, data.mapId, data.picName)
    },
    // 最大化设计
    pm1() {
      if(this.config.locked) {
        return
      }
      if (this.config.maxSizeType === 'pageAll') {  //已经选中再选中
        this.designerApi.cancelObjectMaxSize('pageAll')
        this.config.maxSizeType = ''
        return
      }
      this.config.maxSizeType = 'pageAll'
      this.designerApi.setObjectMaxSize('pageAll')
    },
    // 铺满设计区域
    pm2() {
      if(this.config.locked) {
        return
      }
      if (this.config.maxSizeType === 'cutAll') {  //已经选中再选中
        this.designerApi.cancelObjectMaxSize('cutAll')
        this.config.maxSizeType = ''
        return
      }
      this.config.maxSizeType = 'cutAll'
      this.designerApi.setObjectMaxSize('cutAll')
    },
    // 高度最大化
    pm3() {
      if(this.config.locked) {
        return
      }
      if (this.config.maxSizeType === 'cutHeight') {  //已经选中再选中
        this.designerApi.cancelObjectMaxSize('cutHeight')
        this.config.maxSizeType = ''
        return
      }
      this.config.maxSizeType = 'cutHeight'
      this.designerApi.setObjectMaxSize('cutHeight')
    },
    // 宽度最大化
    pm4() {
      if(this.config.locked) {
        return
      }
      if (this.config.maxSizeType === 'cutWidth') {  //已经选中再选中
        this.designerApi.cancelObjectMaxSize('cutWidth')
        this.config.maxSizeType = ''
        return
      }
      this.config.maxSizeType = 'cutWidth'
      this.designerApi.setObjectMaxSize('cutWidth')
    },
    // 间距
    charSpacingChange() {
      if (this.config.charSpacing) {
        this.designerApi.setTextStyle({
          charSpacing: this.config.charSpacing,
        })
      }
    },
    // 行高
    lineHeightChange() {
      if (this.config.lineHeight) {
        this.designerApi.setTextStyle({
          lineHeight: this.config.lineHeight,
        })
      }
      
    },
    // 水平翻转
    handleFlipX() {
      if(this.config.locked) {
        return
      }
      this.designerApi.flip('x')
    },
    // 垂直翻转
    handleFlipY() {
      if(this.config.locked) {
        return
      }
      this.designerApi.flip('y')
    },
    // 逆时针45
    handleFlipCounterclockwise() {
      if(this.config.locked) {
        return
      }
      const value = this.config.rotate - 45
      this.config.rotate = value < -180 ? value + 360 : value
    },
    // 顺时针45
    handleFlipClockwise() {
      if(this.config.locked) {
        return
      }
      const value = this.config.rotate + 45
      this.config.rotate = value > 180 ? value - 360 : value
    },
    angleChange() {
      if (this.designerApi.rotate) {
        this.designerApi.rotate(this.config.rotate) //兼容初始化时页面渲染造成的调用
      }
    },
    // 平铺
    handleSelectTile(tileType) {
      if(this.config.locked) {
        return
      }
      if (this.config.isTile === tileType) {  //已经选中再选中
        this.designerApi.setPattern(null)
        this.config.isTile = ''
        this.config.showTileConfig = false
        return
      }
      this.designerApi.setPattern(tileType)
      this.config.isTile = tileType
      this.config.showTileConfig = true
    },
    handleTileGap() {
      this.designerApi.setPatternMargin({
        marginLeft: this.config.gapWidth, // 横向间距
        marginTop: this.config.gapHeight,  // 纵向间距
        marginSuo: false // 是否锁定比例
      })
    },
    // 位置与变换
    handleChangePos() {
      if(this.config.locked) {
        return
      }
      this.showPosPop = true
    },
    handleChangeLayer() {
      this.designerApi.setCoords({ 
        left: this.layerInfo.x, 
        top: this.layerInfo.y,
        width: this.layerInfo.w,
        height: this.layerInfo.h,
      })
    },
    updatePosition(type) {
      let layInfoData = null
      if (!type) {
        let layerInfoCache = Cookies.get("layerInfo")
        if (layerInfoCache) {
          layInfoData = JSON.parse(layerInfoCache)
        }
      } else {
        const index = type - 1
        let layerInfoCache = Cookies.get("moreLayerInfo")
        if (layerInfoCache) {
          layInfoData = JSON.parse(layerInfoCache)[index]?.data
        }
      }
      if (layInfoData) {
        this.layerInfo.x = layInfoData.x
        this.layerInfo.y = layInfoData.y
        this.layerInfo.w = layInfoData.w
        this.layerInfo.h = layInfoData.h
        this.designerApi.setCoords({ 
          left: this.layerInfo.x, 
          top: this.layerInfo.y,
          width: this.layerInfo.w,
          height: this.layerInfo.h,
        })
      } else {
        this.$message.error("还未设置坐标，请先设置再使用！")
      }
    },
    // 设置坐标
    handlePos() {
      let moreLayerInfo = {}
      let moreLayerInfoCache = Cookies.get("moreLayerInfo")
      if (moreLayerInfoCache) {
        moreLayerInfo = JSON.parse(moreLayerInfoCache)
      } else {
        moreLayerInfo = {}
      }
      const index = parseInt(this.posForm.posSort) - 1
      moreLayerInfo[index] = {
        label: this.posForm.posLabel,
        data: this.layerInfo
      }
      Cookies.set("moreLayerInfo", JSON.stringify(moreLayerInfo), { expires: 365 })
      this.setPosVisible = false
      this.layerPosInfoShow = JSON.parse(Cookies.get("moreLayerInfo"))//更新标签
      // 重置数据
      this.posForm.posSort = '1'
      this.posForm.posLabel = ''
      this.$message.success('设置成功！')
    },
    // 放大
    handleZoomin() {
      if(this.config.locked) {
        return
      }
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      this.designerApi.scaleLayer(0.1)  // 放大 10%
    },
    // 缩小
    handleZoomout() {
      if(this.config.locked) {
        return
      }
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      this.designerApi.scaleLayer(-0.1)  // 缩小 10%
    },
    // 透明
    handleShowOpacity() {
      if(this.config.locked) {
        return
      }
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      this.config.opacity = parseInt(this.config.opacity)
      this.components.showOpacityConfig = true
    },
    handleChangeOpacity() {
      this.designerApi.setOpacity(this.config.opacity / 100)
    },
    // 创建副本
    handleCopy() {
      if(this.config.locked) {
        return
      }
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      this.designerApi.copyLayer()
      this.msgSuccess("复制成功")
    },
    handleLockLayerSwitch() {
      if (!this.currentObject.id) {
        this.$message.error('请选择要操作的图层')
        return
      }
      if (this.config.locked) {
        // 锁定了，去解锁
        this.config.locked = false
        this.designerApi.setLock(false)
      } else {
        // 未锁定，去锁定
        this.config.locked = true
        this.designerApi.setLock(true)
      }
    },
    // 字体颜色
    handleSetTextColor() {
      this.components.colorPickerText = true
    },
    handleChangeColorText(color) {
      this.designerApi.setTextStyle({
        fill: color
      })
      this.config.backgroundColorText = color
    },
    // 可选字体
    getFontList() {
      this.fontList = this.designerApi.getFontList()
      this.fontList.forEach(font => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = font.url
        link.id = `font-${font.name}`
        document.head.appendChild(link)
        
        // 简单错误处理
        link.onerror = () => {
          console.warn(`字体 ${font.name} 加载失败`)
        }
      })
    },
    // 字体
    handleChangeFontType(value) {
      this.designerApi.setTextStyle({
        fontFamily: value
      })
      this.config.fontFamily = value
    },
    // 字体大小
    handleChangeFontSize(value) {
      this.designerApi.setTextStyle({
        fontSize: value
      })
      this.config.fontSize = value
    },
    // 加粗
    handleAddWeight() {
      if (this.config.fontWeight == "bold") {
        this.config.fontWeight = "normal"
      } else if (this.config.fontWeight == "normal") {
        this.config.fontWeight = "bold"
      }
      this.designerApi.setTextStyle({
        fontWeight: this.config.fontWeight
      })
    },
    // 斜体
    handleAddFontStyle() {
      if (this.config.fontStyle == "italic") {
        this.config.fontStyle = "normal"
      } else if (this.config.fontStyle == "normal") {
        this.config.fontStyle = "italic"
      }
      this.designerApi.setTextStyle({
        fontStyle: this.config.fontStyle
      })
    },
    // 文字对齐（左/中/右）
    handleSetTextAlign(value) {
      this.designerApi.setTextStyle({
        textAlign: value
      })
      this.config.textAlign = value
    },
    sleep(timemills) {
      return new Promise((resolve, reject) => {
        window.setTimeout(() => {
          resolve(1)
        }, timemills)
      })
    },
    // 待定的方法（不知道是否还有用）
    // 图片预览
    getSrc(blob) {
      return window.URL.createObjectURL(blob)
    },
    handlePickColor(color) {
      this.currentColor = color
      this.setProductImageList()
    },
    setProductImageList() {
      let images = []
      for (let record of this.previewImages) {
        if (record.color_name === this.currentColor) {
          images.push(record.blob)
        }
      }
      this.productImageList = images
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    handleShowDesignConfirm() {
      this.showSaveConfirm = true
    },
    reset() {
      if (document.querySelector(".child-content")) {
        document.querySelector(".child-content").style.padding = "12px"
      }
      if (document.querySelector(".el-header")) {
        document.querySelector(".el-header").style.display = "block"
      }
      document.getElementsByTagName("body")[0].style["overflow"] = "inherit"

      document.removeEventListener("click", this.clickEvent)
      // document.removeEventListener('keydown', this.handleKey)
      hotkeys.unbind()
    },
    handleOldDesigner() {
      localStorage.setItem("isNewDesignFlag", "2")
      this.$router.replace({
        path: "/design/online/designerOther",
        query: { ...this.$route.query }
      })
    },
    handleCheckAllChange(val) {
      this.checkedPics = val ? this.saveColorConfirmData : []
      this.isIndeterminate = false
    },
    handleCheckedPicChange(value) {
      let checkedCount = value.length
      this.isCheckColor = checkedCount === this.saveColorConfirmData.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.saveColorConfirmData.length
    },
    // async handleSaveKey() {
    //   this.unbindKey()
    //   let hotKey = this.userProfile.user.hotKey
    //   if (!hotKey) {
    //     hotKey = {}
    //   } else {
    //     hotKey = JSON.parse(this.userProfile.user.hotKey)
    //   }
    //   if (this.isApple) {
    //     hotKey.apple = this.keyConfig
    //   } else {
    //     hotKey.windows = this.keyConfig
    //   }
    //   let data = {
    //     userName: this.user.name,
    //     hotKey: JSON.stringify(hotKey),
    //   }
    //   let result = await setHotKey(data)
    //   this.msgSuccess("保存快捷键成功")
    //   this.setKey = false
    //   this.bindKey()
    // },
    // bindKey() {
    //   hotkeys("*", (event, handler) => {
    //     if (this.setKeyVisible && this.setKey) {
    //       event.preventDefault()
    //       console.log(event)

    //       let keys = []
    //       if (event.ctrlKey) {
    //         keys.push(this.isApple ? "control" : "ctrl")
    //         keys.push("+")
    //       }
    //       if (event.shiftKey) {
    //         keys.push("shift")
    //         keys.push("+")
    //       }
    //       if (event.altKey) {
    //         keys.push(this.isApple ? "options" : "alt")
    //         keys.push("+")
    //       }
    //       if (event.metaKey) {
    //         keys.push("command")
    //         keys.push("+")
    //       }
    //       if (
    //         event.key != "Control" &&
    //         event.key != "Shift" &&
    //         event.key != "Alt" &&
    //         event.key != "Meta"
    //       ) {
    //         keys.push(event.key.toLowerCase())
    //       }
    //       if (
    //         event.key == "Control" ||
    //         event.key == "Shift" ||
    //         event.key == "Alt" ||
    //         event.key == "Meta"
    //       ) {
    //         return
    //       }
    //       for (let record of this.keyConfig) {
    //         if (record.event != this.keyBox && record.text == keys.join("+")) {
    //           this.msgError(
    //             `快捷键与“${record.name}（${record.text}）”存在冲突，请重新设置`
    //           )
    //           return
    //         }
    //       }
    //       for (let record of this.keyConfig) {
    //         if (record.event == this.keyBox) {
    //           record.keys = keys
    //           record.text = keys.join("")
    //         }
    //       }
    //     }
    //   })
      
    //   for (let record of this.keyConfig) {
    //     let hotKey = record.text
    //     if (hotKey.indexOf("ctrl") > -1) {
    //       hotKey += "," + hotKey.replace("ctrl", "command")
    //     }
    //     if (hotKey.toLowerCase().indexOf("delete") > -1) {
    //       hotKey += "," + "backspace"
    //     }
    //     hotKey = hotKey.replace("options", "alt")
    //     hotKey = hotKey.replace("control", "ctrl")

    //     if (record.event == "enlarge") {
    //       console.log('hotKey: ',hotKey)
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleZoomin()
    //       })
    //     } else if (record.event == "copy") {
    //       hotkeys(hotKey, (event, handler) => {
    //         event.preventDefault()
    //         if (this.partMode == "2") {
    //           return
    //         }
    //         const object = this.designer.getActiveObject()
    //         if (object) {
    //           const objects = this.designer.getCurrentObjects()
    //           for (let i = 0; i < objects.length; i++) {
    //             if (objects[i].id == object.id) {
    //               this.config.copyIndex = object.id
    //               this.msgSuccess("复制成功")
    //               break
    //             }
    //           }
    //         }
    //       })
    //     } else if (record.event == "stick") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         if (this.partMode == "2") {
    //           return
    //         }
    //         const objects = this.designer.getCurrentObjects()
    //         for (let i = 0; i < objects.length; i++) {
    //           if (objects[i].id == this.config.copyIndex) {
    //             let object = objects[i]
    //             // this.designer.selectObject(object)
    //             // this.performAction({ name: "copy" })
    //           }
    //         }
    //         this.msgSuccess("粘贴成功")
    //       })
    //     } else if (record.event == "save") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleSaveDesign()
    //       })
    //     } else if (record.event == "undo") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleUndo()
    //       })
    //     } else if (record.event == "redo") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleRedo()
    //       })
    //     } else if (record.event == "delete") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.designerApi.deleteLayer(this.currentObject.id)
    //       })
    //     } else if (record.event == "reduce") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleZoomout()
    //       })
    //     } else if (record.event == "clear") {
    //       hotkeys(hotKey, (event, handler) => {
    //         // Prevent the default refresh event under WINDOWS system
    //         event.preventDefault()
    //         this.handleClearCanvas()
    //       })
    //     }
    //   }
    // },
    // unbindKey() {
    //   hotkeys.unbind()
    // },
    // handleCancelSetKey() {
    //   this.setKey = false
    // },
    // handleRestoreKeyConfig() {
    //   this.$confirm("该操作将所有快捷键恢复为默认值，是否继续？", "提示", {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: "是",
    //     cancelButtonText: "否",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.keyConfig = this.isApple
    //         ? JSON.parse(JSON.stringify(this.keyConfigApple))
    //         : JSON.parse(JSON.stringify(this.keyConfigDefault))

    //       this.handleSaveKey()
    //     })
    //     .catch((action) => {})
    // },
    // handleKey(event) {
    //   // console.log(event)
    //   if (event.key == 'Tab' || event.code == 'Tab') {
    //     if(event.target.className.indexOf('tab_per_pro')>-1) {
    //       event.preventDefault() // 阻止默认的Tab键行为
    //       // 根据当前焦点的位置，确定下一个焦点应该是什么
    //       var currentFocus = document.activeElement
    //       var fields = document.querySelectorAll('.tab_per_pro')
    //       var index = Array.prototype.indexOf.call(fields, currentFocus)
  
    //       if (index !== -1) {
    //           // 模拟限制范围为第一个到最后一个输入框
    //           var nextIndex = (index + 1) % fields.length
    //           fields[nextIndex].focus()
    //           const record = this.parts[nextIndex]
    //           // this.handleChangePart(record)
    //       }
    //     }
    //   }
    //   // if (event.key == 'Enter') { //回车
    //   //   if(event.target.className.indexOf('tab_per_pro')>-1) {
    //   //     const index = event.target.dataset.proindex
    //   //     const record = this.parts[index]
    //   //     this.handleChangePart(record)
    //   //   }
    //   // }
    // },
    // async init() {
    //   if (!this.designerUrlType) {
    //     let res = await getConfigKey("3ddesigner_switch")
    //     if (res.code == 200) {
    //       this.designerUrlType = res.msg
    //     }
    //   }
    //   this.designer = new window.Designer({
    //     id: "#designerDiv", // 挂载元素的ID
    //     // baseUrl: "https://www.onecust.cn/3ddesigner",
    //     baseUrl: this.designerUrlType == '02' ? "https://internal.temudiy.com/prod-api/server/product" : "https://www.onecust.cn/3ddesigner", //02缓存数据,01线上
    //     defaultScale: 1, // canvas默认缩放比例
    //     defaultBackgroundColor: "#ffffff",
    //     objectRemoved: (val) => {
    //       this.getCurrentObjects()
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //       this.getEmbroideryPrice()
    //     },
    //     objectCopied: (val) => {
    //       this.handleConfig(val)
    //       this.getCurrentObjects()
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //     },
    //     objectAdded: (val) => {
    //       this.handleConfig(val)
    //       this.getCurrentObjects()
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //       this.getEmbroideryPrice()
    //     },
    //     objectMoved: (val) => {
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //       this.handleConfig(val)
    //     },
    //     objectScaled: (val) => {
    //       this.handleConfig(val)
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //     },
    //     objectRotated: (val) => {
    //       this.getHistoryUndoLength()
    //       this.getHistoryRedoLength()
    //       this.handleConfig(val)
    //     },
    //     objectMouseDown: (val) => {
    //       console.log('objectMouseDown: ',val)
    //       // if (!val) {
    //       //   // this.currentBox = "product"
    //       //   this.currentObject = {}
    //       //   this.currentBox = ''
    //       //   this.currentMenu = 1  //没选中默认打开图库
    //       // } else {
    //         // this.currentObject = val
    //         // if (val.isEmbroideryText) {
    //         //   this.currentBox = "embroidery"
    //         // } else if (val.imageInfo && val.imageInfo.isEmbroideryImage) {
    //         //   this.currentBox = "embroideryImage"
    //         // } else if (val.type == "image" || val.type == "backgroundImage") {
    //         //   this.currentBox = "image"
    //         //   this.currentMenu = 6
    //         // } else if (val.type == "i-text") {
    //         //   this.currentBox = "text"
    //         //   this.currentMenu = 6
    //         // }
    //         this.handleConfig(val)
    //       // }
    //     },
    //     showMessage: (val) => {
    //       this.msgError(val.message)
    //     },
    //     canSaveDesigner: (val) => {
    //       this.canSaveDesigner = val
    //     },
    //   })
    //   if (this.detail.basicId) {
    //     await this.init2D(this.detail.basicId, "preview")
    //     let height = document.documentElement.clientHeight - 129
    //     this.toolBarHeight = height
    //   }
    // },
    // 菜单重置及设计数据回显(数据不全，无法全部回显)
    // handleConfig(object) {
    //   if (!object) {  
    //     this.currentObject = {}
    //     this.currentBox = ''
    //     this.currentMenu = 1  //没选中默认打开图库
    //     return
    //   }
    //   if (object.imageInfo && object.imageInfo.isEmbroideryText) {
    //     this.currentBox = "embroidery"
    //   } else if (object.imageInfo && object.imageInfo.isEmbroideryImage) {
    //     this.currentBox = "embroideryImage"
    //     //获取图层的颜色
    //     window.setTimeout(() => {
    //       if (this.layers.length > 0) {
    //         var objects = this.designer.getCurrentObjects()
    //         this.layers = JSON.parse(JSON.stringify(objects))
    //         this.embroideryImageInfo = this.layers[0].imageInfo
    //         let colorList = []
    //         for (let record of this.embroideryImageInfo.embroideryParams
    //           .colorList) {
    //           colorList.push(record.finalColor)
    //         }
    //         this.embroideryImageColorsOrigin = colorList
    //         this.embroideryImageColors = this._.clone(
    //           this.embroideryImageColorsOrigin
    //         )
    //       }
    //     }, 500)
    //   } else if (
    //     object.type == "image" ||
    //     object.type == "backgroundImage" ||
    //     object.type == "rect"
    //   ) {
    //     this.currentBox = "image"
    //   } else {
    //     this.currentBox = "text"
    //     this.config.fontSize = object.fontSize
    //     this.config.fontFamily = object.fontFamily
    //   }

    //   this.currentObject = object

    //   this.layerInfo.x = this.currentObject.left
    //   this.layerInfo.y = this.currentObject.top
    //   this.layerInfo.w = this.currentObject.width
    //   this.layerInfo.h = this.currentObject.height

    //   this.config.scale = this.currentObject.scale
    //   this.config.locked = this.currentObject.locked
    // },
    // getEmbroideryPrice() {
    //   const canvasList = this.designer.getFabricCanvasList()
    //   window.setTimeout(() => {
    //     this.embroideryPrice = 0
    //     canvasList.map((canvas) => {
    //       const objects = canvas.getObjects()
    //       if (canvas.IS_EMBROIDERY && objects.length) {
    //         this.embroideryPrice += canvas.EMBROIDERY_POSITION_INFO.CNY
    //       }
    //     })
    //   }, 500)
    // },
    /**
     * 获取图层
     */
    // getCurrentObjects() {
    //   // const objects = this.designer.getCurrentObjects()
    //   // this.layers = JSON.parse(JSON.stringify(objects))
    //   // this.layers = this.designerApi.getLayers()
    // },
    // async init2D(code, previewId) {
    //   // this.performAction({ name: "clearAll" })
    //   await this.sleep(500)
    //   await this.designer.init2D(code, previewId)
    //   this.get2DPreviewsData()
    //   this.getConfig()

    //   setTimeout(() => {
    //     const fabric = this.designer.getFabric()
    //     fabric.Object.prototype.controls.bl.offsetX = 11
    //     fabric.Object.prototype.controls.bl.offsetY = -15

    //     fabric.Object.prototype.controls.br.offsetX = -11
    //     fabric.Object.prototype.controls.br.offsetY = -15

    //     fabric.Object.prototype.controls.tl.offsetX = 11
    //     fabric.Object.prototype.controls.tl.offsetY = 10

    //     fabric.Object.prototype.controls.tr.offsetX = -11
    //     fabric.Object.prototype.controls.tr.offsetY = 10
    //   }, 1000)
    // },
    // handleSetBackgroundColor() {
    //   // if (!this.canChangeBackgroundColor) {
    //   //   this.$message.error('此产品因纹理和材质原因不支持更改背景颜色')
    //   //   return
    //   // }
    //   this.components.colorPicker = true
    // },
    // selectTextColor(color, idx) {
    //   this.textForm.color_name = color.name
    // },
    // selectImageColor(color, idx) {
    //   this.imageForm.color_name = color.name
    // },
    // async handleDeleteBackground(color) {
    //   this.designer.changeBackgroundColor(color)
    //   this.config.backgroundColor = color
    // },
    // beforeUpload() {},
    // handleSelectProduct(index) {
    //   this.currentProduct = index
    //   this.$nextTick(() => {
    //     if (index == 0) {
    //       this.$refs["product1"].getData()
    //     }
    //     if (index == 1) {
    //       this.$refs["product2"].getData()
    //     }
    //   })
    // },
    // handleSelectProductMenu(index) {
    //   this.currentProductMenu = index
    //   this.$nextTick(() => {
    //     this.$refs["product1"].getData()
    //   })
    // },
    // async handleChangeView(activeView) {
    //   this.activeView = activeView
    //   if (this.activeView == "3D") {
    //     this.startLoading()
    //     await this.designer.init3D()
    //     this.endLoading()
    //     return
    //   }
    //   this.startLoading()
    //   await this.designer.show2D()
    //   this.endLoading()
    // },
    // handleSelectUploadImage(index) {
    //   if (this.partMode == "1" && index == 1) {
    //     this.msgError("当前只能上传印花图片")
    //     return
    //   }
    //   if (this.partMode == "2" && index == 0) {
    //     this.msgError("当前只能上传刺绣图片")
    //     return
    //   }
    //   this.currentUploadImage = index
    //   this.$nextTick(() => {
    //     this.$refs["uploadHistory"].getData()
    //   })
    // },
    // handleSelectBackground(index) {
    //   this.currentBackground = index
    // },
    // handleSelectImage(index) {
    //   this.currentImage = index
    // },
    // handleShowImageDialog() {
    //   this.uploadImageVisible = true
    // },
    // getTreeNodeId() {},
    // async handleOper(index, object) {
    //   // const activeObject = object ? object : this.designer.getActiveObject()
    //   // if (activeObject) {
    //   //   this.designer.performAction({ name: index }, activeObject)
    //   // }
    //   // // this.preview()
    // },
    // async handleRotate(value) {
    //   // const activeObject = this.designer.getActiveObject()
    //   // if (activeObject) {
    //   //   this.designer.performAction(
    //   //     { name: "rotate", value: value },
    //   //     activeObject
    //   //   )
    //   //   // this.preview()
    //   // }
    // },
    // handleChangeCanvasSize() {
    //   let value = this.config.canvasSize - 50
    //   if (!this.designer) {
    //     return
    //   }
    //   this.designer.increaseCanvasSize(value)
    // },
    // handleRecoverCanvasSize() {
    //   this.config.canvasSize = 50
    //   let value = this.config.canvasSize - 50
    //   if (!this.designer) {
    //     return
    //   }
    //   this.designer.increaseCanvasSize(value)
    // },
    // handleAddCanvasSize() {
    //   this.config.canvasSize++
    //   let value = this.config.canvasSize - 50
    //   if (!this.designer) {
    //     return
    //   }
    //   this.designer.increaseCanvasSize(value)
    // },
    // handleMinusCanvasSize() {
    //   this.config.canvasSize--
    //   let value = this.config.canvasSize - 50
    //   if (!this.designer) {
    //     return
    //   }
    //   this.designer.increaseCanvasSize(value)
    // },
    
    // handlePickSize(size) {
    //   this.currentSize = size
    //   this.setProductImageList()
    // },
    
    // async updateEmbroideryImage() {
    //   try {
    //     const params = {}
    //     let embroideryParams = this.layers[0].imageInfo.embroideryParams
    //     debugger
    //     let color_list = embroideryParams.colorList
    //       ? embroideryParams.colorList
    //       : embroideryParams.color_list
    //     for (let i = 0; i < color_list.length; i++) {
    //       color_list[i].currentColor = this.embroideryImageColors[i]
    //     }

    //     params.id = embroideryParams.embroidery_id
    //     params.colorList = color_list
    //     await this.designer.updateEmbroideryImage(params)

    //     let layers = this.designer.getCurrentObjects()
    //     this.handleConfig(layers[0])
    //     // this.getCurrentObjects()
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // async handleShowPreview() {
    //   this.startLoading()
    //   this.previewImages = await this.designer.generateSamples([],null,800)
    //   this.previewImagesVisible = true
    //   console.log(this.previewImages)
    //   this.handlePickColor(this.colorList[0])

    //   this.$nextTick(() => {
    //     document.querySelector(".preview-list").scrollTop = 0
    //     this.handleClickPreviewImage(0)
    //     this.endLoading()
    //   })
    // },
    // handleReset3D() {
    //   this.designer.reset3DCamera()
    // },
    // exportCanvasAsPNG() {
    //   var canvasElement = document.getElementById("preview")
    //   var MIME_TYPE = "image/png"
    //   var imgURL = canvasElement.toDataURL(MIME_TYPE)
    //   var dlLink = document.createElement("a")
    //   dlLink.download = new Date().getTime()
    //   dlLink.href = imgURL
    //   dlLink.dataset.downloadurl = [
    //     MIME_TYPE,
    //     dlLink.download,
    //     dlLink.href,
    //   ].join(":")
    //   document.body.appendChild(dlLink)
    //   dlLink.click()
    //   document.body.removeChild(dlLink)
    // },
    // handleJumpDetail() {
    //   let routeUrl = this.$router.resolve({
    //     path: "/select/custom/product",
    //     query: { pId: this.detail.pId },
    //   })
    //   window.open(routeUrl.href, "_blank")
    // },
    // handleMyDesign() {
    //   let routeUrl = this.$router.resolve({
    //     path: "/select/selection/design",
    //   })
    //   window.open(routeUrl.href, "_blank")
    // },
    // async performAction(obj) {
    // //   await this.designer.performAction(obj)
    // },
    // async handleAddBackground(record) {
    //   // let imageObject1 = await this.designer.setBackgroundImage({
    //   //   _image_id: record.mapId,
    //   //   name: record.picName,
    //   //   url: record.picUrl,
    //   //   width: record.picWidth,
    //   //   height: record.picHeight,
    //   //   originalUrl: record.picUrl,
    //   // })
    //   // this.designer.performAction({ name: "maximize" }, imageObject1)
    // },
    // init2DColor() {
    //   if (!this.designer) return
    //   const colors = this.designer.get2DColors() || [];
    //   if (colors.length) {
    //     this.designer.change2DColor(colors[0].name)
    //   }
    //   const canChangeBackgroundColor = this.designer.canChangeBackgroundColor()

    //   this.canChangeBackgroundColor = canChangeBackgroundColor
    // },
    // async handleChangeColor(color, isCover) {
    //   if (isCover) {
    //     await this.designer.toggleAllApplyBackgroundColor(color)
    //   } else {
    //     await this.designer.changeBackgroundColor(color)
    //   }
    //   this.config.backgroundColor = color
    // },
    // handleChangeEmbroideryFontType() {
    //   if (this.textForm.font_type == "2d") {
    //     this.embroideryFontList = this.textFontList
    //     this.textForm.font_family = "Block2"
    //   } else {
    //     this.embroideryFontList = this.textFontList3D
    //     this.textForm.font_family = "3D Futuro"
    //   }
    // },
    // handleAddEmbroideryText() {
    //   if (this.textForm.text == "") {
    //     this.msgError("请输入文字")
    //     return
    //   }
    //   //判断合法
    //   if (/[\u4e00-\u9fa5]/.test(this.textForm.text)) {
    //     this.msgError("暂不支持中文")
    //     return
    //   }
    //   // this.performAction({ name: "clear", backgroundColor: "" })
    //   // this.designer.addEmbroideryText(this.textForm)
    //   this.uploadTextVisible = false
    // },
    // async handleCopyPart() {
    //   if (this.config.partConfig == "1") {
    //     for (let record of this.parts) {
    //       if (record.name.indexOf("Left") > -1) {
    //         await this.designer.mirrorTo(
    //           record.name,
    //           record.name.replace("Left", "Right"),
    //           true
    //         )
    //         await this.designer.allFlipX(record.name.replace("Left", "Right"))
    //       }
    //     }
    //     this.msgSuccess("镜像成功")
    //   } else if (this.config.partConfig == "2") {
    //     for (let record of this.parts) {
    //       if (record.name.indexOf("Right") > -1) {
    //         await this.designer.mirrorTo(
    //           record.name,
    //           record.name.replace("Right", "Left"),
    //           true
    //         )
    //         await this.designer.allFlipX(record.name.replace("Right", "Left"))
    //       }
    //     }
    //     this.msgSuccess("镜像成功")
    //   } else if (
    //     this.config.partConfig == "3" &&
    //     this.config.toParts.length == 0
    //   ) {
    //     this.msgError("请选择需要复制的刀版")
    //   } else {
    //     for (let record of this.config.toParts) {
    //       if (record == this.config.activePart) {
    //         continue
    //       }
    //       await this.designer.mirrorTo(this.config.activePart, record, true)
    //     }
    //     this.msgSuccess("镜像成功")
    //   }
    // },
    // 获取当前画布的背景图
    // getBackgroundImageObject() {
    //   // return this.designer.getBackgroundImageObject()
    // },
    // showTileConfig() {
    //   this.config.showTileConfig = true
    // },
    // limitLines() {
    //   let text = this.textForm.text

    //   let b = text.indexOf("\n")
    //   var num = 0
    //   while (b !== -1) {
    //     num++
    //     b = text.indexOf("\n", b + 1)
    //   }
    //   if (num >= 2) {
    //     let index = text.lastIndexOf("\n")
    //     this.textForm.text =
    //       text.substring(0, index) + text.substring(index + 1, text.length)
    //   }
    // },
    // handleShowLayer() {
    //   this.components.showLayer = !this.components.showLayer
    // },
    // handleCloseLayer() {
    //   this.components.showLayer = false
    // },
    /**
     * 切换2d颜色列表
     */
    // change2DColor(color) {
    //   this.designer.change2DColor(color)
    // },
    // change3DColor(color) {
    //   this.designer.change3DColor(color)
    // },
    /**
     * 获取2d缩略图列表
     */
    // get2DPreviewsData() {
    //   let result = this.designer.get2DPreviewsData()
    //   this.previewsData = result
    // },
    /**
     * 切换2d预览视图
     */
    // change2DPreview(partName) {
    //   this.designer.change2DPreview(partName)
    // },
    // handleChangePart(record) {
    //   if (record.is_copied) {
    //     this.msgError("复制图层不支持切换")
    //     return
    //   }
    //   this.currentPart = record
    //   this.designer.changePart(record.name)
    //   // this.change2DPreviewByPart(record.name)
    //   this.config.activePart = record.name
    //   // this.getAllLayers()
    //   //获取背景
    //   const backgroundColor = this.designer.getCurrentCanvasBackgroundColor()
    //   this.config.backgroundColor = backgroundColor
    // },
    // handleChangePartBySwitch() {
    //   if (!this.currentConfig.support_printing && this.partMode == "1") {
    //     this.partMode = "2"
    //     this.msgError("当前产品不支持印花")
    //     return
    //   }
    //   if (!this.currentConfig.support_embroidery && this.partMode == "2") {
    //     this.partMode = "1"
    //     this.msgError("当前产品不支持刺绣")
    //     return
    //   }

    //   let partName1 = ""
    //   let partName2 = ""
    //   for (let record of this.parts) {
    //     if (!partName1 && !record.support_embroidery) {
    //       partName1 = record
    //     }
    //     if (!partName2 && record.support_embroidery) {
    //       partName2 = record
    //     }
    //   }
    //   if (this.partMode == "1") {
    //     this.handleChangePart(partName1)
    //     this.designer.toggleControlStyle(false)
    //     this.currentUploadImage = 0
    //     this.handleSelectUploadImage(0)
    //   } else {
    //     this.handleChangePart(partName2)
    //     this.currentUploadImage = 1
    //     this.designer.toggleControlStyle(true)
    //     this.handleSelectUploadImage(1)
    //   }
    //   if (this.currentMenu == 1) {
    //     this.handleChangeMenu(1)
    //   }
    // },
    /**
     * 根据刀板名称切换2d预览视图
     */
    // change2DPreviewByPart(partName) {
    //   this.designer.change2DPreviewByPart(partName)
    // },
    // handleSetColor(index) {
    //   this.setColorVisible = true
    //   this.imageForm.color_name = this.embroideryImageColors[index]
    //   this.imageForm.color_index = index
    // },
    // handleAddEmbroideryImageColor() {
    //   this.setColorVisible = false
    //   this.embroideryImageColors[
    //     this.imageForm.color_index
    //   ] = this.imageForm.color_name
    //   this.updateEmbroideryImage()
    // },
    /**
     * 获取刀板
     */

    // getConfig() {
    //   const config = this.designer.getConfig()
    //   this.parts = JSON.parse(JSON.stringify(config.parts))
    //   if (!config.support_printing) {
    //     this.partMode = "2"
    //     this.currentUploadImage = 1
    //     this.currentProductMenu = 1
    //     this.designer.toggleControlStyle(true)
    //     this.handleSelectProductMenu(1)
    //     // this.currentMaterial = 3
    //     // this.handleSelectMaterial(3)
    //   } else {
    //     this.partMode = "1"
    //     this.currentUploadImage = 0
    //     this.currentProductMenu = 0
    //     this.designer.toggleControlStyle(false)
    //     // this.handleSelectProductMenu()
    //     // this.currentMaterial = 0
    //     // this.handleSelectMaterial(0)
    //   }
    //   this.currentPart = this.parts[0]
    //   this.config.activePart = this.parts[0].name
    //   this.currentConfig = config
    //   this.psd_params = this.parts[0].psd_params
    //   // this.$nextTick(() => {
    //   //   this.$refs["uploadHistory"].getData()
    //   // })
    // },
    // handleDownloadPart() {
    //   // if (this.config.downloadPart == "") {
    //   //   this.msgError("请选择刀板")
    //   //   return
    //   // }
    //   let basicId = this.detail.basicId
    //   let index = basicId.indexOf("-")
    //   if (index != -1) {
    //     basicId = basicId.substring(0, index)
    //   }
    //   window.open(
    //     `https://3ddesigner.oss-cn-hongkong.aliyuncs.com/${basicId}/Knives/BusinessKnives.zip`,
    //     "_blank"
    //   )
    // },
    // handleSelectPart(record) {
    //   this.config.downloadPart = record.title
    // },
    // 获取后退历史记录列表长度
    // getHistoryRedoLength() {
    //   setTimeout(() => {
    //     const length = this.designer.getHistoryRedoLength()
    //     this.config.redoLength = length
    //   }, 500)
    // },
    // 获取前进历史记录列表长度
    // getHistoryUndoLength() {
    //   // setTimeout(() => {
    //   //   const length = this.designer.getHistoryUndoLength()
    //   //   this.config.undoLength = length
    //   // }, 500)
    // },
    // handleChangePreview(index) {
    //   // this.change2DPreview(this.previewsData[index].preview_name)
    // },
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    // getEmbroideryPriceRange() {
    //   let embroideryNumMax = 0
    //   this.embroideryNum = 1
    //   let embroideryList = this.detail.embroideryList
    //   if (embroideryList) {
    //     embroideryNumMax = embroideryList[embroideryList.length - 1].highNum
    //     this.embroideryDiscountPrice = embroideryList[0].discount * 10
    //   }
    //   this.embroideryNumMax = embroideryNumMax
    // },
    // handleChangeEmbroideryNum() {
    //   if (this.detail.embroideryList) {
    //     for (let record of this.detail.embroideryList) {
    //       if (
    //         this.embroideryNum >= record.lowNum &&
    //         this.embroideryNum <= record.highNum
    //       ) {
    //         this.embroideryDiscountPrice = record.discount * 10
    //         break
    //       }
    //     }
    //   }
    // },
    // handleLockLayer(lock) {
    //   // if (lock) {
    //   //   this.performAction({ name: "lock" }, this.designer.getActiveObject())
    //   //   this.config.locked = true
    //   // } else {
    //   //   this.performAction({ name: "unlock" }, this.designer.getActiveObject())
    //   //   this.config.locked = false
    //   // }
    //   // this.getCurrentObjects()
    // },
//     handleCopyColor() {
//       var text = `
// 【值: "#171717", 颜色: "black"】
// 【值: "#ffffff", 颜色: "white"】
// 【值: "#a1a1a1", 颜色: "grey"】
// 【值: "#9c6a23", 颜色: "brown"】
// 【值: "#d82424", 颜色: "red"】
// 【值: "#ee6419", 颜色: "orange"】
// 【值: "#50b03c", 颜色: "green"】
// 【值: "#035239", 颜色: "darkGreen"】
// 【值: "#192c7c", 颜色: "blue"】
// 【值: "#3f92db", 颜色: "sky"】
// 【值: "#934b7c", 颜色: "purple"】
// 【值: "#ffde00", 颜色: "yellow"】`
//       let target = document.createElement("input") //创建input节点
//       target.value = text // 给input的value赋值
//       document.body.appendChild(target)
//       target.value = text // 修改文本框的内容
//       target.select() // 选中文本
//       document.execCommand("copy") // 执行浏览器复制命令
//       this.msgSuccess("复制成功")
//       document.body.removeChild(target)
//     },
    // async handleSetBackground() {
    //   // if (this.config.isSetBackground) {
    //   //   await this.handleUnTile()  //取消平铺
    //   //   const activeObject = this.designer.getActiveObject()
    //   //   if (!activeObject) return
    //   //   this.designer.performAction(
    //   //     {
    //   //       name: "tile",
    //   //       gapWidth: 0,
    //   //       gapHeight: 0,
    //   //     },
    //   //     activeObject
    //   //   )
    //   // } else {
    //   //   const activeObject = this.designer.getActiveObject()
    //   //   if (!activeObject) return
    //   //   await this.designer.performAction({ name: "untile" }, activeObject)
    //   //   this.designer.removeBackgroundImage()
    //   // }
    // },
    // convertCanvasToImage(canvas) {
    //   if (canvas) {
    //     let imageBase64 = canvas.toDataURL("image/png", 1)
    //     return imageBase64
    //   }
    //   return ""
    // },
    // selcetPreview(index) {
    //   this.previewIndex = index
    //   // this.handleChangePreview(index)
    // }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/custom.css";

#deCreateNew {
  color: #495b6e;
  // position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .logo {
    width: 118px;
  }
  .main-panel {
    // padding: 0 10vw 0px 10vw;
    padding: 0;
    background-color: #f0f2f5;
    box-sizing: border-box; 
    height: 100%;
    // overflow: hidden;
    .base-quality-check {
      top: -36px!important;
    }
  }
  @media screen and (min-width: 2000px) {
    // .main-panel {
    //   padding: 0 20vw 0px 20vw;
    // }
    .view-img {
      left: calc(20vw - 90px) !important;
    }
    .bg-color-set {
      right: calc(20vw - 58px) !important;
    }
  }
  .canvas-item__canvas-wrap {
    top: calc(50%);
    transform: translateY(-50%);
    position: absolute;
  }
  background: #ffffff;
  .main {
    overflow: hidden;
    font-size: 13px;
    color: #666;
    flex: 1;
    display: flex;
    flex-direction: row;
    bottom: 0;
    position: relative;

    .left-panel {
      // width: 390px;
      width: 410px;
      padding: 0 0 8px 0;
      box-sizing: border-box;
      background: #ffffff;

      ::v-deep .search {
        padding: 0 8px 0 0;
      }

      .header {
        padding: 8px 0px 16px 0px;
        border-bottom: 1px dashed #e5e5e5;
        .button {
          height: 36px;
          border: solid 1px #d9d9d9;
          border-radius: 4px;
          padding: 10px 18px;
          color: #666;
          display: inline-block;
          font-size: 14px;
          line-height: 14px;
          cursor: pointer;
          margin-right: 16px;
          box-sizing: border-box;
        }
        :last-child {
          margin-right: 0px;
        }
        .is-select {
          background-color: #4934b2;
          color: #fff;
          cursor: default;
        }
      }

      .content {
        padding: 10px 0 0 9px;

        ::v-deep .classify {
          padding: 16px 8px 0 0;
        }

        ::v-deep .result {
          flex: 1;
          overflow: hidden;
          position: relative;
          padding-bottom: 20px;

          .result-content {
            height: calc(100vh - 246px);
            overflow: auto;
            padding: 0 0 8px 0;
            margin: 8px 0 23px 0;
          }
          .active {
            border: 1px solid #4934b2 !important;
          }

          .item {
            width: 95px;
            height: 95px;
            float: left;
            margin-top: 9px;
            margin-left: 8px;
            position: relative;
            border: solid 1px #e5e5e5;
            box-sizing: border-box;
            border-radius: 5px;

            img {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 5px;
            }
          }
          .item:hover {
            // box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
            border: 1px solid #4934b2 !important;
          }
          .result-content :nth-child(3n + 1) {
            margin-left: 0px;
          }
        }
        ::v-deep .pagination {
          width: 100%;
          height: 44px;
          position: absolute;
          left: 0px;
          right: 0;
          bottom: 0;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-pagination__total {
            margin-right: 0px;
          }
          .btn-prev {
            padding-right: 0px;
          }
          .btn-next {
            padding-left: 0px;
          }
          .el-pagination__jump {
            margin-left: 8px;
          }
          .el-pagination .el-select .el-input {
            width: 86px;
          }
        }
      }
      .menu {
        overflow: hidden;
        margin: 0 0 16px 0;
        .menu-item {
          float: left;
          margin: 0 21px 0 0;
          padding: 0 0 4px 0;
          width: 56px;
          text-align: center;
          box-sizing: border-box;
          cursor: pointer;
        }
        .menu-item-select {
          border-bottom: 2px solid #4934b2;
        }
      }
      .upload-button {
        margin: 0 0 0px 0;
      }
    }
    .simple-designer {
      flex: auto;
      position: relative;
      box-sizing: border-box;
      background-color: #f0f5ff;
      overflow: hidden;
      // padding-top: 6vh;
      padding-top: 0;

      .toolbar {
        margin: 12px 0 0 0;
        text-align: center;
        .thirdly-designer-icon {
          font-size: 26px !important;
          color: #666;
        }
        .operation-list {
          overflow: hidden;
          margin: 0 auto;
          display: inline-block;
          .base-icon-button {
            float: left;
            margin: 0 16px 0 0;
          }
        }
      }
    }
    .simple-designer__content {
      padding: 2% 0;
      margin: 0 auto;
      max-width: calc(100vh - 154px - 4%);
      box-sizing: border-box;
    }
    .right-panel {
      width: 330px;
      background: #ffffff;
      padding: 0 0 0 0;
      position: relative;
      .layer-list {
        width: 100%;
        padding: 0 8px 0 8px;
        box-sizing: border-box;
        max-height: 220px;
        overflow-y: auto;
        .layer-item {
          overflow: hidden;
          line-height: 36px;
          border: 1px dashed grey;
          padding: 0px 8px 0px 8px;
          margin-bottom: 8px;
          box-sizing: border-box;
          .image-wrap {
            float: left;
            margin: 0 8px 4px 0;
            img {
              width: 32px;
              height: 32px;
              vertical-align: middle;
            }
          }
          .layer-name {
            float: left;
            font-size: 14px;
          }
          .layer-tools {
            float: right;
            i {
              margin-right: 5px;
            }
          }
        }
      }
      .thumb {
        margin: 0 0 10px 0;
        padding: 2px 0 0 0;
        box-sizing: border-box;
        width: 100%;
        border: 1px solid #f6f6f6;
        box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px 0 rgb(0 0 0 / 8%),
          0 3px 6px -4px rgb(0 0 0 / 12%);
        img {
          width: 70%;
        }
        .name {
          font-size: 16px;
          text-align: center;
        }
      }
      .price {
      }
      .buttons {
        text-align: right;
        margin: 8px 8px 16px 0;
        padding: 6px 0px 14px 0;
        border-bottom: 1px solid #f0f5ff;
      }

      .appearance-button {
        overflow: hidden;
        margin: 0 8px 12px 16px;
        ul {
          float: left;
        }
      }

      .color-picker-list li,
      .color-picker-list-hover li,
      .mgg-preview-colors li {
        background-color: #fff;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: #d6d2d2 solid 1px;
        margin-left: 2px;
        padding: 1px;
        float: left;
      }

      .color-picker-list li.cur,
      .mgg-preview-colors li.cur,
      .size-picker-list li.cur {
        border: #4934b2 solid 2px;
      }

      .color-picker-list li a,
      .color-picker-list-hover li a,
      .mgg-preview-colors li a {
        width: 24px;
        height: 24px;
        display: table;
      }

      .size-button {
        overflow: hidden;
        margin: 0 8px 0 0;
        .size-picker-list {
          float: left;
          margin: 0 0 8px 16px;
        }
      }

      .size-button .size-picker-list li {
        margin: 0px 4px 4px 4px;
        cursor: pointer;
        display: inline-block;
        border-style: solid;
        border-width: 1px;
        padding: 0 4px;
        border-color: rgb(219, 219, 219);
        border-radius: 2px;
        background-color: rgb(253, 253, 253);
        min-width: 40px;
        height: 24px;
        line-height: 22px;
        text-align: center;
      }

      .size-button .size-picker-list li.cur {
        border: 2px solid #4934b2;
        color: #4934b2;
      }
    }
    .el-carousel__item {
      text-align: center;
      cursor: zoom-in;
    }
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ddd;
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ffffff;
  }
  .el-carousel__button {
    width: 7px;
    height: 7px;
    border-radius: 8px;
    background: #8f8f90;
  }
  .el-carousel__indicator.is-active button {
    background: #4934b2;
  }
  .preview-area {
    overflow: hidden;
    .carousel {
      width: 600px;
      float: left;
      .el-carousel__item {
        text-align: center;
      }
      .el-carousel__container {
        height: 500px;
      }
      img {
        width: 500px;
        height: 500px;
      }
    }
    .preview-list {
      width: 130px;
      float: left;
      height: 500px;
      margin: 0 0 0 16px;
      overflow-y: auto;
      .preview-list-item {
        border: 1px solid #e5e5e5;
        margin: 0 8px 15px 0;
        box-sizing: border-box;
        width: 111px;
        height: 111px;
        position: relative;
        cursor: pointer;
        .preview-text {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          text-align: center;
          width: 100%;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          padding: 0.05rem 0;
          font-size: 0.14rem;
          z-index: 10;
          font-size: 14px;
        }
        &:hover .preview-text {
          display: block;
        }
        &.is-active .preview-text {
          display: block;
          background: #4934b2;
        }
      }

      img {
        width: 109px;
        height: 109px;
      }
      .is-active {
        border: 1px solid #4934b2;
      }
    }
    .color-picker {
      overflow: hidden;
      margin: 16px 8px 0 0;
      ul {
        overflow: hidden;
        padding: 0px 0 0 266px;
      }
    }

    .color-picker-list li,
    .color-picker-list-hover li {
      background-color: #fff;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: #d6d2d2 solid 1px;
      margin-left: 2px;
      padding: 1px;
      float: left;
    }
    .color-picker-list li.cur {
      border: #4934b2 solid 2px;
    }
    .color-picker-list li a,
    .color-picker-list-hover li a {
      width: 24px;
      height: 24px;
      display: table;
    }
  }
  .left-panel {
    display: flex;
    .toolbar {
      width: 65px;
      height: calc(100vh - 75px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: center;
      padding-top: 9px;
      background-color: #fff;
      z-index: 1;
      .tool-item {
        height: 62px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 18px;
        cursor: pointer;
      }
      .menu-item {
        font-size: 29px;
        margin: 0 auto;
      }
      .active {
        color: #4934b2;
        background-color: #d2e7f7;
      }
    }
    .content {
      // width: 320px;
      width: 345px;
      height: calc(100vh - 70px);
      overflow: hidden;
      background: #fff;
      transition: all 0.3s;
      opacity: 1;
    }
  }
  .f24 {
    font-size: 24px !important;
    line-height: 32px;
  }
  .product {
    height: 100%;
  }
  .row-name {
    padding: 0 20px 13px 20px;
    font-size: 16px;
    border-bottom: 1px solid #f0f5ff;
    overflow: hidden;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    padding: 14px 20px 13px 20px;
  }
  .row-name .code {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    white-space: nowrap;
    display: flex;
  }
  .row-name .price {
    font-size: 16px;
    color: #fa8c16;
  }
  .row-name > .container {
    display: flex;
    justify-content: space-between;
  }
  .row-size {
    .title {
      line-height: 24px;
      padding: 8px 20px 5px 20px;
      font-size: 14px;
    }
    border-bottom: 1px solid #f0f5ff;
  }
  .product-name {
    float: left;
  }
  .product-price {
    float: right;
    color: #fa8c16;
  }
  .el-color-picker__trigger {
    height: 36px;
    width: 36px;
  }
  // 位置与变换
  .position-operate-pop {
    position: fixed;
    top: 300px;
    left: 470px;
    z-index: 200;
    box-shadow: 1px 1px 12px #ccc;
    user-select: none;
    font-size: 13px;
    .tit {
      width: 260px;
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f6f6f6;
      box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, .06);
      cursor: move;
      .btn {
        padding: 5px;
        cursor: pointer;
      }
    }
    .container {
      width: 260px;
      padding: 15px 13px;
      background: #fff;
      .zw-unit-input {
        // display: inline-block;
        // position: relative;
        // width: 105px;
        .zw-unit-input-tit {
          text-align: center;
          margin-bottom: 2px;
          font-weight: bold;
        }
      }
      .zw-position {
        .el-button {
          margin-bottom: 6px;
          width: 70px;
          padding-left: 0;
          padding-right: 0;
          &:nth-child(3n+1) {
            margin-left: 0px;
          }
        }
      }
    }
  }

}

.zwdesign-header {
  flex: none;
  height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(31, 93, 145, 0.1);
  box-shadow: 0 0 10px 0 rgba(31, 93, 145, 0.1);
}

.zwdesign-header .zwdesign-header--left {
  min-width: 150px;
  width: auto;
  padding: 0 15px;
  display: flex;
  // align-items: center;
}

.zwdesign-header .zwdesign-header--left .logo {
  font-size: 34px;
  color: #3d47bf;
}

.zwdesign-header .dividing-line {
  width: 1px;
  height: 28px;
  margin-left: 10px;
  margin-right: 10px;
  background: rgba(0, 0, 0, 0.15);
}

.zwdesign-header .zwdesign-header--center {
  display: flex;
  height: 100%;
  // min-width: 450px;
  // min-width: 240px;
  flex: 1;
  padding: 0;
}

.zwdesign-header .zwdesign-header--center .line {
  width: 1px;
  height: 100%;
  margin-right: 10px;
  margin-left: 10px;
}

[data-theme="default"] .zwdesign-header .zwdesign-header--center .line {
  background-color: #ddd !important;
}

// [data-theme="dark"] .zwdesign-header .zwdesign-header--center .line,
// [data-theme="light"] .zwdesign-header .zwdesign-header--center .line {
// }

.zwdesign-header .zwdesign-header--center .left-toolbar {
  // flex: 1 0 auto;
  display: flex;
  align-items: center;
}

.zwdesign-header .zwdesign-header--center .right-toolbar {
  flex: none;
  display: flex;
}

.zwdesign-header .zwdesign-header--center .toolbar-item {
  margin-top: 5px;
  cursor: pointer;
  text-align: center;
  // padding: 0 10px;
  padding: 0 7px;
  font-size: 12px;
  font-weight: 400;
}

[data-theme="default"] .zwdesign-header .zwdesign-header--center .toolbar-item {
  color: #495b6e !important;
}

[data-theme="dark"] .zwdesign-header .zwdesign-header--center .toolbar-item,
[data-theme="light"] .zwdesign-header .zwdesign-header--center .toolbar-item {
  color: !important;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .iconbox {
  padding: 5px;
  background: transparent;
  border-radius: 5px;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .icon {
  font-size: 16px;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .toolbar-item-text {
  font-weight: 400;
}

.zwdesign-header .zwdesign-header--center .toolbar-item.active .iconbox {
  background: #f0f5ff;
}

.zwdesign-header .zwdesign-header--center .toolbar-item.active .icon,
.zwdesign-header
  .zwdesign-header--center
  .toolbar-item.active
  .toolbar-item-text {
  color: #4934b2;
}

.zwdesign-header .zwdesign-header--right {
  flex: none;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  .toolbar-item {
    color: #495b6e;
    font-size: 12px;
    width: 52px;
    text-align: center;
    &:hover {
      color: #4934b2;
      .toolbar-item-text {
        color: #4934b2;
      }
    }
  }
}

.zwdesign-header .zwdesign-header--right .save-record {
  // margin-right: 24px;
  margin-right: 12px;
  outline: 0;
}

.zwdesign-header .zwdesign-header--right .save-record,
.zwdesign-header .zwdesign-header--right .shopping-cart {
  display: inline-block;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  position: relative;
  margin-left: 8px;
}

.zwdesign-header .zwdesign-header--right .save-record .dot,
.zwdesign-header .zwdesign-header--right .shopping-cart .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
  position: absolute;
  right: 19px;
  top: 10px;
}

.zwdesign-header .zwdesign-header--right .save-record .border-r,
.zwdesign-header .zwdesign-header--right .shopping-cart .border-r {
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}

.zwdesign-header .zwdesign-header--right .save-record.active,
.zwdesign-header .zwdesign-header--right .shopping-cart.active {
  color: #4934b2;
}

// .zwdesign-header .zwdesign-header--right .dividing-line {
//   width: 1px;
//   height: 28px;
//   background: rgba(0, 0, 0, 0.15);
// }

.save-btn-content {
  min-width: 68px;
  height: 32px;
  line-height: 32px;
  color: #ffffff;
  // margin: 0 0 0 20px;
  margin: 0 0 0 12px;
}

.save-btn-content .save-btn {
  min-width: 68px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 24px;
  padding: 0 8px;
}

[data-theme="default"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #fff !important;
}

[data-theme="light"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #414141 !important;
}

[data-theme="dark"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #a7a7a7 !important;
}

[data-theme="default"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  background-color: #4934b2 !important;
}

[data-theme="dark"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn,
[data-theme="light"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  background-color: !important;
}

.zwdesign-header .zwdesign-header--right .save-btn-content .buynow-btn {
  min-width: 90px;
  margin-left: 10px;
}

.zwdesign-header .zwdesign-header--right .login-btn {
  color: rgba(0, 0, 0, 0.15);
  font-size: 32px;
  cursor: pointer;
  margin-left: 20px;
}

.zwdesign-header .zwdesign-header--right .merchant-name {
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 550;
  font-size: 14px;
  cursor: pointer;
  padding: 15px 0;
  margin-left: 20px;
}

.zwdesign-header .zwdesign-header--right .merchant-name span {
  display: inline-block;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zwdesign-header .zwdesign-header--right .merchant-name i.arrow {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 550;
}

@media screen and (max-width: 1450px) {
  .zwdesign-header .zwdesign-header--right.logined .login-btn,
  .zwdesign-header .zwdesign-header--right.logined .merchant-name,
  .zwdesign-header .zwdesign-header--right.logined .save-btn,
  .zwdesign-header .zwdesign-header--right.logined .save-record,
  .zwdesign-header .zwdesign-header--right.logined .shopping-cart {
    margin-left: 10px;
  }

  .zwdesign-header .zwdesign-header--right.logined .save-record {
    margin-right: 10px;
  }
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconnav_logo:before {
  content: "\e68c";
}

.iconmember-o-mian:before {
  content: "\e686";
}

.iconcustom-label:before {
  content: "\e7b7";
}

.iconicon-label_overtime-payment:before {
  content: "\e7b4";
}

.iconicon-label_ontimeship1:before {
  content: "\e7b5";
}

.iconicon-ontimeship:before {
  content: "\e7b3";
}

.iconcolumn-reduction:before {
  content: "\e7b2";
}

.iconalign:before {
  content: "\e7b1";
}

.iconrotate-right:before {
  content: "\e7ad";
}

.iconrotate-left:before {
  content: "\e7ae";
}

.iconfile-copy:before {
  content: "\e7af";
}

.iconbg:before {
  content: "\e7b0";
}

.iconleft-down-deformed:before {
  content: "\e7a7";
}

.icondrag-up:before {
  content: "\e7ac";
}

.iconbtn-add:before {
  content: "\e7a6";
}

.icondrag-left:before {
  content: "\e7a8";
}

.iconbtn-Less:before {
  content: "\e7a9";
}

.iconfloating-window:before {
  content: "\e7aa";
}

.iconreduction:before {
  content: "\e7ab";
}

.iconenlarge:before {
  content: "\e7a5";
}

.iconsetting:before {
  content: "\e7a3";
}

.iconfolder:before {
  content: "\e7a4";
}

.iconclose-fill:before {
  content: "\e7a1";
}

.iconrevoke-fill:before {
  content: "\e7a2";
}

.iconmember-level4:before {
  content: "\e799";
}

.iconmember-o-level2:before {
  content: "\e79d";
}

.iconmember-o-level1:before {
  content: "\e79e";
}

.iconmember-o-level4:before {
  content: "\e79f";
}

.iconmember-o-level3:before {
  content: "\e7a0";
}

.iconqq1:before {
  content: "\e7b6";
}

.iconweixing:before {
  content: "\e87a";
}

.icondrop-out:before {
  content: "\e79c";
}

.iconfolder-open-fill:before {
  content: "\e798";
}

.iconsave-fill:before {
  content: "\e79a";
}

.iconshopping-cart:before {
  content: "\e79b";
}

.iconicon_90degree:before {
  content: "\e600";
}

.iconicon_180degree:before {
  content: "\e601";
}

.iconicon_45degree:before {
  content: "\e602";
}

.iconbtn-lock:before {
  content: "\e797";
}

.iconcaveat-triangle-fill:before {
  content: "\e796";
}

.icondisable-redline:before {
  content: "\e795";
}

.iconstraw:before {
  content: "\e794";
}

.iconalign-center:before {
  content: "\e78c";
}

.iconalign-both:before {
  content: "\e78d";
}

.iconalign-left1:before {
  content: "\e78e";
}

.iconfont-size1:before {
  content: "\e78f";
}

.iconfont-slanted:before {
  content: "\e790";
}

.iconalign-right:before {
  content: "\e791";
}

.iconfont-underscore:before {
  content: "\e792";
}

.iconfont-strikethrough:before {
  content: "\e793";
}

.iconavatar:before {
  content: "\e78a";
}

.iconfree:before {
  content: "\e78b";
}

.iconselected:before {
  content: "\e789";
}

.iconCertification:before {
  content: "\e787";
}

.iconPromotion:before {
  content: "\e788";
}

.iconmember-level2:before {
  content: "\e784";
}

.iconmember-level1:before {
  content: "\e785";
}

.iconmember-level3:before {
  content: "\e786";
}

.iconcaveat-circle-fill:before {
  content: "\e782";
}

.iconcaveat-circle:before {
  content: "\e783";
}

.iconclose-bold:before {
  content: "\e780";
}

.iconselect-bold:before {
  content: "\e781";
}

.iconlabel_promotion:before {
  content: "\e77d";
}

.iconlabel_select:before {
  content: "\e77e";
}

.iconlabel_prerogative:before {
  content: "\e77f";
}

.iconbtn-delete:before {
  content: "\e77b";
}

.iconbtn-sync:before {
  content: "\e77c";
}

.iconungroup:before {
  content: "\e779";
}

.icongroup:before {
  content: "\e77a";
}

.iconinfo-circle-fill:before {
  content: "\e778";
}

.iconfont-column-skip:before {
  content: "\e777";
}

.icontoggle:before {
  content: "\e7c3";
}

.iconlogo1:before {
  content: "\e7c2";
}

.iconheart:before {
  content: "\e7df";
}

.iconheart-fill:before {
  content: "\e849";
}

.iconzoom-out1:before {
  content: "\e684";
}

.iconmenu:before {
  content: "\e7f4";
}

.iconrotate-right45:before {
  content: "\e7b9";
}

.iconrotate-left45:before {
  content: "\e7ba";
}

.iconarrawsalt:before {
  content: "\e7e9";
}

.iconfullscreen1:before {
  content: "\e7ec";
}

.iconcolum-height:before {
  content: "\e7ef";
}

.iconcolumn-width1:before {
  content: "\e7fc";
}

.iconzuoyoufanzhuan_huaban1:before {
  content: "\e65f";
}

.iconchuizhifanzhuan_huaban1:before {
  content: "\e660";
}

.iconicon_new:before {
  content: "\e603";
}

.iconic_amazon:before {
  content: "\e61e";
}

.iconcustomer:before {
  content: "\e7b8";
}

.iconnav_logo:before {
  content: "\e68c";
}

.iconmember-o-mian:before {
  content: "\e686";
}

.iconcustom-label:before {
  content: "\e7b7";
}

.iconicon-label_overtime-payment:before {
  content: "\e7b4";
}

.iconicon-label_ontimeship1:before {
  content: "\e7b5";
}

.iconicon-ontimeship:before {
  content: "\e7b3";
}

.iconcolumn-reduction:before {
  content: "\e7b2";
}

.iconalign:before {
  content: "\e7b1";
}

.iconrotate-right:before {
  content: "\e7ad";
}

.iconrotate-left:before {
  content: "\e7ae";
}

.iconfile-copy:before {
  content: "\e7af";
}

.iconbg:before {
  content: "\e7b0";
}

.iconleft-down-deformed:before {
  content: "\e7a7";
}

.icondrag-up:before {
  content: "\e7ac";
}

.iconbtn-add:before {
  content: "\e7a6";
}

.icondrag-left:before {
  content: "\e7a8";
}

.iconbtn-Less:before {
  content: "\e7a9";
}

.iconfloating-window:before {
  content: "\e7aa";
}

.iconreduction:before {
  content: "\e7ab";
}

.iconenlarge:before {
  content: "\e7a5";
}

.iconsetting:before {
  content: "\e7a3";
}

.iconfolder:before {
  content: "\e7a4";
}

.iconclose-fill:before {
  content: "\e7a1";
}

.iconrevoke-fill:before {
  content: "\e7a2";
}

.iconmember-level4:before {
  content: "\e799";
}

.iconmember-o-level2:before {
  content: "\e79d";
}

.iconmember-o-level1:before {
  content: "\e79e";
}

.iconmember-o-level4:before {
  content: "\e79f";
}

.iconmember-o-level3:before {
  content: "\e7a0";
}

.iconqq1:before {
  content: "\e7b6";
}

.iconweixing:before {
  content: "\e87a";
}

.icondrop-out:before {
  content: "\e79c";
}

.iconfolder-open-fill:before {
  content: "\e798";
}

.iconsave-fill:before {
  content: "\e79a";
}

.iconshopping-cart:before {
  content: "\e79b";
}

.iconicon_90degree:before {
  content: "\e600";
}

.iconicon_180degree:before {
  content: "\e601";
}

.iconicon_45degree:before {
  content: "\e602";
}

.iconbtn-lock:before {
  content: "\e797";
}

.iconcaveat-triangle-fill:before {
  content: "\e796";
}

.icondisable-redline:before {
  content: "\e795";
}

.iconstraw:before {
  content: "\e794";
}

.iconalign-center:before {
  content: "\e78c";
}

.iconalign-both:before {
  content: "\e78d";
}

.iconalign-left1:before {
  content: "\e78e";
}

.iconfont-size1:before {
  content: "\e78f";
}

.iconfont-slanted:before {
  content: "\e790";
}

.iconalign-right:before {
  content: "\e791";
}

.iconfont-underscore:before {
  content: "\e792";
}

.iconfont-strikethrough:before {
  content: "\e793";
}

.iconavatar:before {
  content: "\e78a";
}

.iconfree:before {
  content: "\e78b";
}

.iconselected:before {
  content: "\e789";
}

.iconCertification:before {
  content: "\e787";
}

.iconPromotion:before {
  content: "\e788";
}

.iconmember-level2:before {
  content: "\e784";
}

.iconmember-level1:before {
  content: "\e785";
}

.iconmember-level3:before {
  content: "\e786";
}

.iconcaveat-circle-fill:before {
  content: "\e782";
}

.iconcaveat-circle:before {
  content: "\e783";
}

.iconclose-bold:before {
  content: "\e780";
}

.iconselect-bold:before {
  content: "\e781";
}

.iconlabel_promotion:before {
  content: "\e77d";
}

.iconlabel_select:before {
  content: "\e77e";
}

.iconlabel_prerogative:before {
  content: "\e77f";
}

.iconbtn-delete:before {
  content: "\e77b";
}

.iconbtn-sync:before {
  content: "\e77c";
}

.iconungroup:before {
  content: "\e779";
}

.icongroup:before {
  content: "\e77a";
}

.iconinfo-circle-fill:before {
  content: "\e778";
}

.iconfont-column-skip:before {
  content: "\e777";
}

.iconlogo:before {
  content: "\e776";
}

.iconnum-c6:before {
  content: "\e759";
}

.iconnum-c3:before {
  content: "\e761";
}

.iconarrow-left-bold:before {
  content: "\e775";
}

.iconalign-left:before {
  content: "\e71e";
}

.iconarrow-down-bold:before {
  content: "\e71f";
}

.iconarrow-right-bold:before {
  content: "\e720";
}

.iconarrow-up-bold:before {
  content: "\e721";
}

.iconborder-outer:before {
  content: "\e722";
}

.iconborder-aider:before {
  content: "\e723";
}

.iconbright:before {
  content: "\e724";
}

.iconborder-info:before {
  content: "\e725";
}

.iconcaret-down:before {
  content: "\e726";
}

.iconcanvas-recovery:before {
  content: "\e727";
}

.iconcanvas-expend:before {
  content: "\e728";
}

.iconcaret-more:before {
  content: "\e729";
}

.iconcaret-right:before {
  content: "\e72b";
}

.iconcolumn-height:before {
  content: "\e72c";
}

.iconcontrol-fill:before {
  content: "\e72d";
}

.iconcolumn-paved:before {
  content: "\e72e";
}

.iconcontrol:before {
  content: "\e72f";
}

.iconcolumn-max:before {
  content: "\e731";
}

.iconcolumn-width:before {
  content: "\e732";
}

.icondelete:before {
  content: "\e733";
}

.iconcutout:before {
  content: "\e734";
}

.iconcrop:before {
  content: "\e735";
}

.icondistribute-level:before {
  content: "\e736";
}

.icondistribute-plumb:before {
  content: "\e737";
}

.icondistributed-bottom:before {
  content: "\e738";
}

.icondistributed-left:before {
  content: "\e739";
}

.icondistributed-center:before {
  content: "\e73a";
}

.icondistributed-left-bottom:before {
  content: "\e73b";
}

.icondistributed-right-top:before {
  content: "\e73c";
}

.iconeye-close:before {
  content: "\e73d";
}

.iconfile-add-to:before {
  content: "\e73e";
}

.iconfilter:before {
  content: "\e73f";
}

.iconfile-add:before {
  content: "\e740";
}

.iconfont-column-width:before {
  content: "\e741";
}

.iconeye-open:before {
  content: "\e742";
}

.iconfont-column-height:before {
  content: "\e743";
}

.iconcanvas-compress:before {
  content: "\e744";
}

.iconpicture-fill:before {
  content: "\e745";
}

.iconfont-vertical:before {
  content: "\e746";
}

.iconinfo-circle:before {
  content: "\e747";
}

.iconunlock:before {
  content: "\e748";
}

.iconzoom:before {
  content: "\e749";
}

.iconzoom-out:before {
  content: "\e74a";
}

.iconnum-c1:before {
  content: "\e74b";
}

.iconupload-fill:before {
  content: "\e74c";
}

.iconkeyboard:before {
  content: "\e74d";
}

.icontext-fill:before {
  content: "\e74e";
}

.iconview-layers:before {
  content: "\e74f";
}

.iconmore:before {
  content: "\e750";
}

.iconsort-Irregular:before {
  content: "\e751";
}

.iconImport:before {
  content: "\e752";
}

.iconmorefill:before {
  content: "\e753";
}

.iconsorting:before {
  content: "\e754";
}

.iconsymmetry-level:before {
  content: "\e755";
}

.iconzoom-in:before {
  content: "\e756";
}

.iconlock-fill:before {
  content: "\e757";
}

.iconsync:before {
  content: "\e758";
}

.iconquestion-fill:before {
  content: "\e75a";
}

.icontext:before {
  content: "\e75b";
}

.iconfullscreen-exit:before {
  content: "\e75c";
}

.iconnum-c4:before {
  content: "\e75d";
}

.iconquestion:before {
  content: "\e75e";
}

.iconforward:before {
  content: "\e75f";
}

.iconskin:before {
  content: "\e760";
}

.iconskin-fill:before {
  content: "\e762";
}

.iconpicture:before {
  content: "\e763";
}

.iconfont-size:before {
  content: "\e764";
}

.iconnum-c5:before {
  content: "\e765";
}

.iconguidelines:before {
  content: "\e766";
}

.iconunlock-fill:before {
  content: "\e767";
}

.iconlock:before {
  content: "\e768";
}

.iconview-layers-fill:before {
  content: "\e769";
}

.iconupload:before {
  content: "\e76a";
}

.iconsort-neat:before {
  content: "\e76b";
}

.iconlayers:before {
  content: "\e76c";
}

.iconnum-c2:before {
  content: "\e76d";
}

.iconsymmetry-vertical:before {
  content: "\e76e";
}

.iconfullscreen:before {
  content: "\e76f";
}

.iconbackward:before {
  content: "\e770";
}

.icondistributed-left-top:before {
  content: "\e771";
}

.icondistributed-right-bottom:before {
  content: "\e772";
}

.icondistributed-right:before {
  content: "\e773";
}

.icondistributed-top:before {
  content: "\e774";
}

.iconlogo:before {
  content: "\e776";
}

.iconnum-c6:before {
  content: "\e759";
}

.iconnum-c3:before {
  content: "\e761";
}

.iconarrow-left-bold:before {
  content: "\e775";
}

.iconalign-left:before {
  content: "\e71e";
}

.iconarrow-down-bold:before {
  content: "\e71f";
}

.iconarrow-right-bold:before {
  content: "\e720";
}

.iconarrow-up-bold:before {
  content: "\e721";
}

.iconborder-outer:before {
  content: "\e722";
}

.iconborder-aider:before {
  content: "\e723";
}

.iconbright:before {
  content: "\e724";
}

.iconborder-info:before {
  content: "\e725";
}

.iconcaret-down:before {
  content: "\e726";
}

.iconcanvas-recovery:before {
  content: "\e727";
}

.iconcanvas-expend:before {
  content: "\e728";
}

.iconcaret-more:before {
  content: "\e729";
}

.iconbrush:before {
  content: "\e72a";
}

.iconcaret-right:before {
  content: "\e72b";
}

.iconcolumn-height:before {
  content: "\e72c";
}

.iconcontrol-fill:before {
  content: "\e72d";
}

.iconcolumn-paved:before {
  content: "\e72e";
}

.iconcontrol:before {
  content: "\e72f";
}

.iconcolumn-max:before {
  content: "\e731";
}

.iconcolumn-width:before {
  content: "\e732";
}

.icondelete:before {
  content: "\e733";
}

.iconcutout:before {
  content: "\e734";
}

.iconcrop:before {
  content: "\e735";
}

.icondistribute-level:before {
  content: "\e736";
}

.icondistribute-plumb:before {
  content: "\e737";
}

.icondistributed-bottom:before {
  content: "\e738";
}

.icondistributed-left:before {
  content: "\e739";
}

.icondistributed-center:before {
  content: "\e73a";
}

.icondistributed-left-bottom:before {
  content: "\e73b";
}

.icondistributed-right-top:before {
  content: "\e73c";
}

.iconeye-close:before {
  content: "\e73d";
}

.iconfile-add-to:before {
  content: "\e73e";
}

.iconfilter:before {
  content: "\e73f";
}

.iconfile-add:before {
  content: "\e740";
}

.iconfont-column-width:before {
  content: "\e741";
}

.iconeye-open:before {
  content: "\e742";
}

.iconfont-column-height:before {
  content: "\e743";
}

.iconcanvas-compress:before {
  content: "\e744";
}

.iconpicture-fill:before {
  content: "\e745";
}

.iconfont-vertical:before {
  content: "\e746";
}

.iconinfo-circle:before {
  content: "\e747";
}

.iconunlock:before {
  content: "\e748";
}

.iconzoom:before {
  content: "\e749";
}

.iconzoom-out:before {
  content: "\e74a";
}

.iconnum-c1:before {
  content: "\e74b";
}

.iconupload-fill:before {
  content: "\e74c";
}

.iconkeyboard:before {
  content: "\e74d";
}

.icontext-fill:before {
  content: "\e74e";
}

.iconview-layers:before {
  content: "\e74f";
}

.iconmore:before {
  content: "\e750";
}

.iconsort-Irregular:before {
  content: "\e751";
}

.iconImport:before {
  content: "\e752";
}

.iconmorefill:before {
  content: "\e753";
}

.iconsorting:before {
  content: "\e754";
}

.iconsymmetry-level:before {
  content: "\e755";
}

.iconzoom-in:before {
  content: "\e756";
}

.iconlock-fill:before {
  content: "\e757";
}

.iconsync:before {
  content: "\e758";
}

.iconquestion-fill:before {
  content: "\e75a";
}

.icontext:before {
  content: "\e75b";
}

.iconfullscreen-exit:before {
  content: "\e75c";
}

.iconnum-c4:before {
  content: "\e75d";
}

.iconquestion:before {
  content: "\e75e";
}

.iconforward:before {
  content: "\e75f";
}

.iconskin:before {
  content: "\e760";
}

.iconskin-fill:before {
  content: "\e762";
}

.iconpicture:before {
  content: "\e763";
}

.iconfont-size:before {
  content: "\e764";
}

.iconnum-c5:before {
  content: "\e765";
}

.iconguidelines:before {
  content: "\e766";
}

.iconunlock-fill:before {
  content: "\e767";
}

.iconlock:before {
  content: "\e768";
}

.iconview-layers-fill:before {
  content: "\e769";
}

.iconupload:before {
  content: "\e76a";
}

.iconsort-neat:before {
  content: "\e76b";
}

.iconlayers:before {
  content: "\e76c";
}

.iconnum-c2:before {
  content: "\e76d";
}

.iconsymmetry-vertical:before {
  content: "\e76e";
}

.iconfullscreen:before {
  content: "\e76f";
}

.iconbackward:before {
  content: "\e770";
}

.icondistributed-left-top:before {
  content: "\e771";
}

.icondistributed-right-bottom:before {
  content: "\e772";
}

.icondistributed-right:before {
  content: "\e773";
}

.icondistributed-top:before {
  content: "\e774";
}
.iconcustomer:before {
  content: "\e7b8";
}

.product-detail-box {
  font-size: 14px;
  .save-record-cont {
    padding: 10px;
    cursor: pointer;
    font-size: 12px;
    &:hover {
      color: #4934b2;
    }
    i {
      margin-left: 4px;
    }
  }
}

.product-detail-box > div {
  display: flex;
  flex-direction: column;
}
.embroidery-text .el-form-item {
  margin-bottom: 16px !important;
}
.embroidery-text .el-form {
  margin-bottom: 0 !important;
}
#deCreateNew {
  .row-info {
    line-height: 45px;
    border-bottom: 1px solid #f0f5ff;
  }
  .product-detail-box .details {
    flex: 1;
    padding: 0 20px;
    border-top: 1px solid #f0f5ff;
  }

  .add-text-btn {
    width: calc(100% - 20px);
    height: 40px;
    background: #f0f5ff;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .remark-box {
    margin-top: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #495b6e;

    a {
      color: #4934b2;
    }
  }

  .upload-title {
    color: #000;
    font-size: 14px;
  }
  .zwdesign-header .zwdesign-header--center .line {
    background-color: #ddd !important;
  }
  .tool-item {
    color: #495b6e;
    &:hover {
      color: #4934b2;
    }
  }
  .tool-item a {
    color: #495b6e;
    &:hover {
      color: #4934b2;
    }
  }
  .toolbar-item {
    color: #495b6e;
    &:hover {
      color: #4934b2;
      .toolbar-item-text {
        color: #4934b2;
      }
    }
  }
  // .sku-attr {
  //   overflow: hidden;
  //   padding: 0 0 0 8px;
  //   .sku-name {
  //     margin: 0 32px 0 0;
  //   }
  //   .sku-detail {
  //     margin: 5px 0 0 0;
  //   }
  // }
  // .sku-color {
  //   margin: 0 8px 0 0;
  //   border: 1px solid #aaaaaa;
  //   cursor: pointer;
  //   min-width: 30px;
  //   height: 30px;
  //   line-height: 30px;
  //   display: inline-block;
  //   text-align: center;
  //   transition: all 0.5s ease-in-out;
  //   border: 3px solid transparent;
  //   box-shadow: 0 0 0 1px #ddd;
  // }
  // .sku-size {
  //   color: #333;
  //   font-size: 12px;
  //   font-weight: 400;
  //   line-height: 30px;
  //   text-transform: capitalize;
  //   display: inline-block;
  //   margin: 0;
  //   min-width: 30px;
  //   overflow: hidden;
  //   text-align: center;
  //   background-color: #f9f9f9;
  //   border-radius: 7px;
  //   transition: all 0.5s ease-in-out;
  //   padding: 0 6px;
  //   margin: 0 8px 5px 0;
  //   border: 3px solid transparent;
  //   box-shadow: 0 0 0 1px #ddd;
  //   cursor: pointer;
  //   box-sizing: border-box;
  // }

  // .is-select {
  //   border: 3px solid #f25551;
  //   box-shadow: none;
  // }
  .ml4 {
    margin-left: 4px !important;
  }
  .ml15 {
    margin-left: 15px !important;
  }
  .ml40 {
    margin-left: 40px !important;
  }
  .ml80 {
    margin-left: 80px !important;
  }
  .ml60 {
    margin-left: 60px !important;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .mb8 {
    margin-bottom: 8px;
  }
  .mb10 {
    margin-bottom: 10px;
  }
  .mr5 {
    margin-right: 5px;
  }
  .mr12 {
    margin-right: 12px;
  }
  .mr16 {
    margin-right: 16px;
  }
  .mr23 {
    margin-right: 23px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .cp {
    cursor: pointer;
  }
  .flex-col-ct {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
  }
  .flex-col-start {
    align-items: flex-start;
  }
  .flex,
  .flex-col {
    display: flex;
  }
  .flex-row-between {
    justify-content: space-between;
  }
  .flex-row-end {
    justify-content: flex-end;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .f14 {
    font-size: 14px;
    line-height: 22px;
  }
  .f20 {
    font-size: 20px;
    line-height: 28px;
  }

  .gallery-detail-box > .inner-content {
    padding-bottom: 40px;
  }

  .gallery-detail-box.el-checkbox__label {
    padding-left: 8px !important;
  }

  .gallery-detail-box .ajustment-pannel {
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    flex-direction: column;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-title {
    flex: none;
    height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-title
    .ajustment-pannel-title--left {
    display: flex;
    align-items: center;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-title
    .ajustment-pannel-title--left
    .title {
    margin: 0 6px;
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont {
    padding: 20px 26px;
    overflow-y: auto;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont .render-box {
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem:nth-child(5n) {
    margin-right: 0;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img {
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #f0f5ff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img.active {
    border: 2px solid #4934b2;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img
    img {
    border-radius: 5px;
    max-width: 100%;
    max-height: 100%;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-name {
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    color: #37474f;
    line-height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 80px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-name:hover {
    color: #4934b2;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item {
    width: 233px;
    height: 70px;
    padding: 10px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item.el-input__inner {
    height: 24px !important;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-desc {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-desc
    .label {
    color: #37474f;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-slide {
    width: 100%;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont .path-box {
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item {
    width: 80px;
    height: 80px;
    background: #f0f5ff;
    border-radius: 5px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 2px solid transparent;
    padding: 20px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item:nth-child(2n) {
    margin-right: 0;
  }

  [data-theme="default"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active {
    border: 2px solid #4934b2 !important;
  }

  [data-theme="dark"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active,
  [data-theme="light"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active {
    border: 2px solid #fff !important;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item
    img {
    width: 100%;
    height: 100%;
  }

  .gallery-detail-box .icon-box32 {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .gallery-detail-box .icon-caret-more {
    position: relative;
  }

  .gallery-detail-box .icon-caret-more:after {
    position: absolute;
    font-family: iconfont !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    right: 0;
    bottom: 0;
    content: "\e729";
  }

  .gallery-detail-box .label {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
  }

  [data-theme="default"] .gallery-detail-box .label {
    color: #000 !important;
  }

  [data-theme="dark"] .gallery-detail-box .label,
  [data-theme="light"] .gallery-detail-box .label {
    color: !important;
  }

  .gallery-detail-box .img-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .gallery-detail-box .img-info .img-info--left {
    align-items: center;
    height: 50px;
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box .img-info .img-info--left .imgName {
    min-width: 80px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .gallery-detail-box .img-info .img-info--left .imgSize {
    display: none;
  }

  .gallery-detail-box .img-info .img-info--right {
    color: #4934b2;
  }

  .gallery-detail-box .img-info .img-info--right .img-replace-tip-icon {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    vertical-align: -2px;
    margin-left: 1px;
  }

  .gallery-detail-box .img-info .img-info--right .img-replace-tip-icon.blue {
    color: #4934b2;
  }

  .gallery-detail-box .operation-content {
    padding: 5px 20px;
  }

  .gallery-detail-box .operation-content .operation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gallery-detail-box .operation-content .operation-item .operation-item-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50px;
    color: #000;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 40px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    position: relative;
    padding: 0 4px;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item {
    display: flex;
    flex-direction: column;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item
    .icon {
    height: 32px;
    width: 32px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item
    .icon.active {
    background: #e1edff;
    color: #4934b2;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item:hover {
    background: #e6e6e6;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item.active {
    background: #f0f5ff;
  }

  // .tileway-pop {
  //   width: 100%;
  //   position: absolute;
  //   top: 160px;
  //   left: 0;
  //   z-index: 99;
  //   background: #fff;
  //   box-shadow: 0 9px 28px 8px rgba(0, 0, 0, 0.05),
  //     0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
  //   border-radius: 5px;
  // }

  .opacity-pop {
    // width: 100%;
    width: 96%;
    position: absolute;
    // top: 43px;
    top: 114px;
    // left: 0;
    left: 2%;
    z-index: 99;
    background: #fff;
    box-shadow: 0 9px 28px 8px rgba(221, 212, 212, 0.05),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }

  .gallery-detail-box .operation-content .operation-item2 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 40px;
  }

  .gallery-detail-box .operation-content .operation-item2 .item {
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    flex: 1;
    height: 100%;
    cursor: pointer;
    outline: none;
  }

  .gallery-detail-box .operation-content .operation-item2 .item.checked {
    background: #f0f5ff;
    color: #4934b2;
  }

  .gallery-detail-box .operation-content > div:not(:last-child) {
    margin-bottom: 2px;
  }

  .gallery-detail-box .item-box--suspend {
    width: 100%;
    bottom: 0;
    z-index: 10;
    padding: 0 20px;
  }

  .gallery-detail-box .item-box--suspend .opt-box {
    height: 40px;
    border-radius: 5px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.03);
    position: relative;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item.active {
    background: #f0f5ff;
    color: #4934b2;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item:hover {
    background: #e6e6e6;
  }

  .view-list-container {
    box-shadow: 0 5px 12px 4px rgba(0, 0, 0, 0.09),
      0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 1px 2px -2px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    padding: 10px 0;
  }

  .view-list-container .view-item {
    text-align: center;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }

  .view-list-container .view-item:hover {
    background: #f0f5ff;
  }

  .zw-message-pop .dialog-content {
    padding-left: 26px;
  }

  .zw-message-pop .dialog-content .switch-con {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    margin-bottom: 10px;
  }

  .zw-message-pop .dialog-content .tip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
  }
  div {
    box-sizing: border-box;
  }
  .gallery-detail-box {
    font: 12px/1 sans-serif;
  }
  .pl20 {
    padding-left: 20px !important;
  }
  .pr20 {
    padding-right: 20px !important;
  }
  .ml10 {
    margin-left: 10px !important;
  }

  .text-detail-box .el-slider__button {
    width: 12px;
    height: 12px;
  }

  .text-detail-box .icon-box32 {
    width: 38px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .text-detail-box .icon-box32:hover {
    border: 1px solid rgba(0, 0, 0, 0.45);
  }

  .text-detail-box .icon-box32:before {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  .text-detail-box .label {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
  }

  [data-theme="default"] .text-detail-box .label {
    color: #000 !important;
  }

  [data-theme="dark"] .text-detail-box .label,
  [data-theme="light"] .text-detail-box .label {
    color: !important;
  }

  .text-detail-box .img-info {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .text-detail-box .img-info .img-info--right {
    color: #1f96f8;
  }

  .text-detail-box .img-info .img-info--left .textSize {
    display: none;
  }

  .text-detail-box .img-info .img-info--left .textName {
    max-width: 120px;
  }

  .text-detail-box .operation-content {
    padding: 15px 20px;
  }

  .text-detail-box .operation-content .operation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .text-detail-box .operation-content .operation-item .operation-item-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50px;
    color: #000;
  }

  .text-detail-box .operation-content .operation-item .operation-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 40px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    position: relative;
    padding: 0 4px;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    outline: none;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item:hover {
    background: #e6e6e6;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item.active {
    background: #e1edff;
    color: #4934b2;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .selectItem
    .icon {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    width: 16px;
    height: 16px;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .selectItem
    .icon.rotate90 {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }

  .text-detail-box .operation-content > div:not(:last-child) {
    margin-bottom: 12px;
  }

  .text-detail-box .item-box--suspend {
    width: 100%;
    bottom: 0;
    z-index: 10;
    padding: 0 20px;
  }

  .text-detail-box .item-box--suspend .opt-box {
    height: 40px;
    border-radius: 5px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.03);
    background: rgba(0, 0, 0, 0.03);
    position: relative;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item.active {
    background: #f0f5ff;
    color: #4934b2;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item:hover {
    background: #e6e6e6;
  }

  .text-detail-box .align-box ul.box {
    list-style: none;
    width: 145px;
    height: 98px;
  }

  .text-detail-box .align-box ul.box li {
    float: left;
  }

  .text-detail-box .align-box ul.box li:first-child span {
    border-top-left-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(3) span {
    border-top-right-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(7) span {
    border-bottom-left-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(9) span {
    border-bottom-right-radius: 5px;
  }

  .text-detail-box .align-box ul.box li span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 34px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin-left: -1px;
    margin-top: -1px;
  }

  .text-detail-box .align-box ul.box li span:hover {
    position: relative;
    border: 2px solid #02a7f0;
    color: #02a7f0;
    z-index: 100;
  }

  .text-detail-box .align-box .box:after {
    content: "";
    height: 0;
    visibility: hidden;
    clear: both;
    display: block;
  }

  .text-detail-box .align-box .align-type {
    display: flex;
    width: 38px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #e0e5ea;
  }

  .text-detail-box .align-box .align-type:not(.zw-disabled):hover {
    border: 2px solid #02a7f0;
  }

  .text-detail-box .fontShap-box .el-input .el-input__inner {
    height: 20px;
    line-height: 20px;
  }

  .bg-color-set {
    position: absolute;
    right: calc(10vw - 58px);
    top: 6vh;
    width: 42px;
    height: 198px;
    background: #e0e4ee;
    border-radius: 5px;
  }

  .view-img {
    position: absolute;
    left: calc(10vw - 90px);
    top: 6vh;
    z-index: 1;
    padding: 6px 5px 23px 6px;
    background: #e0e4ee;
    border-radius: 6px;
    max-height: calc(100vh - 49px);
    overflow-y: auto;
  }
  .view-img li {
    width: 60px;
    height: 60px;
    position: relative;
    box-sizing: initial;
    background: #fff;
    border-radius: 3px;
    padding: 6px;
    box-sizing: border-box;
  }
  .view-img li.active {
    border: 1px solid #4934b2;
  }
  .view-img li img {
    width: 100%;
  }
  .view-img li:not(:last-child) {
    margin-bottom: 23px;
  }
  img {
    border-style: none;
  }

  .bg-color-set li {
    text-align: center;
  }

  .bg-color-set li .set-to-view-icon {
    font-size: 22px;
  }

  .bg-color-set li.bg-color-pick {
    margin-bottom: 0px;
  }

  .el-color-picker__color.is-alpha {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
  }

  .el-color-picker__color.is-delete {
    background-image: url(data:image/png;base64,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) !important;
    background-size: contain;
    background-color: #fff;
  }

  .bg-color-picker- {
    position: absolute;
    right: calc(10vw - 150px);
    top: calc(6vh + 31px);
    /* width: 32px; */
    /* height: 64px; */
    background: #ffffff;
    border-radius: 5px;
    z-index: 100;
  }
  .bg-color-picker-text {
    position: absolute;
    left: 6px;
    top: 39px;
    /* width: 32px; */
    /* height: 64px; */
    background: #ffffff;
    border-radius: 5px;
    z-index: 100;
  }
  .sidebar .sidebar-cont {
    height: calc(100vh - 55px);
    overflow: hidden;
    background: #fff;
    transition: all 0.3s;
    opacity: 1;
    display: flex;
    flex-direction: column;
  }
  .sidebar .sidebar-cont .cont-top {
    overflow-y: hidden;
  }

  .sidebar .sidebar-cont .pic-layer {
    // height: 240px;
    // min-height: 208px;
    // max-height: calc(100% - 300px);
    height: calc(100vh - 82px);
    // height: 100%;
    position: relative;
    border: 1px solid #f0f5ff;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.06);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .sidebar .sidebar-cont .pic-layer > .tit {
    line-height: 32px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
  }
  .el-dropdown-link {
    cursor: pointer;
  }

  .sidebar .sidebar-cont .pic-layer > .tit .txt {
    display: inline-block;
    padding: 0 30px;
    background: #fff;
    color: #4934b2;
    font-size: 14px;
    font-weight: 600;
  }

  .sidebar .sidebar-cont .pic-layer > .tit .close {
    padding: 0 10px;
    cursor: pointer;
  }

  .sidebar .sidebar-cont .pic-layer .resize-area {
    display: inline-block;
    content: "";
    position: absolute;
    left: 50%;
    top: 4px;
    z-index: 99;
    height: 28px;
    padding: 0 10px;
    background: transparent;
    cursor: n-resize;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .product.layer .result-content {
    height: calc(100vh - 488px) !important;
  }

  .material.layer .result-content {
    height: calc(100vh - 525px) !important;
  }

  .main .left-panel .content .material ::v-deep .result .result-content {
    height: calc(100vh - 308px);
  }

  .main .left-panel .content .upload-image .result .result-content {
    height: calc(100vh - 309px);
  }

  .background-text {
    height: 100%;
    .picker-box {
      position: relative;
      .menu-bg-color-picker-text {
        position: absolute;
        left: 12px;
        top: 12px;
        right: 12px;
        height: auto;
        border-radius: 5px;
        &::v-deep .vc-compact{
          width: 100%;
          box-shadow: none;
        }
        &::v-deep .vc-chrome {
          box-shadow: none;
        }
      }
    }
  }

  .upload-text.layer .result-content {
    height: calc(100vh - 520px) !important;
  }
  .upload-image.layer .result-content {
    height: calc(100vh - 529px) !important;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #37474f;
    position: relative;
    border: none;
    cursor: pointer;
  }

  .custom-tree-node:hover {
    color: #000;
  }

  .custom-tree-node .name {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 50px;
  }

  .custom-tree-node .name.bg,
  .custom-tree-node .name.bg label {
    cursor: not-allowed;
  }

  .custom-tree-node .name .bgicon {
    font-size: 15px;
    margin: 1px 5px 0 -20px;
    color: #37474f;
  }

  .custom-tree-node .name label {
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .custom-tree-node .name .imgbox {
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
  }

  .custom-tree-node .name .imgbox img {
    max-width: 15px;
    max-height: 15px;
  }

  .custom-tree-node .operates .lock-icon {
    position: absolute;
    right: 46px;
    top: 0;
  }
  .custom-tree-node .operates .down-icon {
    position: absolute;
    right: 69px;
    top: 12px;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
  }
  .custom-tree-node .operates .up-icon {
    position: absolute;
    right: 92px;
    top: 12px;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
  }
  .custom-tree-node .operates .delete-icon {
    position: absolute;
    right: 0px;
    top: 14px;
  }

  .custom-tree-node .operates .hidden-icon {
    position: absolute;
    right: 23px;
    top: 0;
  }

  .custom-tree-node .suspen {
    visibility: hidden;
  }

  .custom-tree-node.node-view {
    font-weight: 500;
  }

  .custom-tree-node:hover .suspen {
    visibility: visible;
  }

  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    border: 1px solid transparent;
    border-radius: 5px;
    padding: 0 12px 0 12px;
    margin: 0 12px;
  }

  .el-tree-node__content:hover {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.45);
  }

  .active .el-tree-node__content {
    background-color: #f5f7fa;
  }
  .layer-box {
    padding: 8px 0 8px 0;
    overflow-y: auto;
    // height: 100%;
    height: calc(100% - 32px);
  }
  & .the-main__middle-content {
    width: 100%;
  }
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .designer-footer-left {
    padding: 6px 15px;
    border-radius: 5px;
    box-shadow: 1px 1px 12px #ccc;
    background: #fff;
    position: absolute;
    left: 19px;
  }

  .designer-footer-left p {
    color: #52c41a;
    font-size: 14px;
    line-height: 22px;
  }

  .designer-footer-left span {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    line-height: 20px;
  }

  .designer-footer-center {
    border-radius: 5px;
    position: absolute;
    left: calc(50% - 29px);
    top: 0px;
    text-align: center;
    margin: 17px 0 0 0;
  }
  .designer-footer-center p {
    font-size: 14px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.65);
  }
  .designer-footer-center span {
    font-size: 14px;
    color: #4934b2;
  }

  .designer-footer-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 17px;
    border-radius: 5px;
    box-shadow: 1px 1px 12px #ccc;
    background: #fff;
    position: absolute;
    right: 19px;
  }

  .designer-footer-right .maximize {
    margin-right: 28px;
    position: relative;
  }

  .designer-footer-right .maximize:before {
    content: "";
    position: absolute;
    top: 0;
    left: 35px;
    height: 20px;
    width: 1px;
    background: rgba(0, 0, 0, 0.15);
  }
  .designer-footer-right .iconfont {
    font-size: 20px;
    position: relative;
    cursor: pointer;
  }
  .designer-footer-right .slider {
    width: 60px;
    margin: 0 12px;
  }
  .tool-component {
    position: absolute;
    bottom: 100px;
    width: 100%;
    height: 0;
    justify-content: center;
    display: flex;
    .tool {
      text-align: center;
      &:not(:last-child) {
        margin-right: 30px;
      }
      .tool-button {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        border: 1px solid #ccc;
        margin-bottom: 8px;
        cursor: pointer;
        &.disabled {
          color: #ccc;
          border: 1px solid #ccc;
          cursor: not-allowed;
        }
        &:not(.disabled):hover {
          color: #4934b2;
          border-color: #4934b2;
        }
      }
      .tool-text {
        color: #666;
      }
    }
  }
  .save-btn-content .save-btn {
    background-color: #4934b2 !important;
    color: #ffffff;
    // margin: 0px 16px 0 0;
    margin: 0px 12px 0 0;
    &:hover {
      opacity: 0.8;
    }
  }
  .row-process {
    display: flex;
    justify-content: space-between;
    line-height: 32px;
    border-bottom: 1px solid #f0f5ff;
    padding: 10px 8px;
    .process-list {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
    .process-item.active {
      border: 2px solid #4934b2 !important;
      color: #4934b2;
    }
    .process-item {
      display: inline-block;
      padding: 0 10px;
      height: 32px;
      line-height: 29px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .pr36 {
    padding-right: 36px !important;
  }
  .zw-disabled-copy {
    pointer-events: inherit;
  }
  .zw-disabled-copy,
  .zw-disabled-copy:active,
  .zw-disabled-copy:hover {
    opacity: 1;
    color: rgb(201, 205, 212) !important;
    cursor: not-allowed;
  }
  .zw-disabled {
    pointer-events: none;
  }
  .zw-disabled,
  .zw-disabled:active,
  .zw-disabled:hover {
    // opacity: 0.2;
    opacity: 1;
    color: rgb(201, 205, 212) !important;
    cursor: not-allowed;
  }
  .tab-disabled {
    pointer-events: none;
  }
  .tab-disabled,
  .tab-disabled:active,
  .tab-disabled:hover {
    opacity: 0.2;
    cursor: not-allowed;
  }
}

.toolbar-item.active .icon,
.toolbar-item.active .toolbar-item-text {
  color: #4934b2;
}

.save-record-cont {
  width: 100%;
  height: auto;
}

.save-record-cont .title-cont {
  padding: 15px 15px 9px 15px;
}

.save-record-cont .title-cont .title-text {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}

.save-record-cont .title-cont .title-icon {
  color: #4934b2;
  margin-right: 6px;
}

.save-record-cont .content {
  padding: 19px 20px 0px 20px;
}

.save-record-cont .content .data-cont {
  flex-wrap: wrap;
}

.save-record-cont .content .data-cont .product-item {
  position: relative;
  cursor: pointer;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.06);
  margin-right: 10px;
  margin-bottom: 10px;
}

.save-record-cont .content .data-cont .product-item:nth-child(4n) {
  margin-right: 0;
}

.save-record-cont .content .data-cont .product-item:before {
  content: "";
  background: radial-gradient(
    closest-side at 0 100%,
    transparent 0,
    rgba(0, 0, 0, 0.04) 100%
  );
  width: 100%;
  height: 100%;
  position: absolute;
  display: inline-block;
  z-index: 0;
  top: 0;
  bottom: 0;
}

.save-record-cont .content .data-cont .product-item img {
  width: 100%;
  height: 100%;
}

.save-record-cont .content .data-cont .product-item .product-id {
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  height: 20px;
  z-index: 99;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
}

.save-record-cont .content .data-cont .product-item:hover .product-id {
  display: block;
}

.save-record-cont .content .data-cont .part-item {
  position: relative;
  cursor: pointer;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.06);
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid transparent;
}
.save-record-cont .content .data-cont .active {
  border: 1px solid #4934b2;
}

.save-record-cont .content .data-cont .part-item:nth-child(4n) {
  margin-right: 0;
}

.save-record-cont .content .data-cont .part-item:before {
  content: "";
  background: radial-gradient(
    closest-side at 0 100%,
    transparent 0,
    rgba(0, 0, 0, 0.04) 100%
  );
  width: 100%;
  height: 100%;
  position: absolute;
  display: inline-block;
  z-index: 0;
  top: 0;
  bottom: 0;
}

.save-record-cont .content .data-cont .part-item img {
  width: 100%;
  height: 100%;
}

.save-record-cont .content .data-cont .part-item .product-id {
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  height: 20px;
  z-index: 99;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
}

.save-record-cont .content .data-cont .part-item:hover .product-id {
  display: block;
}
.flex {
  display: flex;
}

.zw-slide-pop {
  padding: 14px 10px;
}

.zw-slide-pop .zw-slide-pop-main .slide {
  width: 100%;
  display: flex;
  align-items: center;
}

.zw-slide-pop .zw-slide-pop-main .slide .zw-silder {
  padding: 0 10px;
  flex: 1;
}

.zw-slide-pop .zw-slide-pop-main .slide-value {
  width: 48px;
  text-align: right;
}

.zw-slide-pop .zw-slide-pop-main .slide-value.el-input .el-input__inner {
  height: 24px;
  line-height: 24px;
}

.rul_cornerTL,
.rul_cornerTR {
  border-bottom: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBL,
.rul_cornerTL {
  border-right: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBL,
.rul_cornerBR {
  bottom: 1px;
  border-top: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBR,
.rul_cornerTR {
  right: 1px;
  border-left: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  top: 0px;
}
.rul_corner,
.rul_line,
.rul_ruler {
  pointer-events: all;
  position: absolute;
}
.rul_wrapper * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.rul_ruler {
  display: block;
  border: 1px solid rgba(206, 219, 236, 0.5);
  filter: blur(0);
  -webkit-filter: blur(0);
  z-index: 1000;
}
.rul_corner {
  background-color: #fff;
  z-index: 1010;
  cursor: pointer;
}
.rul_corner:hover {
  background-color: #d3d3d3;
}
.rul_cornerTL {
  top: 0;
  left: 0;
}
.rul_cornerTR {
  top: 1px;
}
.rul_cornerBL {
  left: 1px;
}
.rul_ruler_Vertical {
  cursor: ew-resize;
  border-left: none;
}
.rul_ruler_Horizontal {
  cursor: ns-resize;
  border-top: none;
}
.rul_line {
  color: transparent;
  background-color: transparent;
  border-bottom: 1px solid #4934b2;
  border-left: 1px solid #4934b2;
  z-index: 1000;
}
.rul_line_dragged {
  border: 1px dotted #6b7587;
}
.rul_line:hover {
  border-bottom: 1px solid #236e77;
  border-left: 1px solid #236e77;
}
.rul_lineVer {
  top: 0;
  bottom: 0;
}
.rul_lineVer:hover {
  cursor: ew-resize;
}
.rul_lineHor {
  right: 0;
  left: 0;
}
.rul_lineHor:hover {
  cursor: ns-resize;
}
.rul_tooltip:after {
  background: #fff;
  color: #000;
  border: 1px solid gray;
  font-size: 10px;
  content: attr(data-tip);
  top: 50%;
  left: 50%;
  margin-top: 1px;
  margin-left: 1px;
  padding: 2px 5px;
  position: absolute;
  z-index: 10001;
  min-width: 45px;
}
.rul_tracker {
  height: 1px;
  width: 1px;
  background: #000;
  position: absolute;
  pointer-events: none;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "agra"; //自定义文字名
  src: url("../../../assets/fonts/agra.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "aguzlo"; //自定义文字名
  src: url("../../../assets/fonts/aguzlo.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "brush_script_std"; //自定义文字名
  src: url("../../../assets/fonts/brush_script_std.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "butter"; //自定义文字名
  src: url("../../../assets/fonts/butter.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "chiller"; //自定义文字名
  src: url("../../../assets/fonts/chiller.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "clarendon_condensed_bold"; //自定义文字名
  src: url("../../../assets/fonts/clarendon_condensed_bold.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "comeback"; //自定义文字名
  src: url("../../../assets/fonts/comeback.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "digital"; //自定义文字名
  src: url("../../../assets/fonts/digital.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "distorti"; //自定义文字名
  src: url("../../../assets/fonts/distorti.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "eccentric_std"; //自定义文字名
  src: url("../../../assets/fonts/eccentric_std.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "forte"; //自定义文字名
  src: url("../../../assets/fonts/forte.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "friday_night"; //自定义文字名
  src: url("../../../assets/fonts/friday_night.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "happy"; //自定义文字名
  src: url("../../../assets/fonts/happy.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "seaside"; //自定义文字名
  src: url("../../../assets/fonts/seaside.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "spaghettica"; //自定义文字名
  src: url("../../../assets/fonts/spaghettica.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "varsity"; //自定义文字名
  src: url("../../../assets/fonts/varsity.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "verminmagic"; //自定义文字名
  src: url("../../../assets/fonts/verminmagic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}
.operate-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.operate-bar .operate-item {
  background: #f0f2f5;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 12px;
}

.operate-bar .operate-item.iconfont {
  font-size: 22px;
}

.operate-bar .operate-item:hover {
  background-color: #ebecf8;
  color: #3d47bf;
}

.operate-bar .operate-item.active {
  background: #3d47bf;
  color: #fff;
}

.operate-bar .operate-item.mini {
  width: 64px;
}

.operate-bar .operate-item.medium {
  width: 136px;
}

.background-color-content {
  position: relative;
  max-width: 209px;
  padding: 0.64em 0 0 0.64em;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  flex-wrap: wrap;
  align-content: flex-start;
  display: flex;
}

.background-color-content .background-color-item {
  width: 24px;
  height: 24px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 0.64em 0.64em 0;
  list-style: none;
  box-sizing: border-box;
}
#pic-zoom img {
  width: 100% !important;
}
.product-detail-box .el-carousel__indicators {
  z-index: 1001;
}
.mouse-cover-canvas {
  right: 330px !important;
  left: inherit !important;
  top: 57px !important;
}
.magnifier-box .mouse-cover {
  cursor: zoom-in !important;
}
.shortcut-box {
  max-height: calc(90vh - 220px);
  overflow: auto;
  color: #37474f;
  position: relative;
}

.panel-box {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.panel-tit {
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #f0f5ff;
  padding: 0 15px;
  font-weight: 700;
  color: #37474f;
}

.panel-tit.gray {
  background: rgba(0, 0, 0, 0.02);
}

.panel-cont {
  width: 100%;
  column-count: 2;
  column-gap: 20px;
  -moz-column-rule: 1px solid rgba(0, 0, 0, 0.06);
  column-rule: 1px solid rgba(0, 0, 0, 0.06);
  -webkit-column-count: 2;
  -webkit-column-gap: 20px;
  -moz-column-count: 2;
  -moz-column-gap: 20px;
}

.panel-cont .panel-item {
  -moz-column-break-inside: avoid;
  break-inside: avoid;
  width: 100%;
  font-size: 13px;
  cursor: pointer;
}

.panel-cont .panel-item.disabled {
  color: #aaa;
}

.panel-cont .panel-item.warning {
  color: #ff4500;
}

.panel-cont .panel-item > div {
  height: 32px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-cont .panel-item > div:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #0453f3;
}

.panel-cont .panel-item .keycode {
  font-family: sans-serif;
}

.panel-cont .panel-item .keycode span.key {
  display: inline-block;
  padding: 5px 4px;
  background: #f0f5ff;
  border-radius: 3px;
}

.panel-cont .panel-item .keycode span.combine {
  padding: 0 3px;
}

.panel-cont .panel-item .input-box {
  display: inline-block;
  position: relative;
}

.panel-cont .panel-item .input-box input {
  width: 140px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border: 1px solid #efefef;
  border-radius: 5px;
  outline: 0;
  padding-right: 16px;
  text-align: center;
  caret-color: transparent;
}

.panel-cont .panel-item .input-box input:focus {
  border-color: #0453f3;
  color: #0453f3;
}

.panel-cont .panel-item .input-box input:focus::-webkit-input-placeholder {
  color: #0453f3;
}

.panel-cont .panel-item .input-box i {
  display: inline-block;
  line-height: 24px;
  padding: 0 2px;
  position: absolute;
  right: 0;
  top: 0;
  color: rgba(0, 0, 0, 0.15);
}

.panel-cont .panel-item input:focus + i {
  color: #0453f3;
}

.panel-box.sublevel {
  padding-bottom: 0;
}

.panel-box.sublevel .panel-tit {
  background: rgba(0, 0, 0, 0.02);
  margin-top: 10px;
}

.panel-box.sublevel .panel-cont {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 10px;
}
.el-carousel__arrow--left,
.el-carousel__arrow--right {
  z-index: 200;
}
.no_save {
  cursor: not-allowed;
  opacity: 0.5;
  &:hover {
    cursor: not-allowed;
    opacity: 0.5!important;
  }
}
// 坐标
.pos_form {
  .el-radio {
    margin-bottom: 12px;
  }
}

.toolbar-item-operate {
  font-size: 13px!important;
  // font-weight: 600!important;
  .icon {
    margin-right: 4px;
  }
}
.select-icon {
  color: #4934b2!important;
}
// 弹出框 - 更多操作
.header-operate-popover {
  // 公共样式
  .flex-col-ct {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
  }
  .flex,
  .flex-col {
    display: flex;
  }
  .flex-row-between {
    justify-content: space-between;
  }
  // 功能样式
  .toolbar-item {
    padding: 12px;
    padding-left: 16px;
    font-size: 13px;
    color: #1d2129;
    line-height: 22px;
    border-radius: 8px;
    .toolbar-item-text {
      margin-left: 3px;
    }
    .shortcut-cont {
      font-size: 10px;
      padding: 2px 6px;
      background: #f2f3f5;
      border-radius: 4px;
      color: #a9aeb8;
    }
    &:hover {
      background: #f7f8fa;
    }
    &.active {
      color: #4934b2;
    }
  }
}

.zwdesign-header--right {
  .product-detail {
    padding: 4px 12px 4px 8px;
    border-radius: 8px;
    border: 1px solid #c9cdd4;
    margin-left: 12px;
    .product-img {
      width: 2.5rem;
      height: 2.5rem;
      overflow: hidden;
      border-radius: 0.3125rem;
      background: rgba(0, 0, 0, .04);
      flex-shrink: 0;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
      }
      &:before {
        content: "";
        background: radial-gradient(closest-side at 0 100%, transparent 0, rgba(0, 0, 0, .04) 100%);
        width: 100%;
        height: 100%;
        position: absolute;
        display: inline-block;
        top: 0;
        bottom: 0;
      }
    }
    .product-name {
      max-width: 110px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 500;
      font-size: 16px;
      color: #4e5969;
      line-height: 28px;
    }
    @media (max-width: 1450px) {
    .product-name[data-v-b7bed156] {
        max-width: 50px !important;
    }
    }
    .color-size {
      padding: 4px;
      background: #e6f2ff;
      border-radius: 6px;
      font-size: 12px;
    }
    .color-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      margin-right: 6px;
      background: #f0f2f5;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      a {
        border: 1px solid rgba(0, 0, 0, .15);
        width: 20px;
        height: 20px;
        border-radius: 4px;
      }
    }
    .color-item-desc {
      display: inline-block;
      max-width: 80px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .select-product-icon {
      height: 20px;
      margin-top: -8px;
      &:hover {
        color: #4934b2;
      }
    }
    .f20, .f24 {
      font-weight: 400;
    }
  }
}
.header-zwdesign-color-popover {
  .flex-col-ct {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
  }
  .flex,
  .flex-col {
    display: flex;
  }
  .flex-row-between {
    justify-content: space-between;
  }
  .sku-attr {
    overflow: hidden;
    padding: 0 0 0 8px;
    .sku-name {
      margin: 0 32px 0 0;
    }
    .sku-detail {
      margin: 5px 0 0 0;
    }
  }
  .sku-color {
    margin: 0 8px 0 0;
    border: 1px solid #aaaaaa;
    cursor: pointer;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    transition: all 0.5s ease-in-out;
    border: 3px solid transparent;
    box-shadow: 0 0 0 1px #ddd;
  }
  .sku-size {
    color: #333;
    font-size: 12px;
    font-weight: 400;
    line-height: 30px;
    text-transform: capitalize;
    display: inline-block;
    margin: 0;
    min-width: 30px;
    overflow: hidden;
    text-align: center;
    background-color: #f9f9f9;
    border-radius: 7px;
    transition: all 0.5s ease-in-out;
    padding: 0 6px;
    margin: 0 8px 5px 0;
    border: 3px solid transparent;
    box-shadow: 0 0 0 1px #ddd;
    cursor: pointer;
    box-sizing: border-box;
  }

  .is-select {
    border: 3px solid #f25551;
    box-shadow: none;
  }
}
.header-zwdesign-product-popover {
  .flex,
  .flex-col {
    display: flex;
  }
  .product-name-container {
    padding: 10px;
    .product-name-box {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: #1d2129;
    }
    .product-pId-box {
      color: #86909c;
      font-size: 12px;
      line-height: 22px;
      white-space: nowrap;
      display: flex;
    }
    .product-price-box {
      vertical-align: baseline;
      font-weight: 500;
      font-size: 1rem;
      color: #fa8c16;
      line-height: 1.75rem;
    }
  }
}
.save-record-cont-popper {
  .flex-col-ct {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
  }
  .flex,
  .flex-col {
    display: flex;
  }
  .flex-row-between {
    justify-content: space-between;
  }
  .save-record-title-cont {
    font-size: 14px;
    padding: 8px 0 14px;
    border-bottom: 1px solid #efefef;
    .save-record-title-cont-left {
      font-weight: 600;
      .el-icon-goods {
        font-size: 16px;
      }
      span {
        margin-left: 4px;
      }
    }
    .design-pro {
      cursor: pointer;
      color: #4934b2;
      margin: 0 0.125rem;
    }
  }
}

.pl_title {
  padding: 0 15px;
  font-size: 13px;
  // color: #808080;
  color: #313131;
  font-weight: bold;
}
.el-collapse-item:last-child {
  border: none!important;
}
::v-deep .el-collapse-item__header .el-collapse-item__arrow {
  margin: 0;
}

.edit-cont {
  overflow-y: auto!important;
  height: 100%;
  ::v-deep .el-collapse-item__content {
    padding-bottom: 4px;
  }
  .el-collapse {
    border-top: 0;
  }
  .edit_cont_replace_image {
    background: #f0f2f5;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 8px 0 18px;
  }
  .el-collapse-item {
    position: relative;
    .tileway-pop {
      width: 96%;
      position: absolute;
      top: -60px;
      left: 2%;
      z-index: 1002;
      background: #fff;
      box-shadow: 0 9px 28px 8px rgba(0, 0, 0, 0.05),
        0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
      border-radius: 5px;
    }
  }
  .edit-cont-item {
    flex-wrap: wrap;
    .edit-cont-item-entrance {
      cursor: pointer;
      position: relative;
      text-align: center;
      width: 72px;
      margin-right: 12px;
      margin-bottom: 16px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .edit-cont-item-entrance-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 70px;
        color: #4e5969;
        background: #f7f8fa;
        border-radius: 20px;
        font-size: 20px;
        &:hover {
          background-color: #e5e6eb;
          color: #4e5969;
        }
      }
      .entrance_focus {
        color: #4934b2!important;
      }
      .edit-cont-item-entrance-text {
        margin-top: 8px;
        line-height: 18px;
        font-size: 12px;
        color: #4e5969;
      }
    }
  }
  .edit-text-item-entrance {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    color: #4e5969;
    background: #f7f8fa;
    border-radius: 6px;
    font-size: 14px;
    margin-bottom: 16px;
    cursor: pointer;
    &:hover {
      background-color: #e5e6eb;
      color: #4e5969;
    }
  }
}
// 效果图
.design-effect {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 12px;
  padding-top: 0;
  user-select: none;
  .big-img-cont {
    width: 300px;
    height: 300px;
    position: relative;
    border-radius: 22px;
    border: 1px solid #e5e6eb;
    overflow: hidden;
    background: rgba(0, 0, 0, .04);
    .type-btn-group {
      position: absolute;
      right: 12px;
      z-index: 101;
      .btn-item {
        display: inline-block;
        width: 36px;
        height: 20px;
        margin-top: 12px;
        line-height: 20px;
        border-radius: 12px;
        text-align: center;
        font-size: 10px;
        color: #1d2129;
        background: #f0f2f5;
        cursor: pointer;
        &.active {
          background: #4934b2;
          color: #fff;
        }
      }
      .btn-3d {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .btn-2d {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    .preview-btn {
      width: 66px;
      height: 32px;
      background: rgba(0, 0, 0, .6);
      border-radius: 10px 0 20px 0;
      opacity: 0.4;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 101;
      cursor: pointer;
      .iconzoom-in {
        font-size: 12px;
      }
    }
    .map-preview-img {
      display: none;
      cursor: zoom-in;
      position: absolute;
      &.active {
        display: block!important;
      }
    }
  }
  .small-img-list-cont {
    flex: 1;
    overflow-y: auto;
    margin-top: 12px;
    .small-img-item {
      position: relative;
      width: 66px;
      height: 66px;
      overflow: hidden;
      margin-right: 10px;
      margin-bottom: 12px;
      border-radius: 10px;
      &.active {
        border: 2px solid #4934b2;
        .tips-mask {
          display: block;
          background: #4934b2;
        }
      }
      .tips-mask {
        display: none;
        background: rgba(0, 0, 0, 0.4);;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        color: #fff;
        // padding: 2px 0;
        padding-top: 2px;
        font-size: 10px;
        z-index: 10;
      }
      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.45);
        .tips-mask {
          display: block;
        }
      }
    }
  }
}
.designer-iframe ::v-deep .xgt_tc {
  top: 7%;
}

.nav_focus {
  color: #4934b2!important;
}

.save_color_form {
  .save_title {
    font-size: 16px;
    margin-bottom: 12px;
    font-weight: bold;
    span {
      color: #F56C6C;
    }
  }
  .pic_box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 10px;
    .per_pic {
      width: 120px;
      height: 120px;
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      cursor: pointer;
      border: 1px solid #dddddd;
      vertical-align: middle;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .properVal {
          position: absolute;
          width: 100%;
          top: 120px;
          left: 0;
          text-align: center;
          padding: 10px 0;
          color: #000000;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
      }
    }
    &::v-deep .el-checkbox__input {
      position: absolute;
      top: 0;
      left: 0;
    }
    &::v-deep .el-checkbox__label {
      padding-left: 0;
    }
  }
}
</style>
